import {
  toString1pkumu07cwy4m as toString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Unit_instanceat14thlj150z as Unit_instance,
  addAll1k27qatfgp3k5 as addAll,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  firstOrNulltrxqttxfxqju as firstOrNull,
  Char19o2r8palgjof as Char,
  toString30pk9tzaqopn as toString_0,
  startsWith26w8qjqapeeq6 as startsWith,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  startsWith1bgirhbedtv2y as startsWith_0,
  to2cs3ny02qtbcb as to,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split,
  first58ocm7j58k3q as first,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toInt2q8uldh7sc951 as toInt,
  last1vo29oleiqj36 as last,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  emptyList1g2z5xcrvp2zy as emptyList,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtList3hktaavzmj137 as KtList,
  plus39kp8wyage607 as plus,
  lines3g90sq0zeq43v as lines,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  contains2el4s70rdq4ld as contains,
  toBoolean2azvnq2ukl7b3 as toBoolean,
  split2bvyvnrlcifjv as split_0,
  createThis2j2avj17cvnv2 as createThis,
  listOfvhqybd2zx248 as listOf,
  Enum3alwj03lh1n41 as Enum,
  toList3jhuyej2anx2q as toList,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt_0,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains_0,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  roundToInt1ue8x8yshtznx as roundToInt,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToDouble210hrknaofnhf as numberToDouble,
  HashMap1a0ld5kgwhmhv as HashMap,
  firstOrNullf6vlo6vdgu1e as firstOrNull_0,
  first28gmhyvs4kf06 as first_0,
  toMap1vec9topfei08 as toMap,
  listOf1jh22dvmctj1r as listOf_0,
  plus310ted5e4i90h as plus_0,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toDouble1kn912gjoizjp as toDouble,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  println2shhhgwwt4c61 as println,
  until1jbpn0z3f8lbg as until,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  firstOrNull1982767dljvdy as firstOrNull_1,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  toLongw1zpgk99d84b as toLong,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_1,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  lastOrNull1aq5oz189qoe1 as lastOrNull_0,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  lastOrNulllcnpzslswkag as lastOrNull_1,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart5ewg8zf6cs5u as trimStart,
  trimEnd17pt8cbotbalj as trimEnd,
  Regexxgw0gjiagf4z as Regex,
  drop3na99dw9feawf as drop,
  plus20p0vtfmu0596 as plus_2,
  removeLast3759euu1xvfa3 as removeLast,
  dropLast1vpiyky649o34 as dropLast,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_0,
  MarginInt3jiec8xsxkfd as MarginInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_0,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_1,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_2,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_3,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstance2yu48324co92b as Companion_getInstance_4,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_5,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
  _Dyn___get_bool__impl__nv3iundhwx8dew4jjx as _Dyn___get_bool__impl__nv3iun,
  get_dynw5edstkdie96 as get_dyn,
  Dyng396lmez04lc as Dyn,
  _Dyn___get_value__impl__bemnlg3oh7xeq0kw7zy as _Dyn___get_value__impl__bemnlg,
  _Dyn___get_list__impl__qpwjp3hmourv3nh1iz as _Dyn___get_list__impl__qpwjp,
  _Dyn___get_orNull__impl__ox3tzj1ezncdn1zar97 as _Dyn___get_orNull__impl__ox3tzj,
  _Dyn___get_str__impl__dup4cs1orog9cldb3vj as _Dyn___get_str__impl__dup4cs,
  _Dyn___get_double__impl__jlvfa03e43e9hgklusp as _Dyn___get_double__impl__jlvfa0,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_6,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  SliceOrientation__toString_impl_tdph6r33jpxjr7sikgk as SliceOrientation__toString_impl_tdph6r,
  SliceOrientation__hashCode_impl_7mjkdw1dyjp3l12qj22 as SliceOrientation__hashCode_impl_7mjkdw,
  Companion_instanceeeaudfwfrq87 as Companion_instance_1,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_3,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default4sjbw0e0mkug as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_7,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_8,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_9,
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  ListReader37jxep6q6wbzq as ListReader,
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_2,
  Companion_instance3ldriv9x4zcjm as Companion_instance_3,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  toDeque2gx2crptp8sro as toDeque,
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_12,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  splitInChunks2h1zfocl4rvqy as splitInChunks,
  splitKeep2hxk3xif9u3vx as splitKeep,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_14,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_4,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class Entry {
  constructor($outer, info, page) {
    this.f3w_1 = $outer;
    this.b3w_1 = info;
    this.c3w_1 = page;
    var tmp = this;
    var tmp0_elvis_lhs = this.f3w_1.g3w_1.f3(this.c3w_1.k3w_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't find '" + this.c3w_1.k3w_1 + "' in " + toString(this.f3w_1.g3w_1.g3());
      throw IllegalStateException.z4(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.d3w_1 = tmp_0;
    this.e3w_1 = this.d3w_1.h3h(this.b3w_1.t3w_1, this.b3w_1.s3w_1, VOID, this.b3w_1.v3w_1).k3h(this.b3w_1.u3w_1);
  }
  y3w() {
    return this.b3w_1.s3w_1;
  }
}
class AtlasLookup {}
function tryGet(name) {
  var tmp0_safe_receiver = this.e3x(name);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e3w_1;
}
function get_0(name) {
  var tmp0_elvis_lhs = this.f3x(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = "Can't find '" + name + "' it atlas";
    throw IllegalStateException.z4(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
class Atlas {
  constructor(textures, info) {
    info = info === VOID ? AtlasInfo.d3x() : info;
    this.g3w_1 = textures;
    this.h3w_1 = info;
    var tmp = this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.h3w_1.a3x_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = element.r3w_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Entry(this, item, element);
        destination_0.h(tmp$ret$0);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    tmp.i3w_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = this.i3w_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap.hc(capacity);
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var element_0 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.atlas.Atlas.entriesMap.<anonymous>' call
      var tmp$ret$6 = element_0.y3w();
      destination_1.i3(tmp$ret$6, element_0);
    }
    tmp_0.j3w_1 = destination_1;
  }
  e3x(name) {
    return this.j3w_1.f3(name);
  }
}
class Companion {
  constructor() {
    this.m3x_1 = '1.0.0';
  }
}
class Meta {
  constructor(app, format, image, scale, size, version, frameTags, layers, slices) {
    app = app === VOID ? 'app' : app;
    format = format === VOID ? 'format' : format;
    image = image === VOID ? 'image' : image;
    scale = scale === VOID ? 1.0 : scale;
    size = size === VOID ? SizeInt.x2g(1, 1) : size;
    version = version === VOID ? Companion_instance_5.m3x_1 : version;
    var tmp;
    if (frameTags === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = frameTags;
    }
    frameTags = tmp;
    var tmp_0;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = layers;
    }
    layers = tmp_0;
    var tmp_1;
    if (slices === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = slices;
    }
    slices = tmp_1;
    this.n3x_1 = app;
    this.o3x_1 = format;
    this.p3x_1 = image;
    this.q3x_1 = scale;
    this.r3x_1 = size;
    this.s3x_1 = version;
    this.t3x_1 = frameTags;
    this.u3x_1 = layers;
    this.v3x_1 = slices;
  }
  toString() {
    return 'Meta(app=' + this.n3x_1 + ', format=' + this.o3x_1 + ', image=' + this.p3x_1 + ', scale=' + this.q3x_1 + ', size=' + this.r3x_1.toString() + ', version=' + this.s3x_1 + ', frameTags=' + toString(this.t3x_1) + ', layers=' + toString(this.u3x_1) + ', slices=' + toString(this.v3x_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n3x_1);
    result = imul(result, 31) + getStringHashCode(this.o3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q3x_1) | 0;
    result = imul(result, 31) + this.r3x_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.s3x_1) | 0;
    result = imul(result, 31) + hashCode(this.t3x_1) | 0;
    result = imul(result, 31) + hashCode(this.u3x_1) | 0;
    result = imul(result, 31) + hashCode(this.v3x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Meta))
      return false;
    var tmp0_other_with_cast = other instanceof Meta ? other : THROW_CCE();
    if (!(this.n3x_1 === tmp0_other_with_cast.n3x_1))
      return false;
    if (!(this.o3x_1 === tmp0_other_with_cast.o3x_1))
      return false;
    if (!(this.p3x_1 === tmp0_other_with_cast.p3x_1))
      return false;
    if (!equals(this.q3x_1, tmp0_other_with_cast.q3x_1))
      return false;
    if (!this.r3x_1.equals(tmp0_other_with_cast.r3x_1))
      return false;
    if (!(this.s3x_1 === tmp0_other_with_cast.s3x_1))
      return false;
    if (!equals(this.t3x_1, tmp0_other_with_cast.t3x_1))
      return false;
    if (!equals(this.u3x_1, tmp0_other_with_cast.u3x_1))
      return false;
    if (!equals(this.v3x_1, tmp0_other_with_cast.v3x_1))
      return false;
    return true;
  }
}
class FrameTag {
  constructor(name, from, to, direction) {
    name = name === VOID ? '' : name;
    from = from === VOID ? 0 : from;
    to = to === VOID ? 0 : to;
    direction = direction === VOID ? '' : direction;
    this.w3x_1 = name;
    this.x3x_1 = from;
    this.y3x_1 = to;
    this.z3x_1 = direction;
  }
  toString() {
    return 'FrameTag(name=' + this.w3x_1 + ', from=' + this.x3x_1 + ', to=' + this.y3x_1 + ', direction=' + this.z3x_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.w3x_1);
    result = imul(result, 31) + this.x3x_1 | 0;
    result = imul(result, 31) + this.y3x_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.z3x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FrameTag))
      return false;
    var tmp0_other_with_cast = other instanceof FrameTag ? other : THROW_CCE();
    if (!(this.w3x_1 === tmp0_other_with_cast.w3x_1))
      return false;
    if (!(this.x3x_1 === tmp0_other_with_cast.x3x_1))
      return false;
    if (!(this.y3x_1 === tmp0_other_with_cast.y3x_1))
      return false;
    if (!(this.z3x_1 === tmp0_other_with_cast.z3x_1))
      return false;
    return true;
  }
}
class Layer {
  constructor(name, opacity, blendMode) {
    name = name === VOID ? '' : name;
    opacity = opacity === VOID ? 255 : opacity;
    blendMode = blendMode === VOID ? '' : blendMode;
    this.a3y_1 = name;
    this.b3y_1 = opacity;
    this.c3y_1 = blendMode;
  }
  toString() {
    return 'Layer(name=' + this.a3y_1 + ', opacity=' + this.b3y_1 + ', blendMode=' + this.c3y_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a3y_1);
    result = imul(result, 31) + this.b3y_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.c3y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Layer))
      return false;
    var tmp0_other_with_cast = other instanceof Layer ? other : THROW_CCE();
    if (!(this.a3y_1 === tmp0_other_with_cast.a3y_1))
      return false;
    if (!(this.b3y_1 === tmp0_other_with_cast.b3y_1))
      return false;
    if (!(this.c3y_1 === tmp0_other_with_cast.c3y_1))
      return false;
    return true;
  }
}
class Slice {
  constructor(name, color, keys) {
    name = name === VOID ? 'slice' : name;
    color = color === VOID ? '#0000ffff' : color;
    this.d3y_1 = name;
    this.e3y_1 = color;
    this.f3y_1 = keys;
  }
  toString() {
    return 'Slice(name=' + this.d3y_1 + ', color=' + this.e3y_1 + ', keys=' + toString(this.f3y_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.d3y_1);
    result = imul(result, 31) + getStringHashCode(this.e3y_1) | 0;
    result = imul(result, 31) + hashCode(this.f3y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Slice))
      return false;
    var tmp0_other_with_cast = other instanceof Slice ? other : THROW_CCE();
    if (!(this.d3y_1 === tmp0_other_with_cast.d3y_1))
      return false;
    if (!(this.e3y_1 === tmp0_other_with_cast.e3y_1))
      return false;
    if (!equals(this.f3y_1, tmp0_other_with_cast.f3y_1))
      return false;
    return true;
  }
}
class Key {
  constructor(frame, bounds) {
    frame = frame === VOID ? 0 : frame;
    this.g3y_1 = frame;
    this.h3y_1 = bounds;
  }
  toString() {
    return 'Key(frame=' + this.g3y_1 + ', bounds=' + this.h3y_1.toString() + ')';
  }
  hashCode() {
    var result = this.g3y_1;
    result = imul(result, 31) + this.h3y_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Key))
      return false;
    var tmp0_other_with_cast = other instanceof Key ? other : THROW_CCE();
    if (!(this.g3y_1 === tmp0_other_with_cast.g3y_1))
      return false;
    if (!this.h3y_1.equals(tmp0_other_with_cast.h3y_1))
      return false;
    return true;
  }
}
class Page {
  constructor(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    this.k3w_1 = fileName;
    this.l3w_1 = size;
    this.m3w_1 = format;
    this.n3w_1 = filterMin;
    this.o3w_1 = filterMag;
    this.p3w_1 = repeatX;
    this.q3w_1 = repeatY;
    this.r3w_1 = regions;
  }
  i3y(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    return new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions);
  }
  j3y(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions, $super) {
    fileName = fileName === VOID ? this.k3w_1 : fileName;
    size = size === VOID ? this.l3w_1 : size;
    format = format === VOID ? this.m3w_1 : format;
    filterMin = filterMin === VOID ? this.n3w_1 : filterMin;
    filterMag = filterMag === VOID ? this.o3w_1 : filterMag;
    repeatX = repeatX === VOID ? this.p3w_1 : repeatX;
    repeatY = repeatY === VOID ? this.q3w_1 : repeatY;
    regions = regions === VOID ? this.r3w_1 : regions;
    return $super === VOID ? this.i3y(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) : $super.i3y.call(this, fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions);
  }
  toString() {
    return 'Page(fileName=' + this.k3w_1 + ', size=' + this.l3w_1.toString() + ', format=' + this.m3w_1 + ', filterMin=' + this.n3w_1 + ', filterMag=' + this.o3w_1 + ', repeatX=' + this.p3w_1 + ', repeatY=' + this.q3w_1 + ', regions=' + toString(this.r3w_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.k3w_1);
    result = imul(result, 31) + this.l3w_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.m3w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n3w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o3w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p3w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q3w_1) | 0;
    result = imul(result, 31) + hashCode(this.r3w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Page))
      return false;
    var tmp0_other_with_cast = other instanceof Page ? other : THROW_CCE();
    if (!(this.k3w_1 === tmp0_other_with_cast.k3w_1))
      return false;
    if (!this.l3w_1.equals(tmp0_other_with_cast.l3w_1))
      return false;
    if (!(this.m3w_1 === tmp0_other_with_cast.m3w_1))
      return false;
    if (!(this.n3w_1 === tmp0_other_with_cast.n3w_1))
      return false;
    if (!(this.o3w_1 === tmp0_other_with_cast.o3w_1))
      return false;
    if (!(this.p3w_1 === tmp0_other_with_cast.p3w_1))
      return false;
    if (!(this.q3w_1 === tmp0_other_with_cast.q3w_1))
      return false;
    if (!equals(this.r3w_1, tmp0_other_with_cast.r3w_1))
      return false;
    return true;
  }
}
class Region {
  constructor(name, frame, virtFrame, imageOrientation) {
    virtFrame = virtFrame === VOID ? null : virtFrame;
    var tmp;
    if (imageOrientation === VOID) {
      // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
      tmp = Companion_getInstance_6().e3f_1;
    } else {
      tmp = imageOrientation;
    }
    imageOrientation = tmp;
    this.s3w_1 = name;
    this.t3w_1 = frame;
    this.u3w_1 = virtFrame;
    this.v3w_1 = imageOrientation;
    this.w3w_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.v3w_1) ? this.t3w_1.g2f_1 : this.t3w_1.f2f_1;
    this.x3w_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.v3w_1) ? this.t3w_1.f2f_1 : this.t3w_1.g2f_1;
  }
  toString() {
    return 'Region(name=' + this.s3w_1 + ', frame=' + this.t3w_1.toString() + ', virtFrame=' + toString_0(this.u3w_1) + ', imageOrientation=' + SliceOrientation__toString_impl_tdph6r(this.v3w_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s3w_1);
    result = imul(result, 31) + this.t3w_1.hashCode() | 0;
    result = imul(result, 31) + (this.u3w_1 == null ? 0 : this.u3w_1.hashCode()) | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.v3w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Region))
      return false;
    var tmp0_other_with_cast = other instanceof Region ? other : THROW_CCE();
    if (!(this.s3w_1 === tmp0_other_with_cast.s3w_1))
      return false;
    if (!this.t3w_1.equals(tmp0_other_with_cast.t3w_1))
      return false;
    if (!equals(this.u3w_1, tmp0_other_with_cast.u3w_1))
      return false;
    if (!(this.v3w_1 === tmp0_other_with_cast.v3w_1))
      return false;
    return true;
  }
}
class Companion_0 {
  l3x(json) {
    var it = get_dyn(Companion_getInstance_9().hz(json));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var framesDyn = Dyn__get_impl_6l2p80(it, 'frames');
    var frames = _Dyn___get_value__impl__bemnlg(framesDyn);
    var tmp;
    if (!(frames == null) ? isInterface(frames, KtMap) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = frames.g3();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var tmp$ret$0 = createEntry(Companion_instance_6, _Dyn___get_str__impl__dup4cs(get_dyn(item)), Dyn__get_impl_6l2p80(framesDyn, _Dyn___get_str__impl__dup4cs(get_dyn(item))));
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_1 = _Dyn___get_list__impl__qpwjp(framesDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.a1();
      while (tmp0_iterator_0.b1()) {
        var item_0 = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var it_0 = item_0.q2x_1;
        var tmp_0 = Companion_instance_6;
        var tmp6_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(it_0, 'name'));
        var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp6_safe_receiver.q2x_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          var tmp7_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(it_0, 'filename'));
          tmp_1 = tmp7_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp7_safe_receiver.q2x_1);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var tmp1_elvis_lhs = tmp_1;
        var tmp$ret$3 = createEntry(tmp_0, tmp1_elvis_lhs == null ? 'unknown' : tmp1_elvis_lhs, it_0);
        destination_0.h(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var tmp_2 = tmp;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var it_1 = Dyn__get_impl_6l2p80(it, 'meta');
    var tmp_3 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'app'));
    var tmp_4 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'format'));
    var tmp_5 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'image'));
    var tmp_6 = _Dyn___get_double__impl__jlvfa0(Dyn__get_impl_6l2p80(it_1, 'scale'));
    var tmp_7 = toSize(Dyn__get_impl_6l2p80(it_1, 'size'), Companion_instance_6);
    var tmp_8 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'version'));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var frameTagsDyn = Dyn__get_impl_6l2p80(it_1, 'frameTags');
    var frameTags = _Dyn___get_value__impl__bemnlg(frameTagsDyn);
    var tmp_9;
    if (!(frameTags == null) ? isInterface(frameTags, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_2 = _Dyn___get_list__impl__qpwjp(frameTagsDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_1 = this_2.a1();
      while (tmp0_iterator_1.b1()) {
        var item_1 = tmp0_iterator_1.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_2 = item_1.q2x_1;
        var tmp$ret$8 = new FrameTag(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_2, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_2, 'from')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_2, 'to')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_2, 'direction')));
        destination_1.h(tmp$ret$8);
      }
      tmp_9 = destination_1;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_9 = emptyList();
    }
    var tmp_10 = tmp_9;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var layersDyn = Dyn__get_impl_6l2p80(it_1, 'layers');
    var layers = _Dyn___get_value__impl__bemnlg(layersDyn);
    var tmp_11;
    if (!(layers == null) ? isInterface(layers, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_3 = _Dyn___get_list__impl__qpwjp(layersDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
      var tmp0_iterator_2 = this_3.a1();
      while (tmp0_iterator_2.b1()) {
        var item_2 = tmp0_iterator_2.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_3 = item_2.q2x_1;
        var tmp$ret$14 = new Layer(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_3, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_3, 'opacity')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_3, 'blendMode')));
        destination_2.h(tmp$ret$14);
      }
      tmp_11 = destination_2;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_11 = emptyList();
    }
    var tmp_12 = tmp_11;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var slicesDyn = Dyn__get_impl_6l2p80(it_1, 'slices');
    var slices = _Dyn___get_value__impl__bemnlg(slicesDyn);
    var tmp_13;
    if (!(slices == null) ? isInterface(slices, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_4 = _Dyn___get_list__impl__qpwjp(slicesDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList.w(collectionSizeOrDefault(this_4, 10));
      var tmp0_iterator_3 = this_4.a1();
      while (tmp0_iterator_3.b1()) {
        var item_3 = tmp0_iterator_3.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_4 = item_3.q2x_1;
        var tmp_14 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_4, 'name'));
        var tmp_15 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_4, 'color'));
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var keysDyn = Dyn__get_impl_6l2p80(it_4, 'keys');
        var keys = _Dyn___get_value__impl__bemnlg(keysDyn);
        var tmp_16;
        if (!(keys == null) ? isInterface(keys, KtList) : false) {
          // Inline function 'kotlin.collections.map' call
          var this_5 = _Dyn___get_list__impl__qpwjp(keysDyn);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_4 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
          var tmp0_iterator_4 = this_5.a1();
          while (tmp0_iterator_4.b1()) {
            var item_4 = tmp0_iterator_4.c1();
            // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var it_5 = item_4.q2x_1;
            var tmp$ret$20 = new Key(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_5, 'frame')), toRect(Dyn__get_impl_6l2p80(it_5, 'bounds'), Companion_instance_6));
            destination_4.h(tmp$ret$20);
          }
          tmp_16 = destination_4;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          tmp_16 = emptyList();
        }
        var tmp$ret$25 = tmp_16;
        var tmp$ret$26 = new Slice(tmp_14, tmp_15, tmp$ret$25);
        destination_3.h(tmp$ret$26);
      }
      tmp_13 = destination_3;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_13 = emptyList();
    }
    var tmp$ret$31 = tmp_13;
    var tmp$ret$33 = new Meta(tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_12, tmp$ret$31);
    var info = AtlasInfo.k3y(tmp_2, tmp$ret$33);
    // Inline function 'kotlin.collections.map' call
    var this_6 = info.a3x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList.w(collectionSizeOrDefault(this_6, 10));
    var tmp0_iterator_5 = this_6.a1();
    while (tmp0_iterator_5.b1()) {
      var item_5 = tmp0_iterator_5.c1();
      // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_7 = item_5.r3w_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_6 = ArrayList.w(collectionSizeOrDefault(this_7, 10));
      var tmp0_iterator_6 = this_7.a1();
      while (tmp0_iterator_6.b1()) {
        var item_6 = tmp0_iterator_6.c1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        destination_6.h(item_6);
      }
      var tmp$ret$39 = item_5.j3y(VOID, VOID, VOID, VOID, VOID, VOID, VOID, destination_6);
      destination_5.h(tmp$ret$39);
    }
    return info.l3y(VOID, destination_5);
  }
  k3x(content) {
    var xml = Xml(content);
    var imagePath = xml.s11('imagePath');
    var size = SizeInt.x2g(xml.t11('width', -1), xml.t11('height', -1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = plus(xml.p11('SubTexture'), xml.p11('sprite'));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.atlas.Companion.loadXml.<anonymous>' call
      var virtFrame = RectangleInt.h2f(imul(item.t11('frameX', 0), -1), imul(item.t11('frameY', 0), -1), item.t11('frameWidth', 0), item.t11('frameHeight', 0));
      var tmp0_elvis_lhs = item.y11('name');
      var tmp = tmp0_elvis_lhs == null ? item.s11('n') : tmp0_elvis_lhs;
      var tmp_0 = item.u11('x');
      var tmp_1 = item.u11('y');
      var tmp1_elvis_lhs = item.x11('width');
      var tmp_2 = tmp1_elvis_lhs == null ? item.u11('w') : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = item.x11('height');
      var tmp$ret$0 = new Region(tmp, RectangleInt.h2f(tmp_0, tmp_1, tmp_2, tmp2_elvis_lhs == null ? item.u11('h') : tmp2_elvis_lhs), !(virtFrame.f2f_1 === 0) || !(virtFrame.g2f_1 === 0) ? virtFrame : null, item.q11('rotated', false) ? Companion_getInstance_6().h3f_1 : Companion_getInstance_6().e3f_1);
      destination.h(tmp$ret$0);
    }
    return AtlasInfo.k3y(destination, new Meta('Unknown', 'xml', imagePath, 1.0, size, '1.0'));
  }
  j3x(content) {
    var r = new ListReader(lines(content));
    var pageImage = null;
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentEntryList = ArrayList.h1();
    // Inline function 'kotlin.collections.arrayListOf' call
    var pages = ArrayList.h1();
    $l$loop: while (r.gw()) {
      // Inline function 'kotlin.text.trim' call
      var this_0 = r.k1u();
      var line = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(line) === 0) {
        if (r.fw())
          break $l$loop;
        // Inline function 'kotlin.text.trim' call
        var this_1 = r.k1u();
        var fileName = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        var size = SizeInt.x2g(0, 0);
        var format = 'rgba8888';
        var filterMin = false;
        var filterMag = false;
        var repeatX = false;
        var repeatY = false;
        while (r.gw() && contains(r.u2p(), _Char___init__impl__6a9atx(58))) {
          // Inline function 'kotlin.text.trim' call
          var this_2 = r.k1u();
          var tmp$ret$5 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
          var _destruct__k2r9zo = loadText$keyValue(tmp$ret$5);
          var key = _destruct__k2r9zo.jl();
          var value = _destruct__k2r9zo.kl();
          switch (key) {
            case 'size':
              size = loadText$size(value);
              break;
            case 'format':
              format = value;
              break;
            case 'filter':
              // Inline function 'kotlin.collections.map' call

              var this_3 = split_0(value, [',']);
              // Inline function 'kotlin.collections.mapTo' call

              var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
              var tmp0_iterator = this_3.a1();
              while (tmp0_iterator.b1()) {
                var item = tmp0_iterator.c1();
                // Inline function 'korlibs.image.atlas.Companion.loadText.<anonymous>' call
                // Inline function 'kotlin.text.toLowerCase' call
                // Inline function 'kotlin.text.trim' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$9 = toString(trim(isCharSequence(item) ? item : THROW_CCE())).toLowerCase();
                destination.h(tmp$ret$9);
              }

              var filter = destination;
              filterMin = loadText$filter(first(filter));
              filterMag = loadText$filter(last(filter));
              break;
            case 'repeat':
              repeatX = contains(value, _Char___init__impl__6a9atx(120));
              repeatY = contains(value, _Char___init__impl__6a9atx(121));
              break;
          }
        }
        // Inline function 'kotlin.collections.arrayListOf' call
        currentEntryList = ArrayList.h1();
        pages.h(new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, currentEntryList));
      } else {
        var name = line;
        var rotate = false;
        var xy = Companion_getInstance_0().o25_1;
        var size_0 = SizeInt.x2g(0, 0);
        var orig = SizeInt.x2g(0, 0);
        var offset = Companion_getInstance_0().o25_1;
        while (r.gw() && contains(r.u2p(), _Char___init__impl__6a9atx(58))) {
          // Inline function 'kotlin.text.trim' call
          var this_4 = r.k1u();
          var tmp$ret$13 = toString(trim(isCharSequence(this_4) ? this_4 : THROW_CCE()));
          var _destruct__k2r9zo_0 = loadText$keyValue(tmp$ret$13);
          var key_0 = _destruct__k2r9zo_0.jl();
          var value_0 = _destruct__k2r9zo_0.kl();
          switch (key_0) {
            case 'rotate':
              rotate = toBoolean(value_0);
              break;
            case 'xy':
              xy = loadText$point(value_0);
              break;
            case 'size':
              size_0 = loadText$size(value_0);
              break;
            case 'orig':
              orig = loadText$size(value_0);
              break;
            case 'offset':
              offset = loadText$point(value_0);
              break;
          }
        }
        var orientation = rotate ? Companion_getInstance_6().f3f_1 : Companion_getInstance_6().e3f_1;
        var w = !rotate ? size_0.v2g_1 : size_0.w2g_1;
        var h = !rotate ? size_0.w2g_1 : size_0.v2g_1;
        var oW = orig.v2g_1;
        var oH = orig.w2g_1;
        currentEntryList.h(new Region(name, RectangleInt.h2f(numberToInt(xy.m25_1), numberToInt(xy.n25_1), w, h), RectangleInt.h2f(numberToInt(offset.m25_1), (orig.w2g_1 - size_0.w2g_1 | 0) - numberToInt(offset.n25_1) | 0, oW, oH), orientation));
      }
    }
    var firstPage = first(pages);
    return AtlasInfo.d3x(new Meta('unknown', firstPage.m3w_1, firstPage.k3w_1, 1.0, firstPage.l3w_1, '1.0'), pages);
  }
}
class AtlasInfo {
  static d3x(meta, pages) {
    meta = meta === VOID ? new Meta() : meta;
    var tmp;
    if (pages === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = pages;
    }
    pages = tmp;
    var $this = createThis(this);
    $this.z3w_1 = meta;
    $this.a3x_1 = pages;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = $this.a3x_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.atlas.AtlasInfo.frames.<anonymous>' call
      var list = element.r3w_1;
      addAll(destination, list);
    }
    tmp_0.b3x_1 = destination;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = $this.b3x_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.hc(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.atlas.AtlasInfo.framesMap.<anonymous>' call
      var tmp$ret$4 = element_0.s3w_1;
      destination_0.i3(tmp$ret$4, element_0);
    }
    tmp_1.c3x_1 = destination_0;
    return $this;
  }
  static k3y(frames, meta) {
    return this.d3x(meta, listOf(new Page(meta.p3x_1, meta.r3x_1, meta.o3x_1, true, true, false, false, frames)));
  }
  m3y(meta, pages) {
    return AtlasInfo.d3x(meta, pages);
  }
  l3y(meta, pages, $super) {
    meta = meta === VOID ? this.z3w_1 : meta;
    pages = pages === VOID ? this.a3x_1 : pages;
    return $super === VOID ? this.m3y(meta, pages) : $super.m3y.call(this, meta, pages);
  }
  toString() {
    return 'AtlasInfo(meta=' + this.z3w_1.toString() + ', pages=' + toString(this.a3x_1) + ')';
  }
  hashCode() {
    var result = this.z3w_1.hashCode();
    result = imul(result, 31) + hashCode(this.a3x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AtlasInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AtlasInfo ? other : THROW_CCE();
    if (!this.z3w_1.equals(tmp0_other_with_cast.z3w_1))
      return false;
    if (!equals(this.a3x_1, tmp0_other_with_cast.a3x_1))
      return false;
    return true;
  }
}
class GrowMethod extends Enum {}
class Entry_0 {
  constructor(slice, data) {
    this.n3y_1 = slice;
    this.o3y_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.n3y_1.toString() + ', data=' + toString_0(this.o3y_1) + ')';
  }
  hashCode() {
    var result = this.n3y_1.hashCode();
    result = imul(result, 31) + (this.o3y_1 == null ? 0 : hashCode(this.o3y_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.n3y_1.equals(tmp0_other_with_cast.n3y_1))
      return false;
    if (!equals(this.o3y_1, tmp0_other_with_cast.o3y_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static s3z(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.p3y_1 = binPacker;
    $this.q3y_1 = border;
    $this.r3y_1 = premultiplied;
    $this.s3y_1 = allowToGrow;
    $this.t3y_1 = growMethod;
    $this.u3y_1 = MarginInt.e29($this.q3y_1);
    $this.v3y_1 = Bitmap32.q3z($this.z2i(), $this.a2j(), VOID, $this.r3y_1);
    $this.w3y_1 = arrayListOf([$this.v3y_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.x3y_1 = ArrayList.h1();
    $this.y3y_1 = LinkedHashMap.gc();
    $this.z3y_1 = null;
    return $this;
  }
  static t3z(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.s3z(Companion_instance_1.i3e(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  z2i() {
    return numberToInt(this.p3y_1.z2i());
  }
  a2j() {
    return numberToInt(this.p3y_1.a2j());
  }
  e1() {
    return this.x3y_1.e1();
  }
  u3z(bmp, data, name) {
    return this.r3z(slice(bmp, VOID, name), data, name);
  }
  v3z(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.e1() : name;
    return $super === VOID ? this.u3z(bmp, data, name) : $super.u3z.call(this, bmp, data, name);
  }
  r3z(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.u3z(extract_0(bmp).j40(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.e1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.z3y_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.z3y_1).n3y_1;
        if (bigEmptySlice.x3f_1 >= bmp.x3f_1 && bigEmptySlice.y3f_1 >= bmp.y3f_1) {
          entry = new Entry_0(bigEmptySlice.h3h(RectangleInt.h2f(0, 0, bmp.x3f_1, bmp.y3f_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.p3y_1.y2r(bmp.x3f_1 + imul(this.q3y_1, 2), bmp.y3f_1 + imul(this.q3y_1, 2));
        var slice = sliceWithSize(this.v3y_1, numberToInt(rect.d26() + this.q3y_1), numberToInt(rect.f26() + this.q3y_1), bmp.x3f_1, bmp.y3f_1, rname);
        var dstX = slice.d26();
        var dstY = slice.f26();
        var boundsWithBorder = get_bounds_0(slice).i2f(this.u3y_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.v3y_1;
        if (true) {
          this_0.k40();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.v3y_1.l40(bmp, dstX, dstY);
          expandBorder(this.v3y_1, slice.p3f_1, this.q3y_1);
        }finally {
          result = true ? this_0.m40(boundsWithBorder) : 0;
        }
        entry = new Entry_0(slice, data);
        if (this.z3y_1 == null || bmp.v2f() > ensureNotNull(this.z3y_1).n3y_1.v2f()) {
          this.z3y_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.x3y_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.y3y_1;
      var value = entry;
      this_2.i3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.s3y_1)
          throw e;
        growAtlas(this, bmp);
        return this.r3z(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  n40(bmp, data, name, $super) {
    name = name === VOID ? bmp.s3f_1 : name;
    return $super === VOID ? this.r3z(bmp, data, name) : $super.r3z.call(this, bmp, data, name);
  }
}
class Bitmap {
  static o40(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.w3z_1 = new Mixin();
    $this.x3z_1 = width;
    $this.y3z_1 = height;
    $this.z3z_1 = bpp;
    $this.a40_1 = backingArray;
    $this.b40_1 = RectangleInt.h2f(0, 0, $this.x3z_1, $this.y3z_1);
    $this.c40_1 = null;
    $this.d40_1 = premultiplied;
    $this.e40_1 = false;
    var tmp = $this;
    tmp.f40_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.g40_1 = 0;
    $this.h40_1 = null;
    $this.i40_1 = false;
    return $this;
  }
  ay(_set____db54di) {
    this.w3z_1.ay(_set____db54di);
  }
  by() {
    return this.w3z_1.by();
  }
  e1() {
    return SizeInt.x2g(this.x3z_1, this.y3z_1);
  }
  p40() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f40_1;
    tempInts$factory();
    return this_0.u1();
  }
  q40() {
    return _RgbaArray___init__impl__oib4y4(this.p40());
  }
  r40() {
    return imul(this.x3z_1, this.z3z_1) / 8 | 0;
  }
  v2f() {
    return imul(this.x3z_1, this.y3z_1);
  }
  s40(x, y) {
    return imul(y, this.x3z_1) + x | 0;
  }
  t40() {
    if (!(this.h40_1 == null)) {
      this.h40_1 = null;
    }
  }
  k40() {
    return Unit_instance;
  }
  m40(rect) {
    if (this.h40_1 == null)
      this.h40_1 = rect;
    else
      this.h40_1 = Companion_instance_0.o2f(ensureNotNull(this.h40_1), rect);
    this.g40_1 = this.g40_1 + 1 | 0;
    return this.g40_1;
  }
  u40(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.v40(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  w40(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.x40(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  y40(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.w40(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.w40.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  z40(x, y, v) {
    if (this.d40_1) {
      this.x40(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.x40(x, y, v);
    }
  }
  a41(x, y) {
    var tmp;
    if (this.d40_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.v40(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.v40(x, y);
    }
    return tmp;
  }
  b41(x, y, color) {
    this.x40(x, y, _RGBA___init__impl__lqpay5(color));
  }
  c41(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.v40(x, y));
  }
  d41(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.x3z_1 || y0 >= this.y3z_1)
      return Colors_getInstance().j41_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.x3z_1 - 1 | 0);
    var y1Inside = y1 < (this.y3z_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.v40(x0, y0);
    var c10 = x1Inside ? this.v40(x1, y0) : c00;
    var c01 = y1Inside ? this.v40(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.v40(x1, y1) : c01;
    return Companion_getInstance_26().b47(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  c47(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.d47(srcX);
    var srcX1 = src.d47(srcX + width | 0);
    var srcY0 = src.e47(srcY);
    var srcY1 = src.e47(srcY + height | 0);
    var dstX0 = dst.d47(dstX);
    var dstX1 = dst.d47(dstX + width | 0);
    var dstY0 = dst.e47(dstY);
    var dstY1 = dst.e47(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.f47(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  f47(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.u40(srcX, srcY + y | 0, width, 1, this.p40(), 0);
        dst.w40(dstX, dstY + y | 0, width, 1, this.p40(), 0);
      }
       while (inductionVariable < height);
  }
  g47(x) {
    return x >= 0 && x < this.x3z_1;
  }
  h47(y) {
    return y >= 0 && y < this.y3z_1;
  }
  i47(x, y) {
    return this.g47(x) && this.h47(y);
  }
  j47(x) {
    return clamp(x, 0, this.x3z_1 - 1 | 0);
  }
  k47(y) {
    return clamp(y, 0, this.y3z_1 - 1 | 0);
  }
  d47(x) {
    return clamp(x, 0, this.x3z_1);
  }
  e47(y) {
    return clamp(y, 0, this.y3z_1);
  }
  l47() {
    var inductionVariable = 0;
    var last = this.y3z_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m47(y, (this.y3z_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  n47() {
    var inductionVariable = 0;
    var last = this.x3z_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o47(x, (this.x3z_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  p47(rotation) {
    var tmp;
    switch (rotation.r3_1) {
      case 0:
        tmp = this.wx();
        break;
      case 1:
        tmp = this.q47().n47();
        break;
      case 2:
        tmp = this.q47().n47().q47().n47();
        break;
      case 3:
        tmp = this.q47().l47();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  r47(orientation) {
    var out = this.wx();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.n47();
    }
    return out.p47(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  q47() {
    var temp = new IntArray2(this.x3z_1, this.y3z_1, readPixelsUnsafe(this, 0, 0, this.x3z_1, this.y3z_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.y3z_1;
    var height = this.x3z_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.y3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.x3z_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.f2j(y, x, temp.y27(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.s47(this.y3z_1, this.x3z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.y40(0, 0, this.y3z_1, this.x3z_1, out.y2i_1);
    return this_0;
  }
  m47(y0, y1) {
    var inductionVariable = 0;
    var last = this.x3z_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.c41(x, y0);
        var c1 = this.c41(x, y1);
        this.b41(x, y0, c1);
        this.b41(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  o47(x0, x1) {
    var inductionVariable = 0;
    var last = this.y3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.c41(x0, y);
        var c1 = this.c41(x1, y);
        this.b41(x0, y, c1);
        this.b41(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  t47(antialiasing) {
    throw UnsupportedOperationException.da('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  s47(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString(this) + ')');
  }
  j40() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.q3z(this.x3z_1, this.y3z_1, VOID, this.d40_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.u40(0, 0, this.x3z_1, this.y3z_1, this_0.n3z_1, 0);
    return this_0;
  }
  u47() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.j40();
    }
    return tmp;
  }
  wx() {
    var out = this.s47(this.x3z_1, this.y3z_1);
    this.f47(0, 0, out, 0, 0, this.x3z_1, this.y3z_1);
    return out;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.e48_1 = Bitmap32.q3z(0, 0, VOID, true);
  }
  f48(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.q3z(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.n3z_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  g48(width, height, premultiplied) {
    return Bitmap32.q3z(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  h48(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.l48_1;
    var dstShift = dstChannel.l48_1;
    var dstClear = dstChannel.n48_1;
    var dstData = dst.n3z_1;
    var srcData = src.n3z_1;
    var inductionVariable = 0;
    var last = dst.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  o48(src, dst, dstChannel) {
    var destShift = imul(dstChannel.k48_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.j49()[n] & 255;
        dst.n3z_1[n] = dst.n3z_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  k49(src, srcChannel, dst) {
    var shift = srcChannel.l48_1;
    var inductionVariable = 0;
    var last = src.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.j49()[n] = toByte((src.n3z_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.c48_1 = this$0;
  }
  l49($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  vd(p1, $completion) {
    return this.l49(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static q3z(width, height, ints, premultiplied) {
    Companion_getInstance_17();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.o40(width, height, 32, premultiplied, ints);
    $this.n3z_1 = ints;
    if ($this.n3z_1.length < imul(width, height))
      throw RuntimeException.oa('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.n3z_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.o3z_1 = new Int32Array(tmp$ret$0);
    $this.p3z_1 = RectangleInt.h2f(0, 0, width, height);
    return $this;
  }
  s47(width, height) {
    return Bitmap32.q3z(width, height, VOID, this.d40_1);
  }
  f47(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.f47(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.n3z_1;
    var dstArray = dst.n3z_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.s40(srcX, srcY + y | 0), dstArray, dst.s40(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  m49(x, y, color) {
    this.z40(x, y, color);
  }
  n49(x, y) {
    return this.a41(x, y);
  }
  b41(x, y, color) {
    this.n3z_1[this.s40(x, y)] = color;
  }
  c41(x, y) {
    return this.n3z_1[this.s40(x, y)];
  }
  v40(x, y) {
    return _RGBA___init__impl__lqpay5(this.c41(x, y));
  }
  x40(x, y, v) {
    return this.b41(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  o49(n, color) {
    this.n3z_1[n] = this.d40_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  p49(n, color) {
    var tmp;
    if (this.d40_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.n3z_1[n] = tmp;
  }
  d48(n) {
    var tmp;
    if (this.d40_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.n3z_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.n3z_1[n]);
    }
    return tmp;
  }
  q49(n) {
    return this.d40_1 ? _RGBAPremultiplied___init__impl__uos02x(this.n3z_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.n3z_1[n]));
  }
  r49(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.s40(dx, dy + y | 0);
        var srcOffset = src.s40(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.p49(dstOffset + x | 0, mix(dst.q49(dstOffset + x | 0), src.q49(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.d40_1 === src.d40_1) {
            arraycopy(src.n3z_1, srcOffset, dst.n3z_1, dstOffset, width);
          } else if (!dst.d40_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.o49(dstOffset + x_0 | 0, src.d48(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.p49(dstOffset + x_1 | 0, src.q49(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  s49(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.x3z_1 - dx_0 | 0;
    var availableHeight = this.y3z_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.r49(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  t49(mix, other, _dx, _dy) {
    this.s49(other, _dx, _dy, 0, 0, other.x3z_1, other.y3z_1, mix);
  }
  u49(color, x, y, width, height) {
    var x1 = this.j47(x);
    var x2 = this.j47((x + width | 0) - 1 | 0);
    var y1 = this.k47(y);
    var y2 = this.k47((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.d40_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.n3z_1, colorInt, this.s40(x1, cy), this.s40(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  v49(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.x3z_1 - x | 0 : width;
    height = height === VOID ? this.y3z_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.u49(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.u49.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  w49(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.s49(get_bmp(src), dx, dy, b.d26(), b.f26(), b.e26(), b.g26(), mix);
  }
  x49(src, dx, dy) {
    return this.t49(false, src, dx, dy);
  }
  y49(src, dx, dy) {
    return this.t49(true, src, dx, dy);
  }
  l40(src, dx, dy) {
    return this.w49(src, dx, dy, true);
  }
  z49(destination, input, source) {
    return Companion_getInstance_17().h48(input, source, this, destination);
  }
  a4a(destination, input) {
    return Companion_getInstance_17().o48(input, this, destination);
  }
  b4a(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_17().k49(this, channel, out);
    return out;
  }
  c4a(channel, out, $super) {
    out = out === VOID ? Bitmap8.x4a(this.x3z_1, this.y3z_1) : out;
    return $super === VOID ? this.b4a(channel, out) : $super.b4a.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.tb('Bitmap32(');
    this_0.sg(this.x3z_1);
    this_0.tb(', ');
    this_0.sg(this.y3z_1);
    if (!(this.c40_1 == null)) {
      this_0.tb(', name=');
      this_0.tb(this.c40_1);
    }
    this_0.tb(')');
    return this_0.toString();
  }
  m47(y0, y1) {
    var s0 = this.s40(0, y0);
    var s1 = this.s40(0, y1);
    arraycopy(this.n3z_1, s0, this.o3z_1, 0, this.x3z_1);
    arraycopy(this.n3z_1, s1, this.n3z_1, s0, this.x3z_1);
    arraycopy(this.o3z_1, 0, this.n3z_1, s1, this.x3z_1);
  }
  wx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.n3z_1.slice();
    return Bitmap32.q3z(this.x3z_1, this.y3z_1, tmp$ret$1, this.d40_1);
  }
  t47(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  y4a() {
    return this.d40_1 ? this : this.copyPremultiplied();
  }
  z4a() {
    return !this.d40_1 ? this : this.a4b();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.wx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.b4b();
    return this_0;
  }
  a4b() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.wx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.c4b();
    return this_0;
  }
  b4b() {
    if (this.d40_1)
      return Unit_instance;
    this.d40_1 = true;
    var inductionVariable = 0;
    var last = this.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n3z_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.n3z_1[n])));
      }
       while (inductionVariable < last);
  }
  c4b() {
    if (!this.d40_1)
      return Unit_instance;
    this.d40_1 = false;
    var inductionVariable = 0;
    var last = this.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.n3z_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.n3z_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  a1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  d4b(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.n3z_1, this.s40(x, y), width);
    } else {
      var m = this.s40(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.n3z_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  j40() {
    return this;
  }
}
class Companion_2 {
  e4b(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.c47(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static g4b(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_15.f4b(1 << bpp) : palette;
    var $this = this.o40(width, height, bpp, false, bytes);
    $this.c49_1 = bytes;
    $this.d49_1 = palette;
    if ($this.c49_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.oa('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.j49().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.e49_1 = new Int8Array(tmp$ret$0);
    $this.f49_1 = _UByteArrayInt___init__impl__xif7bu($this.j49());
    $this.g49_1 = 8 / bpp | 0;
    $this.h49_1 = ilog2($this.g49_1);
    $this.i49_1 = $this.g49_1 - 1 | 0;
    return $this;
  }
  j49() {
    return this.c49_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.z3z_1 + ', width=' + this.x3z_1 + ', height=' + this.y3z_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.d49_1) + ')';
  }
  c41(x, y) {
    return this.i4b(this.s40(x, y));
  }
  b41(x, y, color) {
    return this.h4b(this.s40(x, y), color);
  }
  i4b(n) {
    var iD = this.k4b(n);
    var iM = this.l4b(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.f49_1, iD), imul(this.z3z_1, iM), this.z3z_1);
  }
  h4b(n, color) {
    var iD = this.k4b(n);
    var iM = this.l4b(n);
    UByteArrayInt__set_impl_gn4532(this.f49_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.f49_1, iD), color, imul(this.z3z_1, iM), this.z3z_1));
  }
  v40(x, y) {
    var tmp = this.d49_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.c41(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  x40(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.td('An operation is not implemented: ' + reason);
  }
  j4b(x, y) {
    return this.k4b(this.s40(x, y));
  }
  k4b(n) {
    return n >>> this.h49_1 | 0;
  }
  l4b(n) {
    return n & this.i49_1;
  }
  m47(y0, y1) {
    var s0 = this.j4b(0, y0);
    var s1 = this.j4b(0, y1);
    arraycopy_0(this.j49(), s0, this.e49_1, 0, this.r40());
    arraycopy_0(this.j49(), s1, this.j49(), s0, this.r40());
    arraycopy_0(this.e49_1, 0, this.j49(), s1, this.r40());
  }
  m4b(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.j49(), this.s40(x, y), width / this.g49_1 | 0);
    } else {
      var m = this.s40(x, y);
      var inductionVariable = 0;
      var last = width / this.g49_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.j49()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  j40() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.q3z(this.x3z_1, this.y3z_1, VOID, this.d40_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.n3z_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.d49_1);
    var inductionVariable = 0;
    var last = this.v2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.i4b(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static x4a(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_15.f4b(256) : palette;
    return this.g4b(8, width, height, data, palette);
  }
  s47(width, height) {
    return Bitmap8.x4a(width, height, VOID, this.d49_1);
  }
  b41(x, y, color) {
    return this.h4b(this.s40(x, y), color);
  }
  c41(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.f49_1, this.s40(x, y));
  }
  v40(x, y) {
    var tmp = this.d49_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.c41(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  i4b(n) {
    return UByteArrayInt__get_impl_px6q8a(this.f49_1, n);
  }
  h4b(n, color) {
    UByteArrayInt__set_impl_gn4532(this.f49_1, n, color);
  }
  f47(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.f47(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.j49();
        var tmp_0 = this.s40(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).j49(), dst.s40(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  wx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.j49().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.d49_1).slice();
    return Bitmap8.x4a(this.x3z_1, this.y3z_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.x3z_1 + ', ' + this.y3z_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.d49_1) + ')';
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_9 = this;
    this.n4b_1 = values();
  }
  d1(index) {
    return this.n4b_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.k48_1 = index;
    this.l48_1 = imul(this.k48_1, 8);
    this.m48_1 = 255 << this.l48_1;
    this.n48_1 = ~this.m48_1;
  }
}
class Bitmaps {}
class Companion_4 {
  constructor() {
    this.o4b_1 = 1.0;
    this.p4b_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.q4b_1 = width;
    this.r4b_1 = height;
    this.s4b_1 = d;
    this.t4b_1 = px;
    this.u4b_1 = py;
    this.v4b_1 = imul(this.q4b_1, this.r4b_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.s4b_1.length >= this.v4b_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.t4b_1.length >= this.v4b_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.z4(toString(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.u4b_1.length >= this.v4b_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.z4(toString(message_1));
    }
  }
  g47(x) {
    return x >= 0 && x < this.q4b_1;
  }
  h47(y) {
    return y >= 0 && y < this.r4b_1;
  }
  i47(x, y) {
    return this.g47(x) && this.h47(y);
  }
  s40(x, y) {
    return imul(y, this.q4b_1) + x | 0;
  }
  a4c(x, y) {
    return this.i47(x, y) ? this.s4b_1[this.s40(x, y)] : Infinity;
  }
  x4b(x, y) {
    return this.i47(x, y) ? this.t4b_1[this.s40(x, y)] : -1;
  }
  y4b(x, y) {
    return this.i47(x, y) ? this.u4b_1[this.s40(x, y)] : -1;
  }
  z4b(x, y, d) {
    if (!this.i47(x, y))
      return Unit_instance;
    this.s4b_1[this.s40(x, y)] = d;
  }
  b4c(x, y, px, py) {
    if (!this.i47(x, y))
      return Unit_instance;
    var index = this.s40(x, y);
    this.t4b_1[index] = px;
    this.u4b_1[index] = py;
  }
  w4b(x, y, px, py) {
    return this.b4c(x, y, this.x4b(px, py), this.y4b(px, py));
  }
  c4c(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q4b_1 === bmp.x3z_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.r4b_1 === bmp.y3z_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.z4(toString(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.r4b_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.q4b_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.z4b(x, y, Infinity);
            this.b4c(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.r4b_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.q4b_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.z4b(x_0, y_0, 0.0);
              this.b4c(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.r4b_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.q4b_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.r4b_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.q4b_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.r4b_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.q4b_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.z4b(x_3, y_3, -this.a4c(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static r4c(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.o40(width, height, 32, premultiplied, data);
    $this.q4c_1 = data;
    return $this;
  }
  x40(x, y, v) {
    var rindex = index4(this, x, y);
    this.q4c_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.q4c_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.q4c_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.q4c_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  v40(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_26().s4c(this.q4c_1[rindex + 0 | 0], this.q4c_1[rindex + 1 | 0], this.q4c_1[rindex + 2 | 0], this.q4c_1[rindex + 3 | 0]);
  }
  t4c(x, y) {
    return this.q4c_1[index4(this, x, y) + 0 | 0];
  }
  u4c(x, y) {
    return this.q4c_1[index4(this, x, y) + 1 | 0];
  }
  v4c(x, y) {
    return this.q4c_1[index4(this, x, y) + 2 | 0];
  }
  w4c(x, y) {
    return this.q4c_1[index4(this, x, y) + 3 | 0];
  }
  x4c(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.q4c_1[rindex + 0 | 0] = r;
    this.q4c_1[rindex + 1 | 0] = g;
    this.q4c_1[rindex + 2 | 0] = b;
    this.q4c_1[rindex + 3 | 0] = a;
  }
  y4c(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.q4c_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.q4c_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.q4c_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.q4c_1[rindex + 3 | 0]);
    return out;
  }
  z4c(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.x3z_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.y3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.s40(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.y4c(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  a4d(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.z4c(out) : $super.z4c.call(this, out);
  }
  b4d(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.x3z_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.y3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.s40(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.y4c(x, y, out);
            this.x4c(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  c4d(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.b4d(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.b4d.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  d4d() {
    var _destruct__k2r9zo = this.a4d();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.c4d(-range, +range);
  }
  e4d(scale) {
    return this.f4d(scale, scale, scale, scale);
  }
  f4d(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.x3z_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.y3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.s40(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.x4c(x, y, this.t4c(x, y) * scaleRed, this.u4c(x, y) * scaleGreen, this.v4c(x, y) * scaleBlue, this.w4c(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  g4d(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.x3z_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.y3z_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.s40(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.t4c(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.u4c(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.v4c(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.w4c(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.x4c(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static v4d(width, height, data, premultiplied) {
    var $this = this.o40(width, height, 32, premultiplied, null);
    $this.u4d_1 = data;
    return $this;
  }
  j40() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_17().g48(this.x3z_1, this.y3z_1, this.d40_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.u40(0, 0, this.x3z_1, this.y3z_1, this_0.n3z_1, 0);
    return this_0;
  }
  x40(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.q40(), 0, v);
    this.w40(x, y, 1, 1, this.p40(), 0);
  }
  v40(x, y) {
    this.u40(x, y, 1, 1, this.p40(), 0);
    return RgbaArray__get_impl_nzyo1o(this.q40(), 0);
  }
  b41(x, y, color) {
    return this.x40(x, y, _RGBA___init__impl__lqpay5(color));
  }
  c41(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.v40(x, y));
  }
  l47() {
    var tmp = this.j40().l47();
    this.y40(0, 0, this.x3z_1, this.y3z_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).n3z_1);
    return this;
  }
  n47() {
    var tmp = this.j40().n47();
    this.y40(0, 0, this.x3z_1, this.y3z_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).n3z_1);
    return this;
  }
  m47(y0, y1) {
    this.u40(0, y0, this.x3z_1, 1, this.p40(), 0);
    this.u40(0, y1, this.x3z_1, 1, this.p40(), this.x3z_1);
    this.w40(0, y1, this.x3z_1, 1, this.p40(), 0);
    this.w40(0, y0, this.x3z_1, 1, this.p40(), this.x3z_1);
  }
  o47(x0, x1) {
    this.u40(x0, 0, 1, this.y3z_1, this.p40(), 0);
    this.u40(x1, 0, 1, this.y3z_1, this.p40(), this.x3z_1);
    this.w40(x1, 0, 1, this.y3z_1, this.p40(), 0);
    this.w40(x0, 0, 1, this.y3z_1, this.p40(), this.x3z_1);
  }
  s47(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.s3() + '(' + this.x3z_1 + ', ' + this.y3z_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static a4f(width, height, premultiplied) {
    Companion_getInstance_21();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.o40(width, height, 32, premultiplied, null);
  }
  x40(x, y, v) {
    return Unit_instance;
  }
  v40(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_5 extends NullBitmap {
  static m4e() {
    Companion_instance_11 = null;
    var $this = this.a4f(1, 1);
    Companion_instance_11 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.b4f_1 = colors;
    this.c4f_1 = names;
    this.d4f_1 = changeStart;
    this.e4f_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.tb('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.b4f_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.b4f_1, n);
        var tmp22_safe_receiver = this.c4f_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.tb(', ');
        }
        if (!(name == null)) {
          this_0.tb(name);
          this_0.tb(': ');
        }
        this_0.tb(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.tb(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.p4f_1 = bmp;
    this.q4f_1 = buffer;
    this.r4f_1 = radius;
    this.s4f_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.p4f_1.toString() + ', buffer=' + this.q4f_1 + ', radius=' + this.r4f_1 + ', cutoff=' + this.s4f_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.p4f_1);
    result = imul(result, 31) + this.q4f_1 | 0;
    result = imul(result, 31) + this.r4f_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.p4f_1, tmp0_other_with_cast.p4f_1))
      return false;
    if (!(this.q4f_1 === tmp0_other_with_cast.q4f_1))
      return false;
    if (!(this.r4f_1 === tmp0_other_with_cast.r4f_1))
      return false;
    if (!equals(this.s4f_1, tmp0_other_with_cast.s4f_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.t4f_1 = 1.0E10;
  }
  u4f(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.q3z(bmp.x3z_1 + imul(buffer, 2) | 0, bmp.y3z_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.x3z_1;
    var height = out.y3z_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.x3z_1;
    var height_0 = out.y3z_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.y3z_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.x3z_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.n49(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.m2j(x0, y0, 1.0E10);
                gridInner.m2j(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.m2j(x0, y0, 0.0);
                gridInner.m2j(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.m2j(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.m2j(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.v4f(gridOuter.k2j_1, 0, 0, out.x3z_1, out.y3z_1, gridOuter.z2i(), f, v, z);
    this.v4f(gridInner.k2j_1, buffer, buffer, bmp.x3z_1, bmp.y3z_1, gridInner.z2i(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.y3z_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.x3z_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.y27(x_0, y_0);
            var gin = gridInner.y27(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.m49(x_0, y_0, Companion_getInstance_26().o4f(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  w4f(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.x3z_1;
      var b = bmp.y3z_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.u4f(bmp, maxSide, buffer, radius, cutoff) : $super.u4f.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  v4f(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.x4f(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.x4f(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  x4f(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.d4g_1 = 32;
  }
  y4f() {
    return this.d4g_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.e4g_1 = 24;
  }
  y4f() {
    return this.e4g_1;
  }
}
class Companion_6 {}
class ColorTransform {
  constructor(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    this.f4g_1 = _mR;
    this.g4g_1 = _mG;
    this.h4g_1 = _mB;
    this.i4g_1 = _mA;
    this.j4g_1 = _aR;
    this.k4g_1 = _aG;
    this.l4g_1 = _aB;
    this.m4g_1 = _aA;
    this.n4g_1 = true;
    this.o4g_1 = true;
    this.p4g_1 = Colors_getInstance().e41_1;
    this.q4g_1 = _ColorAdd___init__impl__q78um5(0);
  }
  r4g() {
    computeColorMul(this);
    return this.p4g_1;
  }
  s4g() {
    computeColorAdd(this);
    return this.q4g_1;
  }
  t4g() {
    return this.f4g_1;
  }
  u4g() {
    return this.g4g_1;
  }
  v4g() {
    return this.h4g_1;
  }
  w4g() {
    return this.i4g_1;
  }
  x4g() {
    return this.j4g_1;
  }
  y4g() {
    return this.k4g_1;
  }
  z4g() {
    return this.l4g_1;
  }
  a4h() {
    return this.m4g_1;
  }
  toString() {
    return 'ColorTransform(*[' + get_niceStr(this.t4g()) + ', ' + get_niceStr(this.u4g()) + ', ' + get_niceStr(this.v4g()) + ', ' + get_niceStr(this.w4g()) + ']+[' + this.x4g() + ', ' + this.y4g() + ', ' + this.z4g() + ', ' + this.a4h() + '])';
  }
  hashCode() {
    var result = getNumberHashCode(this.f4g_1);
    result = imul(result, 31) + getNumberHashCode(this.g4g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h4g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i4g_1) | 0;
    result = imul(result, 31) + this.j4g_1 | 0;
    result = imul(result, 31) + this.k4g_1 | 0;
    result = imul(result, 31) + this.l4g_1 | 0;
    result = imul(result, 31) + this.m4g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransform))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransform ? other : THROW_CCE();
    if (!equals(this.f4g_1, tmp0_other_with_cast.f4g_1))
      return false;
    if (!equals(this.g4g_1, tmp0_other_with_cast.g4g_1))
      return false;
    if (!equals(this.h4g_1, tmp0_other_with_cast.h4g_1))
      return false;
    if (!equals(this.i4g_1, tmp0_other_with_cast.i4g_1))
      return false;
    if (!(this.j4g_1 === tmp0_other_with_cast.j4g_1))
      return false;
    if (!(this.k4g_1 === tmp0_other_with_cast.k4g_1))
      return false;
    if (!(this.l4g_1 === tmp0_other_with_cast.l4g_1))
      return false;
    if (!(this.m4g_1 === tmp0_other_with_cast.m4g_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.b4h_1 = _r;
    this.c4h_1 = _g;
    this.d4h_1 = _b;
    this.e4h_1 = _a;
    this.f4h_1 = true;
    this.g4h_1 = Colors_getInstance().e41_1;
  }
  h4h() {
    return this.b4h_1;
  }
  i4h() {
    return this.c4h_1;
  }
  j4h() {
    return this.d4h_1;
  }
  k4h(value) {
    this.e4h_1 = value;
    this.f4h_1 = true;
  }
  l4h() {
    return this.e4h_1;
  }
  m4h(v) {
    this.n4h(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.g4h_1 = v;
    this.f4h_1 = false;
  }
  r4g() {
    if (this.f4h_1) {
      this.f4h_1 = false;
      this.g4h_1 = Companion_getInstance_26().s4c(this.b4h_1, this.c4h_1, this.d4h_1, this.e4h_1);
    }
    return this.g4h_1;
  }
  n4h(r, g, b, a) {
    this.b4h_1 = r;
    this.c4h_1 = g;
    this.d4h_1 = b;
    this.e4h_1 = a;
    this.f4h_1 = true;
  }
  o4h(other) {
    return this.n4h(other.b4h_1, other.c4h_1, other.d4h_1, other.e4h_1);
  }
  p4h(a, b) {
    return this.n4h(a.h4h() * b.h4h(), a.i4h() * b.i4h(), a.j4h() * b.j4h(), a.l4h() * b.l4h());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.b4h_1 + ', _g=' + this.c4h_1 + ', _b=' + this.d4h_1 + ', _a=' + this.e4h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b4h_1);
    result = imul(result, 31) + getNumberHashCode(this.c4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.b4h_1, tmp0_other_with_cast.b4h_1))
      return false;
    if (!equals(this.c4h_1, tmp0_other_with_cast.c4h_1))
      return false;
    if (!equals(this.d4h_1, tmp0_other_with_cast.d4h_1))
      return false;
    if (!equals(this.e4h_1, tmp0_other_with_cast.e4h_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.e41_1 = Companion_getInstance_26().o4f(255, 255, 255, 255);
    this.f41_1 = Companion_getInstance_26().o4f(0, 0, 0, 255);
    this.g41_1 = Companion_getInstance_26().o4f(255, 0, 0, 255);
    this.h41_1 = Companion_getInstance_26().o4f(0, 255, 0, 255);
    this.i41_1 = Companion_getInstance_26().o4f(0, 0, 255, 255);
    this.j41_1 = Companion_getInstance_26().o4f(0, 0, 0, 0);
    this.k41_1 = Companion_getInstance_26().o4f(255, 255, 255, 0);
    this.l41_1 = Companion_getInstance_26().q4h(240, 248, 255);
    this.m41_1 = Companion_getInstance_26().q4h(250, 235, 215);
    this.n41_1 = Companion_getInstance_26().q4h(0, 255, 255);
    this.o41_1 = Companion_getInstance_26().q4h(127, 255, 212);
    this.p41_1 = Companion_getInstance_26().q4h(240, 255, 255);
    this.q41_1 = Companion_getInstance_26().q4h(245, 245, 220);
    this.r41_1 = Companion_getInstance_26().q4h(255, 228, 196);
    this.s41_1 = Companion_getInstance_26().q4h(255, 235, 205);
    this.t41_1 = Companion_getInstance_26().q4h(138, 43, 226);
    this.u41_1 = Companion_getInstance_26().q4h(165, 42, 42);
    this.v41_1 = Companion_getInstance_26().q4h(222, 184, 135);
    this.w41_1 = Companion_getInstance_26().q4h(95, 158, 160);
    this.x41_1 = Companion_getInstance_26().q4h(127, 255, 0);
    this.y41_1 = Companion_getInstance_26().q4h(210, 105, 30);
    this.z41_1 = Companion_getInstance_26().q4h(255, 127, 80);
    this.a42_1 = Companion_getInstance_26().q4h(100, 149, 237);
    this.b42_1 = Companion_getInstance_26().q4h(255, 248, 220);
    this.c42_1 = Companion_getInstance_26().q4h(220, 20, 60);
    this.d42_1 = Companion_getInstance_26().q4h(0, 0, 139);
    this.e42_1 = Companion_getInstance_26().q4h(0, 255, 255);
    this.f42_1 = Companion_getInstance_26().q4h(0, 139, 139);
    this.g42_1 = Companion_getInstance_26().q4h(184, 134, 11);
    this.h42_1 = Companion_getInstance_26().q4h(169, 169, 169);
    this.i42_1 = Companion_getInstance_26().q4h(0, 100, 0);
    this.j42_1 = Companion_getInstance_26().q4h(169, 169, 169);
    this.k42_1 = Companion_getInstance_26().q4h(189, 183, 107);
    this.l42_1 = Companion_getInstance_26().q4h(255, 0, 255);
    this.m42_1 = Companion_getInstance_26().q4h(139, 0, 139);
    this.n42_1 = Companion_getInstance_26().q4h(85, 107, 47);
    this.o42_1 = Companion_getInstance_26().q4h(255, 140, 0);
    this.p42_1 = Companion_getInstance_26().q4h(153, 50, 204);
    this.q42_1 = Companion_getInstance_26().q4h(139, 0, 0);
    this.r42_1 = Companion_getInstance_26().q4h(233, 150, 122);
    this.s42_1 = Companion_getInstance_26().q4h(143, 188, 143);
    this.t42_1 = Companion_getInstance_26().q4h(72, 61, 139);
    this.u42_1 = Companion_getInstance_26().q4h(47, 79, 79);
    this.v42_1 = Companion_getInstance_26().q4h(47, 79, 79);
    this.w42_1 = Companion_getInstance_26().q4h(0, 206, 209);
    this.x42_1 = Companion_getInstance_26().q4h(148, 0, 211);
    this.y42_1 = Companion_getInstance_26().q4h(255, 20, 147);
    this.z42_1 = Companion_getInstance_26().q4h(0, 191, 255);
    this.a43_1 = Companion_getInstance_26().q4h(105, 105, 105);
    this.b43_1 = Companion_getInstance_26().q4h(105, 105, 105);
    this.c43_1 = Companion_getInstance_26().q4h(30, 144, 255);
    this.d43_1 = Companion_getInstance_26().q4h(178, 34, 34);
    this.e43_1 = Companion_getInstance_26().q4h(255, 250, 240);
    this.f43_1 = Companion_getInstance_26().q4h(34, 139, 34);
    this.g43_1 = Companion_getInstance_26().q4h(255, 0, 255);
    this.h43_1 = Companion_getInstance_26().q4h(220, 220, 220);
    this.i43_1 = Companion_getInstance_26().q4h(248, 248, 255);
    this.j43_1 = Companion_getInstance_26().q4h(255, 215, 0);
    this.k43_1 = Companion_getInstance_26().q4h(218, 165, 32);
    this.l43_1 = Companion_getInstance_26().q4h(173, 255, 47);
    this.m43_1 = Companion_getInstance_26().q4h(240, 255, 240);
    this.n43_1 = Companion_getInstance_26().q4h(255, 105, 180);
    this.o43_1 = Companion_getInstance_26().q4h(205, 92, 92);
    this.p43_1 = Companion_getInstance_26().q4h(75, 0, 130);
    this.q43_1 = Companion_getInstance_26().q4h(255, 255, 240);
    this.r43_1 = Companion_getInstance_26().q4h(240, 230, 140);
    this.s43_1 = Companion_getInstance_26().q4h(230, 230, 250);
    this.t43_1 = Companion_getInstance_26().q4h(255, 240, 245);
    this.u43_1 = Companion_getInstance_26().q4h(124, 252, 0);
    this.v43_1 = Companion_getInstance_26().q4h(255, 250, 205);
    this.w43_1 = Companion_getInstance_26().q4h(173, 216, 230);
    this.x43_1 = Companion_getInstance_26().q4h(240, 128, 128);
    this.y43_1 = Companion_getInstance_26().q4h(224, 255, 255);
    this.z43_1 = Companion_getInstance_26().q4h(250, 250, 210);
    this.a44_1 = Companion_getInstance_26().q4h(211, 211, 211);
    this.b44_1 = Companion_getInstance_26().q4h(144, 238, 144);
    this.c44_1 = Companion_getInstance_26().q4h(211, 211, 211);
    this.d44_1 = Companion_getInstance_26().q4h(255, 182, 193);
    this.e44_1 = Companion_getInstance_26().q4h(255, 160, 122);
    this.f44_1 = Companion_getInstance_26().q4h(32, 178, 170);
    this.g44_1 = Companion_getInstance_26().q4h(135, 206, 250);
    this.h44_1 = Companion_getInstance_26().q4h(119, 136, 153);
    this.i44_1 = Companion_getInstance_26().q4h(119, 136, 153);
    this.j44_1 = Companion_getInstance_26().q4h(176, 196, 222);
    this.k44_1 = Companion_getInstance_26().q4h(255, 255, 224);
    this.l44_1 = Companion_getInstance_26().q4h(0, 255, 0);
    this.m44_1 = Companion_getInstance_26().q4h(50, 205, 50);
    this.n44_1 = Companion_getInstance_26().q4h(250, 240, 230);
    this.o44_1 = Companion_getInstance_26().q4h(128, 0, 0);
    this.p44_1 = Companion_getInstance_26().q4h(102, 205, 170);
    this.q44_1 = Companion_getInstance_26().q4h(0, 0, 205);
    this.r44_1 = Companion_getInstance_26().q4h(186, 85, 211);
    this.s44_1 = Companion_getInstance_26().q4h(147, 112, 219);
    this.t44_1 = Companion_getInstance_26().q4h(60, 179, 113);
    this.u44_1 = Companion_getInstance_26().q4h(123, 104, 238);
    this.v44_1 = Companion_getInstance_26().q4h(0, 250, 154);
    this.w44_1 = Companion_getInstance_26().q4h(72, 209, 204);
    this.x44_1 = Companion_getInstance_26().q4h(199, 21, 133);
    this.y44_1 = Companion_getInstance_26().q4h(25, 25, 112);
    this.z44_1 = Companion_getInstance_26().q4h(245, 255, 250);
    this.a45_1 = Companion_getInstance_26().q4h(255, 228, 225);
    this.b45_1 = Companion_getInstance_26().q4h(255, 228, 181);
    this.c45_1 = Companion_getInstance_26().q4h(255, 222, 173);
    this.d45_1 = Companion_getInstance_26().q4h(0, 0, 128);
    this.e45_1 = Companion_getInstance_26().q4h(253, 245, 230);
    this.f45_1 = Companion_getInstance_26().q4h(128, 128, 0);
    this.g45_1 = Companion_getInstance_26().q4h(107, 142, 35);
    this.h45_1 = Companion_getInstance_26().q4h(255, 165, 0);
    this.i45_1 = Companion_getInstance_26().q4h(255, 69, 0);
    this.j45_1 = Companion_getInstance_26().q4h(218, 112, 214);
    this.k45_1 = Companion_getInstance_26().q4h(238, 232, 170);
    this.l45_1 = Companion_getInstance_26().q4h(152, 251, 152);
    this.m45_1 = Companion_getInstance_26().q4h(175, 238, 238);
    this.n45_1 = Companion_getInstance_26().q4h(219, 112, 147);
    this.o45_1 = Companion_getInstance_26().q4h(255, 239, 213);
    this.p45_1 = Companion_getInstance_26().q4h(255, 218, 185);
    this.q45_1 = Companion_getInstance_26().q4h(205, 133, 63);
    this.r45_1 = Companion_getInstance_26().q4h(255, 192, 203);
    this.s45_1 = Companion_getInstance_26().q4h(221, 160, 221);
    this.t45_1 = Companion_getInstance_26().q4h(176, 224, 230);
    this.u45_1 = Companion_getInstance_26().q4h(128, 0, 128);
    this.v45_1 = Companion_getInstance_26().q4h(188, 143, 143);
    this.w45_1 = Companion_getInstance_26().q4h(65, 105, 225);
    this.x45_1 = Companion_getInstance_26().q4h(139, 69, 19);
    this.y45_1 = Companion_getInstance_26().q4h(250, 128, 114);
    this.z45_1 = Companion_getInstance_26().q4h(244, 164, 96);
    this.a46_1 = Companion_getInstance_26().q4h(46, 139, 87);
    this.b46_1 = Companion_getInstance_26().q4h(255, 245, 238);
    this.c46_1 = Companion_getInstance_26().q4h(160, 82, 45);
    this.d46_1 = Companion_getInstance_26().q4h(192, 192, 192);
    this.e46_1 = Companion_getInstance_26().q4h(135, 206, 235);
    this.f46_1 = Companion_getInstance_26().q4h(106, 90, 205);
    this.g46_1 = Companion_getInstance_26().q4h(112, 128, 144);
    this.h46_1 = Companion_getInstance_26().q4h(112, 128, 144);
    this.i46_1 = Companion_getInstance_26().q4h(255, 250, 250);
    this.j46_1 = Companion_getInstance_26().q4h(0, 255, 127);
    this.k46_1 = Companion_getInstance_26().q4h(70, 130, 180);
    this.l46_1 = Companion_getInstance_26().q4h(210, 180, 140);
    this.m46_1 = Companion_getInstance_26().q4h(0, 128, 128);
    this.n46_1 = Companion_getInstance_26().q4h(216, 191, 216);
    this.o46_1 = Companion_getInstance_26().q4h(255, 99, 71);
    this.p46_1 = Companion_getInstance_26().q4h(64, 224, 208);
    this.q46_1 = Companion_getInstance_26().q4h(238, 130, 238);
    this.r46_1 = Companion_getInstance_26().q4h(245, 222, 179);
    this.s46_1 = Companion_getInstance_26().q4h(245, 245, 245);
    this.t46_1 = Companion_getInstance_26().q4h(154, 205, 50);
    this.u46_1 = Companion_getInstance_26().q4h(255, 255, 0);
    this.v46_1 = mapOf([to('black', new RGBA(this.f41_1)), to('white', new RGBA(this.e41_1)), to('red', new RGBA(this.g41_1)), to('green', new RGBA(this.h41_1)), to('blue', new RGBA(this.i41_1)), to('aliceblue', new RGBA(this.l41_1)), to('antiquewhite', new RGBA(this.m41_1)), to('aqua', new RGBA(this.n41_1)), to('aquamarine', new RGBA(this.o41_1)), to('azure', new RGBA(this.p41_1)), to('beige', new RGBA(this.q41_1)), to('bisque', new RGBA(this.r41_1)), to('blanchedalmond', new RGBA(this.s41_1)), to('blueviolet', new RGBA(this.t41_1)), to('brown', new RGBA(this.u41_1)), to('burlywood', new RGBA(this.v41_1)), to('cadetblue', new RGBA(this.w41_1)), to('chartreuse', new RGBA(this.x41_1)), to('chocolate', new RGBA(this.y41_1)), to('coral', new RGBA(this.z41_1)), to('cornflowerblue', new RGBA(this.a42_1)), to('cornsilk', new RGBA(this.b42_1)), to('crimson', new RGBA(this.c42_1)), to('cyan', new RGBA(this.e42_1)), to('darkblue', new RGBA(this.d42_1)), to('darkcyan', new RGBA(this.f42_1)), to('darkgoldenrod', new RGBA(this.g42_1)), to('darkgray', new RGBA(this.h42_1)), to('darkgreen', new RGBA(this.i42_1)), to('darkgrey', new RGBA(this.j42_1)), to('darkkhaki', new RGBA(this.k42_1)), to('darkmagenta', new RGBA(this.m42_1)), to('darkolivegreen', new RGBA(this.n42_1)), to('darkorange', new RGBA(this.o42_1)), to('darkorchid', new RGBA(this.p42_1)), to('darkred', new RGBA(this.q42_1)), to('darksalmon', new RGBA(this.r42_1)), to('darkseagreen', new RGBA(this.s42_1)), to('darkslateblue', new RGBA(this.t42_1)), to('darkslategray', new RGBA(this.u42_1)), to('darkslategrey', new RGBA(this.v42_1)), to('darkturquoise', new RGBA(this.w42_1)), to('darkviolet', new RGBA(this.x42_1)), to('deeppink', new RGBA(this.y42_1)), to('deepskyblue', new RGBA(this.z42_1)), to('dimgray', new RGBA(this.a43_1)), to('dimgrey', new RGBA(this.b43_1)), to('dodgerblue', new RGBA(this.c43_1)), to('firebrick', new RGBA(this.d43_1)), to('floralwhite', new RGBA(this.e43_1)), to('forestgreen', new RGBA(this.f43_1)), to('fuchsia', new RGBA(this.g43_1)), to('gainsboro', new RGBA(this.h43_1)), to('ghostwhite', new RGBA(this.i43_1)), to('gold', new RGBA(this.j43_1)), to('goldenrod', new RGBA(this.k43_1)), to('greenyellow', new RGBA(this.l43_1)), to('honeydew', new RGBA(this.m43_1)), to('hotpink', new RGBA(this.n43_1)), to('indianred', new RGBA(this.o43_1)), to('indigo', new RGBA(this.p43_1)), to('ivory', new RGBA(this.q43_1)), to('khaki', new RGBA(this.r43_1)), to('lavender', new RGBA(this.s43_1)), to('lavenderblush', new RGBA(this.t43_1)), to('lawngreen', new RGBA(this.u43_1)), to('lemonchiffon', new RGBA(this.v43_1)), to('lightblue', new RGBA(this.w43_1)), to('lightcoral', new RGBA(this.x43_1)), to('lightcyan', new RGBA(this.y43_1)), to('lightgoldenrodyellow', new RGBA(this.z43_1)), to('lightgray', new RGBA(this.a44_1)), to('lightgreen', new RGBA(this.b44_1)), to('lightgrey', new RGBA(this.c44_1)), to('lightpink', new RGBA(this.d44_1)), to('lightsalmon', new RGBA(this.e44_1)), to('lightseagreen', new RGBA(this.f44_1)), to('lightskyblue', new RGBA(this.g44_1)), to('lightslategray', new RGBA(this.h44_1)), to('lightslategrey', new RGBA(this.i44_1)), to('lightsteelblue', new RGBA(this.j44_1)), to('lightyellow', new RGBA(this.k44_1)), to('lime', new RGBA(this.l44_1)), to('limegreen', new RGBA(this.m44_1)), to('linen', new RGBA(this.n44_1)), to('magenta', new RGBA(this.l42_1)), to('maroon', new RGBA(this.o44_1)), to('mediumaquamarine', new RGBA(this.p44_1)), to('mediumblue', new RGBA(this.q44_1)), to('mediumorchid', new RGBA(this.r44_1)), to('mediumpurple', new RGBA(this.s44_1)), to('mediumseagreen', new RGBA(this.t44_1)), to('mediumslateblue', new RGBA(this.u44_1)), to('mediumspringgreen', new RGBA(this.v44_1)), to('mediumturquoise', new RGBA(this.w44_1)), to('mediumvioletred', new RGBA(this.x44_1)), to('midnightblue', new RGBA(this.y44_1)), to('mintcream', new RGBA(this.z44_1)), to('mistyrose', new RGBA(this.a45_1)), to('moccasin', new RGBA(this.b45_1)), to('navajowhite', new RGBA(this.c45_1)), to('navy', new RGBA(this.d45_1)), to('oldlace', new RGBA(this.e45_1)), to('olive', new RGBA(this.f45_1)), to('olivedrab', new RGBA(this.g45_1)), to('orange', new RGBA(this.h45_1)), to('orangered', new RGBA(this.i45_1)), to('orchid', new RGBA(this.j45_1)), to('palegoldenrod', new RGBA(this.k45_1)), to('palegreen', new RGBA(this.l45_1)), to('paleturquoise', new RGBA(this.m45_1)), to('palevioletred', new RGBA(this.n45_1)), to('papayawhip', new RGBA(this.o45_1)), to('peachpuff', new RGBA(this.p45_1)), to('peru', new RGBA(this.q45_1)), to('pink', new RGBA(this.r45_1)), to('plum', new RGBA(this.s45_1)), to('powderblue', new RGBA(this.t45_1)), to('purple', new RGBA(this.u45_1)), to('rosybrown', new RGBA(this.v45_1)), to('royalblue', new RGBA(this.w45_1)), to('saddlebrown', new RGBA(this.x45_1)), to('salmon', new RGBA(this.y45_1)), to('sandybrown', new RGBA(this.z45_1)), to('seagreen', new RGBA(this.a46_1)), to('seashell', new RGBA(this.b46_1)), to('sienna', new RGBA(this.c46_1)), to('silver', new RGBA(this.d46_1)), to('skyblue', new RGBA(this.e46_1)), to('slateblue', new RGBA(this.f46_1)), to('slategray', new RGBA(this.g46_1)), to('slategrey', new RGBA(this.h46_1)), to('snow', new RGBA(this.i46_1)), to('springgreen', new RGBA(this.j46_1)), to('steelblue', new RGBA(this.k46_1)), to('tan', new RGBA(this.l46_1)), to('teal', new RGBA(this.m46_1)), to('thistle', new RGBA(this.n46_1)), to('tomato', new RGBA(this.o46_1)), to('turquoise', new RGBA(this.p46_1)), to('violet', new RGBA(this.q46_1)), to('wheat', new RGBA(this.r46_1)), to('whitesmoke', new RGBA(this.s46_1)), to('yellowgreen', new RGBA(this.t46_1)), to('yellow', new RGBA(this.u46_1))]);
  }
  r4h(str) {
    return this.s4h(str, this.j41_1, true);
  }
  s4h(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).z2(hex.length))
          return this.f41_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt_0(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt_0(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt_0(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt_0(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_26().o4f(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split_0(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.e1() : false) {
          tmp = parts.d1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.e1() : false) {
          tmp_0 = parts.d1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.e1() : false) {
          tmp_1 = parts.d1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.e1() : false) {
          tmp_2 = parts.d1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_26().o4f(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.v46_1.f3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.t4h_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.u4h('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().g41_1;
      } else {
        throw $p;
      }
    }
  }
  u4h(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.s4h(str, default_0, errorOnDefault) : $super.s4h.call(this, str, new RGBA(default_0), errorOnDefault).t4h_1;
  }
}
class MaterialColors {
  constructor() {
    MaterialColors_instance = this;
    this.v4h_1 = Colors_getInstance().r4h('#FFEBEE');
    this.w4h_1 = Colors_getInstance().r4h('#FFCDD2');
    this.x4h_1 = Colors_getInstance().r4h('#EF9A9A');
    this.y4h_1 = Colors_getInstance().r4h('#E57373');
    this.z4h_1 = Colors_getInstance().r4h('#EF5350');
    this.a4i_1 = Colors_getInstance().r4h('#F44336');
    this.b4i_1 = Colors_getInstance().r4h('#E53935');
    this.c4i_1 = Colors_getInstance().r4h('#D32F2F');
    this.d4i_1 = Colors_getInstance().r4h('#C62828');
    this.e4i_1 = Colors_getInstance().r4h('#B71C1C');
    this.f4i_1 = Colors_getInstance().r4h('#FF8A80');
    this.g4i_1 = Colors_getInstance().r4h('#FF5252');
    this.h4i_1 = Colors_getInstance().r4h('#FF1744');
    this.i4i_1 = Colors_getInstance().r4h('#D50000');
    this.j4i_1 = Colors_getInstance().r4h('#FCE4EC');
    this.k4i_1 = Colors_getInstance().r4h('#F8BBD0');
    this.l4i_1 = Colors_getInstance().r4h('#F48FB1');
    this.m4i_1 = Colors_getInstance().r4h('#F06292');
    this.n4i_1 = Colors_getInstance().r4h('#EC407A');
    this.o4i_1 = Colors_getInstance().r4h('#E91E63');
    this.p4i_1 = Colors_getInstance().r4h('#D81B60');
    this.q4i_1 = Colors_getInstance().r4h('#C2185B');
    this.r4i_1 = Colors_getInstance().r4h('#AD1457');
    this.s4i_1 = Colors_getInstance().r4h('#880E4F');
    this.t4i_1 = Colors_getInstance().r4h('#FF80AB');
    this.u4i_1 = Colors_getInstance().r4h('#FF4081');
    this.v4i_1 = Colors_getInstance().r4h('#F50057');
    this.w4i_1 = Colors_getInstance().r4h('#C51162');
    this.x4i_1 = Colors_getInstance().r4h('#F3E5F5');
    this.y4i_1 = Colors_getInstance().r4h('#E1BEE7');
    this.z4i_1 = Colors_getInstance().r4h('#CE93D8');
    this.a4j_1 = Colors_getInstance().r4h('#BA68C8');
    this.b4j_1 = Colors_getInstance().r4h('#AB47BC');
    this.c4j_1 = Colors_getInstance().r4h('#9C27B0');
    this.d4j_1 = Colors_getInstance().r4h('#8E24AA');
    this.e4j_1 = Colors_getInstance().r4h('#7B1FA2');
    this.f4j_1 = Colors_getInstance().r4h('#6A1B9A');
    this.g4j_1 = Colors_getInstance().r4h('#4A148C');
    this.h4j_1 = Colors_getInstance().r4h('#EA80FC');
    this.i4j_1 = Colors_getInstance().r4h('#E040FB');
    this.j4j_1 = Colors_getInstance().r4h('#D500F9');
    this.k4j_1 = Colors_getInstance().r4h('#AA00FF');
    this.l4j_1 = Colors_getInstance().r4h('#EDE7F6');
    this.m4j_1 = Colors_getInstance().r4h('#D1C4E9');
    this.n4j_1 = Colors_getInstance().r4h('#B39DDB');
    this.o4j_1 = Colors_getInstance().r4h('#9575CD');
    this.p4j_1 = Colors_getInstance().r4h('#7E57C2');
    this.q4j_1 = Colors_getInstance().r4h('#673AB7');
    this.r4j_1 = Colors_getInstance().r4h('#5E35B1');
    this.s4j_1 = Colors_getInstance().r4h('#512DA8');
    this.t4j_1 = Colors_getInstance().r4h('#4527A0');
    this.u4j_1 = Colors_getInstance().r4h('#311B92');
    this.v4j_1 = Colors_getInstance().r4h('#B388FF');
    this.w4j_1 = Colors_getInstance().r4h('#7C4DFF');
    this.x4j_1 = Colors_getInstance().r4h('#651FFF');
    this.y4j_1 = Colors_getInstance().r4h('#6200EA');
    this.z4j_1 = Colors_getInstance().r4h('#E3F2FD');
    this.a4k_1 = Colors_getInstance().r4h('#BBDEFB');
    this.b4k_1 = Colors_getInstance().r4h('#90CAF9');
    this.c4k_1 = Colors_getInstance().r4h('#64B5F6');
    this.d4k_1 = Colors_getInstance().r4h('#42A5F5');
    this.e4k_1 = Colors_getInstance().r4h('#2196F3');
    this.f4k_1 = Colors_getInstance().r4h('#1E88E5');
    this.g4k_1 = Colors_getInstance().r4h('#1976D2');
    this.h4k_1 = Colors_getInstance().r4h('#1565C0');
    this.i4k_1 = Colors_getInstance().r4h('#0D47A1');
    this.j4k_1 = Colors_getInstance().r4h('#82B1FF');
    this.k4k_1 = Colors_getInstance().r4h('#448AFF');
    this.l4k_1 = Colors_getInstance().r4h('#2979FF');
    this.m4k_1 = Colors_getInstance().r4h('#2962FF');
    this.n4k_1 = Colors_getInstance().r4h('#E1F5FE');
    this.o4k_1 = Colors_getInstance().r4h('#B3E5FC');
    this.p4k_1 = Colors_getInstance().r4h('#81D4FA');
    this.q4k_1 = Colors_getInstance().r4h('#4FC3F7');
    this.r4k_1 = Colors_getInstance().r4h('#29B6F6');
    this.s4k_1 = Colors_getInstance().r4h('#03A9F4');
    this.t4k_1 = Colors_getInstance().r4h('#039BE5');
    this.u4k_1 = Colors_getInstance().r4h('#0288D1');
    this.v4k_1 = Colors_getInstance().r4h('#0277BD');
    this.w4k_1 = Colors_getInstance().r4h('#01579B');
    this.x4k_1 = Colors_getInstance().r4h('#80D8FF');
    this.y4k_1 = Colors_getInstance().r4h('#40C4FF');
    this.z4k_1 = Colors_getInstance().r4h('#00B0FF');
    this.a4l_1 = Colors_getInstance().r4h('#0091EA');
    this.b4l_1 = Colors_getInstance().r4h('#E0F7FA');
    this.c4l_1 = Colors_getInstance().r4h('#B2EBF2');
    this.d4l_1 = Colors_getInstance().r4h('#80DEEA');
    this.e4l_1 = Colors_getInstance().r4h('#4DD0E1');
    this.f4l_1 = Colors_getInstance().r4h('#26C6DA');
    this.g4l_1 = Colors_getInstance().r4h('#00BCD4');
    this.h4l_1 = Colors_getInstance().r4h('#00ACC1');
    this.i4l_1 = Colors_getInstance().r4h('#0097A7');
    this.j4l_1 = Colors_getInstance().r4h('#00838F');
    this.k4l_1 = Colors_getInstance().r4h('#006064');
    this.l4l_1 = Colors_getInstance().r4h('#84FFFF');
    this.m4l_1 = Colors_getInstance().r4h('#18FFFF');
    this.n4l_1 = Colors_getInstance().r4h('#00E5FF');
    this.o4l_1 = Colors_getInstance().r4h('#00B8D4');
    this.p4l_1 = Colors_getInstance().r4h('#E0F2F1');
    this.q4l_1 = Colors_getInstance().r4h('#B2DFDB');
    this.r4l_1 = Colors_getInstance().r4h('#80CBC4');
    this.s4l_1 = Colors_getInstance().r4h('#4DB6AC');
    this.t4l_1 = Colors_getInstance().r4h('#26A69A');
    this.u4l_1 = Colors_getInstance().r4h('#009688');
    this.v4l_1 = Colors_getInstance().r4h('#00897B');
    this.w4l_1 = Colors_getInstance().r4h('#00796B');
    this.x4l_1 = Colors_getInstance().r4h('#00695C');
    this.y4l_1 = Colors_getInstance().r4h('#004D40');
    this.z4l_1 = Colors_getInstance().r4h('#A7FFEB');
    this.a4m_1 = Colors_getInstance().r4h('#64FFDA');
    this.b4m_1 = Colors_getInstance().r4h('#1DE9B6');
    this.c4m_1 = Colors_getInstance().r4h('#00BFA5');
    this.d4m_1 = Colors_getInstance().r4h('#E8F5E9');
    this.e4m_1 = Colors_getInstance().r4h('#C8E6C9');
    this.f4m_1 = Colors_getInstance().r4h('#A5D6A7');
    this.g4m_1 = Colors_getInstance().r4h('#81C784');
    this.h4m_1 = Colors_getInstance().r4h('#66BB6A');
    this.i4m_1 = Colors_getInstance().r4h('#4CAF50');
    this.j4m_1 = Colors_getInstance().r4h('#43A047');
    this.k4m_1 = Colors_getInstance().r4h('#388E3C');
    this.l4m_1 = Colors_getInstance().r4h('#2E7D32');
    this.m4m_1 = Colors_getInstance().r4h('#1B5E20');
    this.n4m_1 = Colors_getInstance().r4h('#B9F6CA');
    this.o4m_1 = Colors_getInstance().r4h('#69F0AE');
    this.p4m_1 = Colors_getInstance().r4h('#00E676');
    this.q4m_1 = Colors_getInstance().r4h('#00C853');
    this.r4m_1 = Colors_getInstance().r4h('#F1F8E9');
    this.s4m_1 = Colors_getInstance().r4h('#DCEDC8');
    this.t4m_1 = Colors_getInstance().r4h('#C5E1A5');
    this.u4m_1 = Colors_getInstance().r4h('#AED581');
    this.v4m_1 = Colors_getInstance().r4h('#9CCC65');
    this.w4m_1 = Colors_getInstance().r4h('#8BC34A');
    this.x4m_1 = Colors_getInstance().r4h('#7CB342');
    this.y4m_1 = Colors_getInstance().r4h('#689F38');
    this.z4m_1 = Colors_getInstance().r4h('#558B2F');
    this.a4n_1 = Colors_getInstance().r4h('#33691E');
    this.b4n_1 = Colors_getInstance().r4h('#CCFF90');
    this.c4n_1 = Colors_getInstance().r4h('#B2FF59');
    this.d4n_1 = Colors_getInstance().r4h('#76FF03');
    this.e4n_1 = Colors_getInstance().r4h('#64DD17');
    this.f4n_1 = Colors_getInstance().r4h('#F9FBE7');
    this.g4n_1 = Colors_getInstance().r4h('#F0F4C3');
    this.h4n_1 = Colors_getInstance().r4h('#E6EE9C');
    this.i4n_1 = Colors_getInstance().r4h('#DCE775');
    this.j4n_1 = Colors_getInstance().r4h('#D4E157');
    this.k4n_1 = Colors_getInstance().r4h('#CDDC39');
    this.l4n_1 = Colors_getInstance().r4h('#C0CA33');
    this.m4n_1 = Colors_getInstance().r4h('#AFB42B');
    this.n4n_1 = Colors_getInstance().r4h('#9E9D24');
    this.o4n_1 = Colors_getInstance().r4h('#827717');
    this.p4n_1 = Colors_getInstance().r4h('#F4FF81');
    this.q4n_1 = Colors_getInstance().r4h('#EEFF41');
    this.r4n_1 = Colors_getInstance().r4h('#C6FF00');
    this.s4n_1 = Colors_getInstance().r4h('#AEEA00');
    this.t4n_1 = Colors_getInstance().r4h('#FFFDE7');
    this.u4n_1 = Colors_getInstance().r4h('#FFF9C4');
    this.v4n_1 = Colors_getInstance().r4h('#FFF59D');
    this.w4n_1 = Colors_getInstance().r4h('#FFF176');
    this.x4n_1 = Colors_getInstance().r4h('#FFEE58');
    this.y4n_1 = Colors_getInstance().r4h('#FFEB3B');
    this.z4n_1 = Colors_getInstance().r4h('#FDD835');
    this.a4o_1 = Colors_getInstance().r4h('#FBC02D');
    this.b4o_1 = Colors_getInstance().r4h('#F9A825');
    this.c4o_1 = Colors_getInstance().r4h('#F57F17');
    this.d4o_1 = Colors_getInstance().r4h('#FFFF8D');
    this.e4o_1 = Colors_getInstance().r4h('#FFFF00');
    this.f4o_1 = Colors_getInstance().r4h('#FFEA00');
    this.g4o_1 = Colors_getInstance().r4h('#FFD600');
    this.h4o_1 = Colors_getInstance().r4h('#FFF8E1');
    this.i4o_1 = Colors_getInstance().r4h('#FFECB3');
    this.j4o_1 = Colors_getInstance().r4h('#FFE082');
    this.k4o_1 = Colors_getInstance().r4h('#FFD54F');
    this.l4o_1 = Colors_getInstance().r4h('#FFCA28');
    this.m4o_1 = Colors_getInstance().r4h('#FFC107');
    this.n4o_1 = Colors_getInstance().r4h('#FFB300');
    this.o4o_1 = Colors_getInstance().r4h('#FFA000');
    this.p4o_1 = Colors_getInstance().r4h('#FF8F00');
    this.q4o_1 = Colors_getInstance().r4h('#FF6F00');
    this.r4o_1 = Colors_getInstance().r4h('#FFE57F');
    this.s4o_1 = Colors_getInstance().r4h('#FFD740');
    this.t4o_1 = Colors_getInstance().r4h('#FFC400');
    this.u4o_1 = Colors_getInstance().r4h('#FFAB00');
    this.v4o_1 = Colors_getInstance().r4h('#FFF3E0');
    this.w4o_1 = Colors_getInstance().r4h('#FFE0B2');
    this.x4o_1 = Colors_getInstance().r4h('#FFCC80');
    this.y4o_1 = Colors_getInstance().r4h('#FFB74D');
    this.z4o_1 = Colors_getInstance().r4h('#FFA726');
    this.a4p_1 = Colors_getInstance().r4h('#FF9800');
    this.b4p_1 = Colors_getInstance().r4h('#FB8C00');
    this.c4p_1 = Colors_getInstance().r4h('#F57C00');
    this.d4p_1 = Colors_getInstance().r4h('#EF6C00');
    this.e4p_1 = Colors_getInstance().r4h('#E65100');
    this.f4p_1 = Colors_getInstance().r4h('#FFD180');
    this.g4p_1 = Colors_getInstance().r4h('#FFAB40');
    this.h4p_1 = Colors_getInstance().r4h('#FF9100');
    this.i4p_1 = Colors_getInstance().r4h('#FF6D00');
    this.j4p_1 = Colors_getInstance().r4h('#FBE9E7');
    this.k4p_1 = Colors_getInstance().r4h('#FFCCBC');
    this.l4p_1 = Colors_getInstance().r4h('#FFAB91');
    this.m4p_1 = Colors_getInstance().r4h('#FF8A65');
    this.n4p_1 = Colors_getInstance().r4h('#FF7043');
    this.o4p_1 = Colors_getInstance().r4h('#FF5722');
    this.p4p_1 = Colors_getInstance().r4h('#F4511E');
    this.q4p_1 = Colors_getInstance().r4h('#E64A19');
    this.r4p_1 = Colors_getInstance().r4h('#D84315');
    this.s4p_1 = Colors_getInstance().r4h('#BF360C');
    this.t4p_1 = Colors_getInstance().r4h('#FF9E80');
    this.u4p_1 = Colors_getInstance().r4h('#FF6E40');
    this.v4p_1 = Colors_getInstance().r4h('#FF3D00');
    this.w4p_1 = Colors_getInstance().r4h('#DD2C00');
    this.x4p_1 = Colors_getInstance().r4h('#EFEBE9');
    this.y4p_1 = Colors_getInstance().r4h('#EFEBE9');
    this.z4p_1 = Colors_getInstance().r4h('#D7CCC8');
    this.a4q_1 = Colors_getInstance().r4h('#BCAAA4');
    this.b4q_1 = Colors_getInstance().r4h('#8D6E63');
    this.c4q_1 = Colors_getInstance().r4h('#795548');
    this.d4q_1 = Colors_getInstance().r4h('#6D4C41');
    this.e4q_1 = Colors_getInstance().r4h('#5D4037');
    this.f4q_1 = Colors_getInstance().r4h('#4E342E');
    this.g4q_1 = Colors_getInstance().r4h('#3E2723');
    this.h4q_1 = Colors_getInstance().r4h('#FAFAFA');
    this.i4q_1 = Colors_getInstance().r4h('#F5F5F5');
    this.j4q_1 = Colors_getInstance().r4h('#EEEEEE');
    this.k4q_1 = Colors_getInstance().r4h('#E0E0E0');
    this.l4q_1 = Colors_getInstance().r4h('#BDBDBD');
    this.m4q_1 = Colors_getInstance().r4h('#9E9E9E');
    this.n4q_1 = Colors_getInstance().r4h('#757575');
    this.o4q_1 = Colors_getInstance().r4h('#616161');
    this.p4q_1 = Colors_getInstance().r4h('#424242');
    this.q4q_1 = Colors_getInstance().r4h('#212121');
    this.r4q_1 = Colors_getInstance().r4h('#ECEFF1');
    this.s4q_1 = Colors_getInstance().r4h('#CFD8DC');
    this.t4q_1 = Colors_getInstance().r4h('#B0BEC5');
    this.u4q_1 = Colors_getInstance().r4h('#90A4AE');
    this.v4q_1 = Colors_getInstance().r4h('#78909C');
    this.w4q_1 = Colors_getInstance().r4h('#607D8B');
    this.x4q_1 = Colors_getInstance().r4h('#546E7A');
    this.y4q_1 = Colors_getInstance().r4h('#455A64');
    this.z4q_1 = Colors_getInstance().r4h('#37474F');
    this.a4r_1 = Colors_getInstance().r4h('#263238');
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_24();
    super();
    this.c4r_1 = rOffset;
    this.d4r_1 = gOffset;
    this.e4r_1 = bOffset;
  }
  z4f(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.c4r_1 | 0) & 255;
  }
  a4g(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.d4r_1 | 0) & 255;
  }
  b4g(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.e4r_1 | 0) & 255;
  }
  c4g(v) {
    return 255;
  }
}
class Companion_8 extends RGB {
  constructor() {
    Companion_instance_14 = null;
    super(0, 8, 16);
    Companion_instance_14 = this;
  }
}
class Companion_9 {
  f4b(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.f4r_1 = ints;
  }
  c3(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.f4r_1, fromIndex, toIndex);
  }
  g4r(element) {
    return RgbaArray__contains_impl_ofn00n(this.f4r_1, element);
  }
  z2(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  h4r(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.f4r_1, elements);
  }
  a3(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  i4r(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.f4r_1, element);
  }
  l1(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  g1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.f4r_1);
  }
  a1() {
    return RgbaArray__iterator_impl_5wfwsm(this.f4r_1);
  }
  b3() {
    return RgbaArray__listIterator_impl_m4kjt0(this.f4r_1);
  }
  i1(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.f4r_1, index);
  }
  e1() {
    return _RgbaArray___get_size__impl__imxef8(this.f4r_1);
  }
  j4r(index) {
    return RgbaArray__get_impl_nzyo1o(this.f4r_1, index);
  }
  d1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.f4r_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.f4r_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.f4r_1, other);
  }
}
class Companion_10 extends ColorFormat32 {
  constructor() {
    Companion_instance_16 = null;
    super();
    Companion_instance_16 = this;
    this.x46_1 = 0;
    this.y46_1 = 8;
    this.z46_1 = 16;
    this.a47_1 = 24;
  }
  s4c(r, g, b, a) {
    return this.m4r(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  m4r(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  o4f(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  q4h(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  n4r(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  z4f(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  a4g(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  b4g(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  c4g(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  o4r(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.p4r(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  p4r(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  q4r(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.o4r(c1, c2, tmp$ret$0);
  }
  r4r(c1, c2, factor) {
    return Companion_getInstance_26().n4r(_RGBA___get_rgb__impl__tijaqt(this.q4r(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  b47(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.r4r(c00, c10, factorX);
    var c2 = this.r4r(c01, c11, factorX);
    return this.r4r(c1, c2, factorY);
  }
  n4f(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_26().n4r(_RGBA___get_rgb__impl__tijaqt(this.o4r(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  l4r(c1, c2) {
    return Companion_getInstance_26().o4f(imul(_RGBA___get_r__impl__duz7mo(c1), _RGBA___get_r__impl__duz7mo(c2)) / 255 | 0, imul(_RGBA___get_g__impl__o8pukr(c1), _RGBA___get_g__impl__o8pukr(c2)) / 255 | 0, imul(_RGBA___get_b__impl__m6tl80(c1), _RGBA___get_b__impl__m6tl80(c2)) / 255 | 0, imul(_RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2)) / 255 | 0);
  }
  k4r(src, dst, ratio) {
    return Companion_getInstance_26().o4f(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_26();
    this.t4h_1 = value;
  }
  wx() {
    return RGBA__clone_impl_w007z0(this.t4h_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.t4h_1);
  }
  s4r(other) {
    return RGBA__compareTo_impl_lrfjc1(this.t4h_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.t4h_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.t4h_1, other);
  }
}
class Companion_11 {
  constructor() {
    this.t4r_1 = 16711935;
    this.u4r_1 = -16711936;
  }
  v4r(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_12 {
  w4r(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.x4r_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.x4r_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.x4r_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.x4r_1, other);
  }
}
class Companion_13 {
  y4r(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_14 {}
class Kerning {
  constructor(first, second, amount) {
    this.h4s_1 = first;
    this.i4s_1 = second;
    this.j4s_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.z4r_1 = fontSize;
    this.a4s_1 = id;
    this.b4s_1 = texture;
    this.c4s_1 = xoffset;
    this.d4s_1 = yoffset;
    this.e4s_1 = xadvance;
    var tmp = this;
    tmp.f4s_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.g4s_1 = new GlyphMetrics(this.z4r_1, true, -1, Companion_getInstance_2().e2e(this.c4s_1, this.d4s_1, this.b4s_1.x3f_1, this.b4s_1.y3f_1), this.e4s_1);
  }
  k4s() {
    return this.b4s_1.x3f_1;
  }
  l4s() {
    return this.b4s_1.y3f_1;
  }
  m4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4s_1;
    bmp$factory();
    return this_0.u1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.z4r_1 + ', id=' + this.a4s_1 + ', texture=' + this.b4s_1.toString() + ', xoffset=' + this.c4s_1 + ', yoffset=' + this.d4s_1 + ', xadvance=' + this.e4s_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z4r_1);
    result = imul(result, 31) + this.a4s_1 | 0;
    result = imul(result, 31) + this.b4s_1.hashCode() | 0;
    result = imul(result, 31) + this.c4s_1 | 0;
    result = imul(result, 31) + this.d4s_1 | 0;
    result = imul(result, 31) + this.e4s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.z4r_1, tmp0_other_with_cast.z4r_1))
      return false;
    if (!(this.a4s_1 === tmp0_other_with_cast.a4s_1))
      return false;
    if (!this.b4s_1.equals(tmp0_other_with_cast.b4s_1))
      return false;
    if (!(this.c4s_1 === tmp0_other_with_cast.c4s_1))
      return false;
    if (!(this.d4s_1 === tmp0_other_with_cast.d4s_1))
      return false;
    if (!(this.e4s_1 === tmp0_other_with_cast.e4s_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.w4s(size, metrics) : $super.w4s.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.i4t(size, codePoint, metrics, reader) : $super.i4t.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.u4t(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.u4t.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.t4s().b4s_1);
}
function getFontMetrics(size, metrics) {
  return metrics.g4t(this.u4s(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.k2m(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.g4s_1;
  return metrics.o4t(tmp0_elvis_lhs == null ? this.v4s() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.n4s();
}
function get_1(charCode) {
  var tmp0_elvis_lhs = this.k2m(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.k2m(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.t4s() : tmp1_elvis_lhs;
}
function get_2(char) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(char);
  return this.d1(tmp$ret$0);
}
function getGlyph(char) {
  return this.s4t(char);
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.r4t(size);
  var tmp0_elvis_lhs = this.q4s().d1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.i4t(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.k4t_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.z2i() === 0.0 && metrics.a2j() === 0.0)
    return false;
  var texX = pos.m25_1 + metrics.d26();
  var texY = pos.n25_1 + metrics.f26();
  var swidth = metrics.z2i();
  var sheight = metrics.a2j();
  var tmp_1;
  if (equals(ctx.r4u(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.m4s();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.q3z(g.m4s().x3z_1, g.m4s().y3z_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.b40_1;
    if (true) {
      this_1.k40();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.t47(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.y47_1.v4t_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.q4u(1.0 / scale);
          ctx_0.s4u(ctx.r4u());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.z2i() * scale;
          var height = ctx_0.a2j() * scale;
          ctx_0.t4u(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.y47_1.v4t_1 = t;
        }
      }finally {
        ctx_0.l18();
      }
    }finally {
      result = true ? this_1.m40(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.z49(BitmapChannel_ALPHA_getInstance(), g.m4s(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.u4u(bmp, Vector2D.w27(texX, texY - metrics.g26()), Size2D.l2e(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.r4t(size);
  var tmp40_safe_receiver = this.q4t(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.j4s_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.x4u_1 = new Mixin();
    this.y4u_1 = fontSize;
    this.z4u_1 = lineHeight;
    this.a4v_1 = base;
    this.b4v_1 = glyphs;
    this.c4v_1 = kernings;
    this.d4v_1 = name;
    this.e4v_1 = distanceField;
    this.f4v_1 = this.z4u_1 - this.a4v_1;
    var tmp = this;
    tmp.g4v_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.h4v_1 = new GlyphMetrics(this.y4u_1, false, 0, Companion_getInstance_2().j29(), 0.0);
    var tmp_0 = this;
    tmp_0.i4v_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.j4v_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  ay(_set____db54di) {
    this.x4u_1.ay(_set____db54di);
  }
  by() {
    return this.x4u_1.by();
  }
  n4s() {
    return this.y4u_1;
  }
  o4s() {
    return this.z4u_1;
  }
  x3g() {
    return this.a4v_1;
  }
  q4s() {
    return this.b4v_1;
  }
  r4s() {
    return this.c4v_1;
  }
  s3() {
    return this.d4v_1;
  }
  p4s() {
    return this.e4v_1;
  }
  dz() {
    return this;
  }
  u4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g4v_1;
    naturalFontMetrics$factory();
    return this_0.u1();
  }
  v4s() {
    return this.h4v_1;
  }
  q4t(first, second) {
    return this.c4v_1.d1(Companion_instance_19.y4r(first, second));
  }
  k2m(codePoint) {
    return this.b4v_1.d1(codePoint);
  }
  t4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i4v_1;
    anyGlyph$factory();
    return this_0.u1();
  }
  k4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j4v_1;
    invalidGlyph$factory();
    return this_0.u1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.x4x_1 = bmp;
    this.y4x_1 = fmetrics;
    this.z4x_1 = metrics;
    this.a4y_1 = glyphs;
    this.b4y_1 = glyphsPerLine;
    this.c4y_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString(this.x4x_1) + ', fmetrics=' + this.y4x_1.toString() + ', metrics=' + this.z4x_1.toString() + ', glyphs=' + toString(this.a4y_1) + ', glyphsPerLine=' + toString(this.b4y_1) + ', shape=' + toString_0(this.c4y_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.x4x_1);
    result = imul(result, 31) + this.y4x_1.hashCode() | 0;
    result = imul(result, 31) + this.z4x_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a4y_1) | 0;
    result = imul(result, 31) + hashCode(this.b4y_1) | 0;
    result = imul(result, 31) + (this.c4y_1 == null ? 0 : hashCode(this.c4y_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.x4x_1, tmp0_other_with_cast.x4x_1))
      return false;
    if (!this.y4x_1.equals(tmp0_other_with_cast.y4x_1))
      return false;
    if (!this.z4x_1.equals(tmp0_other_with_cast.z4x_1))
      return false;
    if (!equals(this.a4y_1, tmp0_other_with_cast.a4y_1))
      return false;
    if (!equals(this.b4y_1, tmp0_other_with_cast.b4y_1))
      return false;
    if (!equals(this.c4y_1, tmp0_other_with_cast.c4y_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.o4y_1 = codePoint;
    this.p4y_1 = pos;
    this.q4y_1 = metrics;
    this.r4y_1 = fontMetrics;
    this.s4y_1 = transform;
    this.t4y_1 = index;
    this.u4y_1 = nline;
    var tmp = this;
    tmp.v4y_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.w4y_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x4y_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y4y_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  z4y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v4y_1;
    boundsPath$factory();
    return this_0.u1();
  }
  a4z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w4y_1;
    boundsPathCurves$factory();
    return this_0.u1();
  }
  b4z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x4y_1;
    caretStart$factory();
    return this_0.u1();
  }
  c4z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y4y_1;
    caretEnd$factory();
    return this_0.u1();
  }
  d4z(x, y, startEnd) {
    if (this.z4y().k3p(x, y))
      return 0.0;
    var tmp;
    switch (startEnd) {
      case true:
        tmp = this.b4z().h3b(Companion_getInstance_10().qx_1);
        break;
      case false:
        tmp = this.c4z().h3b(Companion_getInstance_10().qx_1);
        break;
      case null:
        // Inline function 'korlibs.math.geom.Companion.middle' call

        Companion_getInstance_0();
        var a = this.b4z().h3b(Companion_getInstance_10().qx_1);
        // Inline function 'korlibs.math.geom.Vector2D.times' call

        // Inline function 'korlibs.math.geom.Vector2D.plus' call

        var that = this.c4z().h3b(Companion_getInstance_10().qx_1);
        var this_0 = Vector2D.w27(a.m25_1 + that.m25_1, a.n25_1 + that.n25_1);
        tmp = Vector2D.w27(this_0.m25_1 * 0.5, this_0.n25_1 * 0.5);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var middle = tmp;
    return Companion_getInstance_0().n2f(middle.m25_1, middle.n25_1, x, y);
  }
  e4z(p, startEnd) {
    return this.d4z(p.m25_1, p.n25_1, startEnd);
  }
  f4z(p, startEnd, $super) {
    startEnd = startEnd === VOID ? null : startEnd;
    return $super === VOID ? this.e4z(p, startEnd) : $super.e4z.call(this, p, startEnd);
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.o4y_1 + ', pos=' + this.p4y_1.toString() + ', metrics=' + this.q4y_1.toString() + ', fontMetrics=' + this.r4y_1.toString() + ', transform=' + this.s4y_1.toString() + ', index=' + this.t4y_1 + ', nline=' + this.u4y_1 + ')';
  }
  hashCode() {
    var result = this.o4y_1;
    result = imul(result, 31) + this.p4y_1.hashCode() | 0;
    result = imul(result, 31) + this.q4y_1.hashCode() | 0;
    result = imul(result, 31) + this.r4y_1.hashCode() | 0;
    result = imul(result, 31) + this.s4y_1.hashCode() | 0;
    result = imul(result, 31) + this.t4y_1 | 0;
    result = imul(result, 31) + this.u4y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.o4y_1 === tmp0_other_with_cast.o4y_1))
      return false;
    if (!this.p4y_1.equals(tmp0_other_with_cast.p4y_1))
      return false;
    if (!this.q4y_1.equals(tmp0_other_with_cast.q4y_1))
      return false;
    if (!this.r4y_1.equals(tmp0_other_with_cast.r4y_1))
      return false;
    if (!this.s4y_1.equals(tmp0_other_with_cast.s4y_1))
      return false;
    if (!(this.t4y_1 === tmp0_other_with_cast.t4y_1))
      return false;
    if (!(this.u4y_1 === tmp0_other_with_cast.u4y_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.g4z_1 = fmetrics;
    this.h4z_1 = metrics;
    this.i4z_1 = glyphs;
    this.j4z_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.g4z_1.toString() + ', metrics=' + this.h4z_1.toString() + ', glyphs=' + toString(this.i4z_1) + ', glyphsPerLine=' + toString(this.j4z_1) + ')';
  }
  hashCode() {
    var result = this.g4z_1.hashCode();
    result = imul(result, 31) + this.h4z_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i4z_1) | 0;
    result = imul(result, 31) + hashCode(this.j4z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.g4z_1.equals(tmp0_other_with_cast.g4z_1))
      return false;
    if (!this.h4z_1.equals(tmp0_other_with_cast.h4z_1))
      return false;
    if (!equals(this.i4z_1, tmp0_other_with_cast.i4z_1))
      return false;
    if (!equals(this.j4z_1, tmp0_other_with_cast.j4z_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.l50_1 = FastArrayList.sy();
    this.m50_1 = FastArrayList.sy();
  }
  e1() {
    return this.l50_1.e1();
  }
  r51(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.l50_1.h(glyph);
    while (this.m50_1.e1() <= glyph.u4y_1) {
      this.m50_1.h(FastArrayList.sy());
    }
    this.m50_1.d1(glyph.u4y_1).h(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.b54(Companion_getInstance_0().o25_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.xw();
  var that = Vector2D.w27(x, 0.0);
  var tmp$ret$0 = Vector2D.w27(this_0.m25_1 + that.m25_1, this_0.n25_1 + that.n25_1);
  this.b54(tmp$ret$0);
}
function newLine(y, end) {
  this.b54(Vector2D.w27(0.0, this.xw().n25_1 + y));
  var _unary__edvuaz = this.t53();
  this.z53(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.j53_1 = new GlyphPath();
    this.k53_1 = new GlyphMetrics();
    this.l53_1 = new FontMetrics();
    this.m53_1 = 0;
    this.o53_1 = 0.0;
    this.p53_1 = Companion_getInstance_0().o25_1;
    this.q53_1 = Companion_getInstance_3().g29_1;
    this.r53_1 = null;
    this.s53_1 = Colors_getInstance().e41_1;
  }
  o4s() {
    return this.l53_1.o4s();
  }
  z53(_set____db54di) {
    this.m53_1 = _set____db54di;
  }
  t53() {
    return this.m53_1;
  }
  y53() {
    var tmp = this.n53_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  a54(font, size) {
    this.n53_1 = font;
    this.o53_1 = size;
    font.w4s(size, this.l53_1);
  }
  b54(_set____db54di) {
    this.p53_1 = _set____db54di;
  }
  xw() {
    return this.p53_1;
  }
  c54(reader, codePoint) {
    return this.y53().i4t(this.o53_1, codePoint, this.k53_1, reader);
  }
  d54(_set____db54di) {
    this.q53_1 = _set____db54di;
  }
  w53() {
    return this.q53_1;
  }
  q4t(leftCodePoint, rightCodePoint) {
    return this.y53().w4u(this.o53_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.y52_1 = $size;
    $box.z52_1 = $align;
    $box.a53_1 = $pos;
    $box.b53_1 = $ctx;
    $box.c53_1 = $paint;
    $box.d53_1 = $textRangeStart;
    $box.e53_1 = $textRangeEnd;
    $box.f53_1 = $doRender;
    $box.g53_1 = $glyphs;
    $box.h53_1 = $placed;
    super($box);
    this.w52_1 = measure($renderer, $text, $size, $fnt);
    this.x52_1 = 0;
  }
  i53(reader, codePoint) {
    var nline = this.t53();
    var dx = this.w52_1.u53(this.z52_1.i51_1, nline);
    var dy = this.w52_1.l51(this.z52_1.j51_1, this.l53_1);
    var px = this.xw().m25_1 + this.a53_1.m25_1 - dx;
    var py = this.xw().n25_1 + this.a53_1.n25_1 + dy;
    var tmp71_safe_receiver = this.b53_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.y47_1.v4t_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.b53_1.v53(px, py);
        this.b53_1.x53(get_immutable(this.w53()));
        var tmp0_elvis_lhs = this.r53_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.c53_1 : tmp0_elvis_lhs;
        this.b53_1.s4u(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.d53_1;
        var containsUpper = this.e53_1;
        var containsArg = this.x52_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.y53().u4t(this.b53_1, this.y52_1, codePoint, Companion_getInstance_0().o25_1, null, this.k53_1, reader, this.f53_1);
        }
        this.x52_1 = this.x52_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.y47_1.v4t_1 = t;
      }
    }
    if (!(this.g53_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.w27(px, py), this.k53_1.wx(), this.l53_1.wx(), this.w53(), this.g53_1.e1(), nline);
      this.g53_1.r51(glyph);
    }
    var tmp72_safe_receiver = this.h53_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.w27(px, py), this.y52_1, this.k53_1, this.l53_1, this.w53());
    return this.k53_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.j28(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.d2g(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_3().j29() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.g54_1 = path;
    this.h54_1 = colorShape;
    this.i54_1 = bitmap;
    this.j54_1 = bitmapOffset;
    this.k54_1 = bitmapScale;
    this.l54_1 = transform;
    this.m54_1 = scale;
  }
  n54() {
    return this.i54_1 == null && this.h54_1 == null;
  }
  o54(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.y47_1.v4t_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.x53(this.l54_1);
      if (!(this.i54_1 == null)) {
        c.u4u(ensureNotNull(this.i54_1), this.j54_1, toFloat(ensureNotNull(this.i54_1).e1()).r2g(this.k54_1));
      } else if (!(this.h54_1 == null)) {
        c.p54(ensureNotNull(this.h54_1));
        c.k50();
      } else {
        draw_1(c, this.g54_1);
      }
    }finally {
      c.y47_1.v4t_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.g54_1.toString() + ', colorShape=' + toString_0(this.h54_1) + ', bitmap=' + toString_0(this.i54_1) + ', bitmapOffset=' + this.j54_1.toString() + ', bitmapScale=' + this.k54_1.toString() + ', transform=' + this.l54_1.toString() + ', scale=' + this.m54_1 + ')';
  }
  hashCode() {
    var result = this.g54_1.hashCode();
    result = imul(result, 31) + (this.h54_1 == null ? 0 : hashCode(this.h54_1)) | 0;
    result = imul(result, 31) + (this.i54_1 == null ? 0 : hashCode(this.i54_1)) | 0;
    result = imul(result, 31) + this.j54_1.hashCode() | 0;
    result = imul(result, 31) + this.k54_1.hashCode() | 0;
    result = imul(result, 31) + this.l54_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.m54_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.g54_1.equals(tmp0_other_with_cast.g54_1))
      return false;
    if (!equals(this.h54_1, tmp0_other_with_cast.h54_1))
      return false;
    if (!equals(this.i54_1, tmp0_other_with_cast.i54_1))
      return false;
    if (!this.j54_1.equals(tmp0_other_with_cast.j54_1))
      return false;
    if (!this.k54_1.equals(tmp0_other_with_cast.k54_1))
      return false;
    if (!this.l54_1.equals(tmp0_other_with_cast.l54_1))
      return false;
    if (!equals(this.m54_1, tmp0_other_with_cast.m54_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.q54_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_31();
    distanceField = distanceField === VOID ? null : distanceField;
    this.r54_1 = new Mixin();
    this.s54_1 = font;
    this.t54_1 = fontSize;
    this.u54_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.t3z(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.u54_1 == null))
      this_0.v3y_1;
    else
      mipmaps(this_0.v3y_1);
    tmp.v54_1 = this_0;
    this.w54_1 = this.s54_1.h4t(this.t54_1);
    this.x54_1 = this.w54_1.o4s();
    this.y54_1 = this.w54_1.a4t_1;
    this.z54_1 = IntMap.v2o();
    this.a55_1 = IntMap.v2o();
    var tmp_0 = this;
    tmp_0.b55_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.c55_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.d55_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.e55_1 = new GlyphMetrics(this.t54_1, false, 0, Companion_getInstance_2().j29(), 0.0);
  }
  ay(_set____db54di) {
    this.r54_1.ay(_set____db54di);
  }
  by() {
    return this.r54_1.by();
  }
  n4s() {
    return this.t54_1;
  }
  p4s() {
    return this.u54_1;
  }
  o4s() {
    return this.x54_1;
  }
  x3g() {
    return this.y54_1;
  }
  q4s() {
    return this.z54_1;
  }
  r4s() {
    return this.a55_1;
  }
  t4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b55_1;
    anyGlyph$factory_0();
    return this_0.u1();
  }
  k4v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c55_1;
    invalidGlyph$factory_0();
    return this_0.u1();
  }
  s3() {
    return this.s54_1.s3();
  }
  u4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d55_1;
    naturalFontMetrics$factory_0();
    return this_0.u1();
  }
  v4s() {
    return this.e55_1;
  }
  q4t(first, second) {
    var kerning = this.s54_1.w4u(this.t54_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.a55_1;
      var key = Companion_instance_19.y4r(first, second);
      var res = this_0.d1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.p2o(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.d1(key));
    }
    return tmp;
  }
  k2m(codePoint) {
    if (this.z54_1.d1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.f55(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.f55(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.f55(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.g55(tmp$ret$6);
    }
    return this.z54_1.d1(codePoint);
  }
  f55(codePoint, range) {
    var containsLower = range.d2_1;
    if (codePoint <= range.e2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.a2k(coerceAtLeast(range.h2() - range.i2() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.i2();
      var last = range.h2();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.g2k(v);
        }
         while (!(v === last));
      this.g55(this_0.t2k());
    }
  }
  g55(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.v54_1.v3y_1;
    var rect = this_0.b40_1;
    if (true) {
      this_0.k40();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.z54_1;
        var res = this_1.d1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.u54_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.t54_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.s54_1;
          var tmp84_size = this.t54_1;
          var tmp85_paint = Colors_getInstance().e41_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.x4x_1.j40();
          var rbmp;
          switch (this.u54_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.c4y_1).h55(), bmp.x3z_1, bmp.y3z_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.c4y_1).h55(), bmp.x3z_1, bmp.y3z_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.v54_1.v3z(rbmp, Unit_instance);
          var slice = entry.n3y_1.d3h(border, border, entry.n3y_1.x3f_1 - border | 0, entry.n3y_1.y3f_1 - border | 0);
          var g = first(result_0.a4y_1);
          var m = g.q4y_1;
          var xadvance = m.n4t_1;
          var tmp$ret$1 = new Glyph(this.t54_1, codePoint, slice, -toIntRound(g.p4y_1.m25_1) | 0, -toIntRound(g.p4y_1.n25_1) | 0, toIntRound(xadvance));
          this_1.p2o(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.d1(codePoint));
      }
    }finally {
      result = true ? this_0.m40(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.x4s_1 = size;
    this.y4s_1 = top;
    this.z4s_1 = ascent;
    this.a4t_1 = baseline;
    this.b4t_1 = descent;
    this.c4t_1 = bottom;
    this.d4t_1 = lineGap;
    this.e4t_1 = maxWidth;
    this.f4t_1 = unitsPerEm;
  }
  i55() {
    // Inline function 'kotlin.math.max' call
    var a = this.z4s_1;
    var b = this.y4s_1;
    return Math.max(a, b);
  }
  j55() {
    // Inline function 'kotlin.math.min' call
    var a = this.b4t_1;
    var b = this.c4t_1;
    return Math.min(a, b);
  }
  k55() {
    return this.i55() - this.j55();
  }
  o4s() {
    return this.k55() + this.d4t_1;
  }
  r50(other) {
    return this.l55(other, 1.0);
  }
  g4t(other, size) {
    return this.l55(other, size / other.x4s_1);
  }
  l55(other, scale) {
    this.x4s_1 = other.x4s_1 * scale;
    this.y4s_1 = other.y4s_1 * scale;
    this.z4s_1 = other.z4s_1 * scale;
    this.a4t_1 = other.a4t_1 * scale;
    this.b4t_1 = other.b4t_1 * scale;
    this.c4t_1 = other.c4t_1 * scale;
    this.d4t_1 = other.d4t_1 * scale;
    this.f4t_1 = other.f4t_1 * scale;
    this.e4t_1 = other.e4t_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.tb('FontMetrics(');
    this_0.tb('size=' + niceStr(this.x4s_1, 1) + ', ');
    this_0.tb('top=' + niceStr(this.y4s_1, 1) + ', ');
    this_0.tb('ascent=' + niceStr(this.z4s_1, 1) + ', ');
    this_0.tb('baseline=' + niceStr(this.a4t_1, 1) + ', ');
    this_0.tb('descent=' + niceStr(this.b4t_1, 1) + ', ');
    this_0.tb('bottom=' + niceStr(this.c4t_1, 1) + ', ');
    this_0.tb('lineGap=' + niceStr(this.d4t_1, 1) + ', ');
    this_0.tb('unitsPerEm=' + niceStr(this.f4t_1, 1) + ', ');
    this_0.tb('maxWidth=' + niceStr(this.e4t_1, 1) + ', ');
    this_0.tb('lineHeight=' + niceStr(this.o4s(), 1));
    this_0.tb(')');
    return this_0.toString();
  }
  wx() {
    return this.m55();
  }
  n55(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  m55(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.x4s_1 : size;
    top = top === VOID ? this.y4s_1 : top;
    ascent = ascent === VOID ? this.z4s_1 : ascent;
    baseline = baseline === VOID ? this.a4t_1 : baseline;
    descent = descent === VOID ? this.b4t_1 : descent;
    bottom = bottom === VOID ? this.c4t_1 : bottom;
    lineGap = lineGap === VOID ? this.d4t_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.e4t_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.f4t_1 : unitsPerEm;
    return $super === VOID ? this.n55(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.n55.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.x4s_1);
    result = imul(result, 31) + getNumberHashCode(this.y4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b4t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c4t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.x4s_1, tmp0_other_with_cast.x4s_1))
      return false;
    if (!equals(this.y4s_1, tmp0_other_with_cast.y4s_1))
      return false;
    if (!equals(this.z4s_1, tmp0_other_with_cast.z4s_1))
      return false;
    if (!equals(this.a4t_1, tmp0_other_with_cast.a4t_1))
      return false;
    if (!equals(this.b4t_1, tmp0_other_with_cast.b4t_1))
      return false;
    if (!equals(this.c4t_1, tmp0_other_with_cast.c4t_1))
      return false;
    if (!equals(this.d4t_1, tmp0_other_with_cast.d4t_1))
      return false;
    if (!equals(this.e4t_1, tmp0_other_with_cast.e4t_1))
      return false;
    if (!equals(this.f4t_1, tmp0_other_with_cast.f4t_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_2().j29() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.j4t_1 = size;
    this.k4t_1 = existing;
    this.l4t_1 = codePoint;
    this.m4t_1 = bounds;
    this.n4t_1 = xadvance;
  }
  g26() {
    return this.m4t_1.g26();
  }
  d26() {
    return this.m4t_1.d26();
  }
  f26() {
    return this.m4t_1.f26();
  }
  z2i() {
    return this.m4t_1.y25_1;
  }
  a2j() {
    return this.m4t_1.z25_1;
  }
  wx() {
    return this.o55(VOID, VOID, VOID, this.m4t_1.wx());
  }
  o4t(other, size, codePoint) {
    return this.p55(other, size / other.j4t_1, codePoint);
  }
  p55(other, scale, codePoint) {
    this.j4t_1 = other.j4t_1;
    this.k4t_1 = other.k4t_1;
    this.l4t_1 = codePoint;
    this.m4t_1 = other.m4t_1.d2e(scale);
    this.n4t_1 = other.n4t_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.tb('GlyphMetrics(');
    this_0.tb('codePoint=' + this.l4t_1 + " ('" + toString_1(numberToChar(this.l4t_1)) + "'), ");
    this_0.tb('existing=' + this.k4t_1 + ', ');
    this_0.tb('xadvance=' + roundToInt(this.n4t_1) + ', ');
    this_0.tb('bounds=' + this.m4t_1.l2().toString());
    this_0.tb(')');
    return this_0.toString();
  }
  q55(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  o55(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.j4t_1 : size;
    existing = existing === VOID ? this.k4t_1 : existing;
    codePoint = codePoint === VOID ? this.l4t_1 : codePoint;
    bounds = bounds === VOID ? this.m4t_1 : bounds;
    xadvance = xadvance === VOID ? this.n4t_1 : xadvance;
    return $super === VOID ? this.q55(size, existing, codePoint, bounds, xadvance) : $super.q55.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.j4t_1);
    result = imul(result, 31) + getBooleanHashCode(this.k4t_1) | 0;
    result = imul(result, 31) + this.l4t_1 | 0;
    result = imul(result, 31) + this.m4t_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.j4t_1, tmp0_other_with_cast.j4t_1))
      return false;
    if (!(this.k4t_1 === tmp0_other_with_cast.k4t_1))
      return false;
    if (!(this.l4t_1 === tmp0_other_with_cast.l4t_1))
      return false;
    if (!this.m4t_1.equals(tmp0_other_with_cast.m4t_1))
      return false;
    if (!equals(this.n4t_1, tmp0_other_with_cast.n4t_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_2().j29() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.n50_1 = bounds;
    this.o50_1 = lineBounds;
    this.p50_1 = fontMetrics;
    this.q50_1 = nlines;
  }
  r55() {
    var tmp0_elvis_lhs = firstOrNull_1(this.o50_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_2().i26_1 : tmp0_elvis_lhs;
  }
  d26() {
    return this.n50_1.d26();
  }
  f26() {
    return this.n50_1.f26();
  }
  z2i() {
    return this.n50_1.y25_1;
  }
  a2j() {
    return this.n50_1.z25_1;
  }
  s55() {
    return -this.d26();
  }
  t55() {
    return this.r55().z25_1 + this.r55().f26();
  }
  q51() {
    return this.p50_1.z4s_1;
  }
  o4s() {
    return this.p50_1.o4s();
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.d26()) + ', ' + get_niceStr_0(this.f26()) + ', ' + get_niceStr_0(this.z2i()) + ', ' + get_niceStr_0(this.a2j()) + '][' + get_niceStr_0(this.s55()) + ', ' + get_niceStr_0(this.t55()) + ']';
  }
  hashCode() {
    var result = this.n50_1.hashCode();
    result = imul(result, 31) + hashCode(this.o50_1) | 0;
    result = imul(result, 31) + this.p50_1.hashCode() | 0;
    result = imul(result, 31) + this.q50_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.n50_1.equals(tmp0_other_with_cast.n50_1))
      return false;
    if (!equals(this.o50_1, tmp0_other_with_cast.o50_1))
      return false;
    if (!this.p50_1.equals(tmp0_other_with_cast.p50_1))
      return false;
    if (!(this.q50_1 === tmp0_other_with_cast.q50_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.w55_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp.x55_1 = toIntMap(destination);
  }
  d1(id) {
    return this.x55_1.d1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.y55_1 = path;
    this.z55_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.y55_1.toString() + ', advanceWidth=' + this.z55_1 + ')';
  }
  hashCode() {
    var result = this.y55_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.z55_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.y55_1.equals(tmp0_other_with_cast.y55_1))
      return false;
    if (!equals(this.z55_1, tmp0_other_with_cast.z55_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.a56_1 = charstringsIndex;
    this.b56_1 = globalSubrIndex;
    this.c56_1 = localSubrsIndex;
    this.d56_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.d56_1.f3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_1(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.e56_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.d56_1.f3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_1(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.f56_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  g56(index, flipY) {
    var evalCtx = new EvalContext(this.b56_1, this.c56_1, this.e56_1, this.f56_1, index);
    var vp = new VectorPath();
    var bytes = this.a56_1.d1(index);
    CharStringType2_instance.j56(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.x3p(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.t56_1);
  }
  v56(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.g56(index, flipY) : $super.g56.call(this, index, flipY);
  }
}
class DataIndex {
  static w56(offsets, bytes) {
    var $this = createThis(this);
    $this.h56_1 = offsets;
    $this.i56_1 = bytes;
    return $this;
  }
  static x56() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.w56(tmp, tmp$ret$1);
  }
  e1() {
    return this.h56_1.length - 1 | 0;
  }
  y56(index) {
    return this.h56_1[index + 1 | 0] - this.h56_1[index] | 0;
  }
  d1(index) {
    return copyOfRange(this.i56_1, this.h56_1[index], this.h56_1[index + 1 | 0]);
  }
  z56() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  a1() {
    return this.z56().a1();
  }
  toString() {
    var tmp = this.e1();
    var tmp_0 = toString(toList_0(this.h56_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.y56(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.w55_1 = id;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.c57_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp.d57_1 = toIntMap(destination);
  }
  d1(id) {
    var tmp0_elvis_lhs = this.d57_1.d1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.z4(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.x56() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.x56() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.k56_1 = globalSubrIndex;
    this.l56_1 = localSubrsIndex;
    this.m56_1 = defaultWidthX;
    this.n56_1 = nominalWidthX;
    this.o56_1 = index;
    this.p56_1 = heap;
    this.q56_1 = computeSubrBias(CharStringType2_instance, this.k56_1.e1());
    this.r56_1 = computeSubrBias(CharStringType2_instance, this.l56_1.e1());
    this.s56_1 = 0;
    this.t56_1 = this.m56_1;
    this.u56_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.c57_1 = id;
  }
}
class CFF {
  e57(_this__u8e3s4) {
    this.f57(_this__u8e3s4);
    var nameIndex = this.g57(_this__u8e3s4);
    var topDictIndex = this.g57(_this__u8e3s4);
    var topDictByte = topDictIndex.d1(0)[1];
    var topDict = this.h57(openFastStream(topDictIndex.d1(0)));
    var stringIndex = this.g57(_this__u8e3s4);
    var globalSubrIndex = this.g57(_this__u8e3s4);
    var privateSizeOffset = topDict.f3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.x56();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.d1(1);
      privateDict = this.h57(_this__u8e3s4.g1q(privateOffset, privateSize));
      var localSubrs = privateDict.f3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.g57(_this__u8e3s4.h1q(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.f3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.g57(_this__u8e3s4.h1q(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  f57(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.m1q();
    var versionMinor = _this__u8e3s4.m1q();
    var headerSize = _this__u8e3s4.m1q();
    var offsetSize = _this__u8e3s4.m1q();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().i57_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  j57(_this__u8e3s4) {
    return _this__u8e3s4.m1q();
  }
  k57(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.j57(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.m1q();
        break;
      case 2:
        tmp = _this__u8e3s4.o1q();
        break;
      case 3:
        tmp = _this__u8e3s4.p1q();
        break;
      case 4:
        tmp = _this__u8e3s4.q1q();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  g57(_this__u8e3s4) {
    var count = _this__u8e3s4.o1q();
    if (count === 0)
      return DataIndex.x56();
    var offSize = this.j57(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.a2k((coerceAtLeast(this_0.h2() - this_0.i2() | 0, 0) / this_0.f2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.i2();
    var nestedLast = this_0.h2();
    var stepArg = this_0.f2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.k57(_this__u8e3s4, offSize) - 1 | 0;
        this_1.g2k(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.k1q(offsets.p2k());
    return DataIndex.w56(offsets.t2k(), bytes);
  }
  h57(_this__u8e3s4) {
    var map = LinkedHashMap.gc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.h1();
    while (_this__u8e3s4.gw()) {
      var item = this.l57(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.i3(item, value);
        values.l3();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  l57(_this__u8e3s4) {
    var b0 = _this__u8e3s4.m1q();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_32();
      tmp = tmp_0.d1(b0 === 12 ? b0 << 8 | _this__u8e3s4.m1q() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.m1q() << 8 | _this__u8e3s4.m1q());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.m1q() << 24 | _this__u8e3s4.m1q() << 16 | _this__u8e3s4.m1q() << 8 | _this__u8e3s4.m1q();
    } else if (b0 === 30) {
      tmp = this.m57(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.m1q() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.m1q() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  n57(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.m1q() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.z4(toString(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.m1q();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.tb('E-');
              break;
            default:
              str.ub((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  m57(_this__u8e3s4, readHeader) {
    return toDouble(this.n57(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  o57(_this__u8e3s4, value) {
    _this__u8e3s4.i2l(_this__u8e3s4.e1() - 1 | 0, value);
  }
  p57(_this__u8e3s4) {
    return _this__u8e3s4.d1(_this__u8e3s4.e1() - 1 | 0);
  }
  q57(_this__u8e3s4) {
    return _this__u8e3s4.p3(_this__u8e3s4.e1() - 1 | 0);
  }
  r57(_this__u8e3s4, value) {
    _this__u8e3s4.sz(value);
  }
  s57(_this__u8e3s4, value) {
    _this__u8e3s4.sz(value);
  }
  t57(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.w3o();
    _this__u8e3s4.f6();
    _this__u8e3s4.q3d(lastPoint);
  }
  u57(_this__u8e3s4, x, y) {
    _this__u8e3s4.e3p(Vector2D.w27(x, y));
  }
  v57(_this__u8e3s4, x, y) {
    _this__u8e3s4.f3p(Vector2D.w27(x, y));
  }
  w57(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.r3d(Vector2D.w27(fcx1, fcy1), Vector2D.w27(fcx2, fcy2), Vector2D.w27(fax, fay));
  }
  x57(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.w3o().m25_1 + cx1;
    var fcy1 = _this__u8e3s4.w3o().n25_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.w57(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  y57(_this__u8e3s4, v, horizontal) {
    return this.u57(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  z57(_this__u8e3s4, v, horizontal) {
    return this.v57(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  a58(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.m1q();
  }
  b58(ctx, s, evalCtx, stack, stackLevel) {
    while (s.gw()) {
      var v0 = this.a58(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_33();
        var op = tmp.d1(v0 === 12 ? v0 << 8 | this.a58(s) : v0);
        switch (op.r3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.g1()) {
              tmp_0 = !evalCtx.u56_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.t56_1 = stack.d1(0) + evalCtx.n56_1;
              evalCtx.u56_1 = true;
            }

            if (!(ctx.v3o() === 0)) {
              this.t57(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.q57(stack));
            var bytes = global ? evalCtx.k56_1.d1(evalCtx.q56_1 + funcOffset | 0) : evalCtx.l56_1.d1(evalCtx.r56_1 + funcOffset | 0);
            this.b58(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.q57(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.q57(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.b2l(this_0, this_0);
            break;
          case 39:
            stack.r2k(stack.e1() - 2 | 0, stack.e1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.td();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.td();
          case 25:
            var index = this.q57(stack);
            var value = this.q57(stack);
            evalCtx.p56_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.p57(stack);
            var tmp$ret$3 = evalCtx.p56_1[numberToInt(it)];
            this.o57(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.q57(stack);
            var l = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.r57(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.q57(stack);
            var l_0 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.r57(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.p57(stack) === 0.0 ? 1 : 0;
            this.o57(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.q57(stack);
            var l_1 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.r57(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.q57(stack);
            var v1 = this.q57(stack);
            var s2 = this.q57(stack);
            var s1 = this.q57(stack);
            this.r57(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.sz(Default_getInstance().wo());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.p57(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.o57(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.p57(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.o57(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.p57(stack);
            this.o57(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.q57(stack);
            var l_2 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.r57(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.q57(stack);
            var l_3 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.r57(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.q57(stack);
            var l_4 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.r57(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.q57(stack);
            var l_5 = this.q57(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.r57(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.e1() > 2) {
              evalCtx.t56_1 = stack.d1(0) + evalCtx.n56_1;
              evalCtx.u56_1 = true;
            }

            if (!(ctx.v3o() === 0)) {
              this.t57(ctx);
            }

            this.u57(ctx, stack.d1(stack.e1() - 2 | 0), stack.d1(stack.e1() - 1 | 0));
            stack.l3();
            break;
          case 3:
          case 28:
            if (stack.e1() > 1) {
              evalCtx.t56_1 = stack.d1(0) + evalCtx.n56_1;
              evalCtx.u56_1 = true;
            }

            this.y57(ctx, this.q57(stack), op.equals(Op_hmoveto_getInstance()));
            stack.l3();
            break;
          case 5:
            var progression = step(until(0, stack.e1()), 2);
            var inductionVariable = progression.d2_1;
            var last = progression.e2_1;
            var step_0 = progression.f2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.v57(ctx, stack.d1(n), stack.d1(n + 1 | 0));
              }
               while (!(n === last));
            stack.l3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.e1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.z57(ctx, stack.d1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.l3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.e1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.d1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.v57(ctx, tmp_1, stack.d1(_unary__edvuaz_0));
              }
            }

            while ((stack.e1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.d1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.d1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.d1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.d1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.d1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.x57(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.d1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.e1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.d1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.v57(ctx, tmp_7, stack.d1(_unary__edvuaz_8));
              }
            }

            stack.l3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.e1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.d1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.e1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.z4(toString(message));
            }

            while (n_2 < stack.e1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.d1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.d1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.d1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.d1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.x57(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.l3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.g1()) {
                break $l$loop;
              }
              var vv_0 = this.q57(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.q57(stack);
              var y2_0 = this.q57(stack);
              var v1_1 = this.q57(stack);
              var v2_0 = stack.e1() === 1 ? this.q57(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.x57(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.l3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.td();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.e1() % 2 | 0) === 0) && !evalCtx.u56_1) {
              var value_0 = stack.d1(0);
              evalCtx.t56_1 = value_0 + evalCtx.n56_1;
            }

            evalCtx.s56_1 = evalCtx.s56_1 + (stack.e1() >>> 1 | 0) | 0;
            evalCtx.u56_1 = true;
            stack.l3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.s56_1 + 7 | 0) >>> 3 | 0;
              s.lw(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.td();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.td();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.a58(s) << 8 | this.a58(s);
        var fractionPart = this.a58(s) << 8 | this.a58(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.r57(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.a58(s) << 8 | this.a58(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.a58(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.a58(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.s57(stack, value_2);
      }
    }
  }
  j56(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.w2k(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.b58(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.b58.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.i57_1 = Companion_getInstance_14().qw('TtfCIDFont');
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_24 = this;
    this.c58_1 = Companion_getInstance_14().qw('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.s5a(size, codePoint, path, reader) : $super.s5a.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.zv_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.i4t(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.zv_1 = old;
      }
    }
  }
  var g = this.t5a(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.k50();
    }
    if (!g.n54()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.y47_1.v4t_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.v53(pos.m25_1, pos.n25_1);
      g.o54(ctx);
    }finally {
      ctx.y47_1.v4t_1 = t;
    }
    switch (fill) {
      case true:
        ctx.t51();
        break;
      case false:
        ctx.s51();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.n54();
  }
  return false;
}
class BaseTtfFont {
  static o5k(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.d58_1 = new Mixin();
    $this.e58_1 = s;
    $this.f58_1 = extName;
    $this.g58_1 = onlyReadMetadata;
    $this.h58_1 = enableLigatures;
    $this.i58_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.j58_1 = tmp_1;
    $this.k58_1 = 0;
    $this.l58_1 = 0;
    $this.m58_1 = 0;
    $this.n58_1 = 0;
    $this.o58_1 = 0;
    $this.p58_1 = 0;
    $this.q58_1 = 0;
    $this.r58_1 = 0;
    $this.s58_1 = 0;
    $this.t58_1 = 0;
    $this.u58_1 = 0;
    $this.v58_1 = 0;
    $this.w58_1 = 0;
    $this.x58_1 = 0;
    $this.y58_1 = Companion_instance_28.p5k(0, 0);
    $this.z58_1 = 0;
    $this.a59_1 = 0;
    $this.b59_1 = 0;
    $this.c59_1 = 0;
    $this.d59_1 = 0;
    $this.e59_1 = 0;
    $this.f59_1 = 0;
    $this.g59_1 = 0;
    $this.h59_1 = 0;
    $this.i59_1 = 0;
    $this.j59_1 = 0;
    $this.k59_1 = 0;
    $this.l59_1 = new Int32Array(0);
    $this.m59_1 = Companion_instance_28.p5k(0, 0);
    $this.n59_1 = 128;
    $this.o59_1 = 0;
    $this.p59_1 = 0;
    $this.q59_1 = 0;
    $this.r59_1 = 0;
    $this.s59_1 = 0;
    $this.t59_1 = 0;
    $this.u59_1 = 0;
    $this.v59_1 = 0;
    $this.w59_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.x59_1 = emptyList();
    $this.y59_1 = LinkedHashMap.gc();
    $this.z59_1 = LinkedHashMap.gc();
    $this.a5a_1 = IntMap.v2o(512);
    $this.b5a_1 = LinkedHashMap.gc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.c5a_1 = [];
    $this.d5a_1 = IntMap.v2o();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.e5a_1 = emptyList();
    $this.f5a_1 = new COLRv1();
    $this.g5a_1 = false;
    $this.h5a_1 = IntIntMap.n2p();
    $this.i5a_1 = IntMap.v2o();
    $this.k5a_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_2().j29(), 0.0);
    $this.l5a_1 = false;
    $this.m5a_1 = null;
    return $this;
  }
  ay(_set____db54di) {
    this.d58_1.ay(_set____db54di);
  }
  by() {
    return this.d58_1.by();
  }
  static n5a(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.o5k(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  w4s(size, metrics) {
    return metrics.g4t(this.x5a(), size);
  }
  i4t(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.i5c(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.u5h_1;
    return metrics.o4t(tmp0_elvis_lhs == null ? this.k5a_1 : tmp0_elvis_lhs, size, codePoint);
  }
  w4u(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  s5a(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.zv_1;
    var codePointPeek = reader == null ? null : reader.hw(0);
    var tmp0_elvis_lhs = this.h5c(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.r4t(size);
    path.g54_1 = g.w21().x5h_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.h5i();
    tmp_0.h54_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.z5h();
    var bitmapEntry = g.j5i();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.j5f();
    path.i54_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.n59_1 / bitmapEntry.s5e_1.y5d_1;
      var scaleY = this.n59_1 / bitmapEntry.s5e_1.z5d_1;
      path.j54_1 = Vector2D.w27(0.0, ((-bitmapEntry.t5e_1 | 0) - bitmapEntry.d5f() | 0) * scaleY);
      path.k54_1 = Scale.q2d(scaleX, scaleY);
    }
    path.l54_1 = Companion_getInstance_3().g29_1.g2a(scale, scale);
    path.m54_1 = scale;
    return path;
  }
  r4t(size) {
    return size / this.n59_1;
  }
  u5a(key) {
    return this.y59_1.f3(key);
  }
  v5a(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.y59_1.i3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.z59_1.i3(glyphID, codePoint);
  }
  w5a(codePoint, glyphID) {
  }
  x5a() {
    var tmp = this.j5a_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  y5a() {
    return this.i58_1.y5a();
  }
  s3() {
    var tmp0_elvis_lhs = this.f58_1;
    return tmp0_elvis_lhs == null ? this.y5a() : tmp0_elvis_lhs;
  }
  o5a() {
    this.p5a();
    this.e5b();
    this.f5b();
    this.g5b();
    this.c5b();
    if (!this.g58_1) {
      if (!(this.r5a('CFF ') == null) && this.r5a('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.b5b('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.m5a_1 = CFF_instance.e57(tmp111_safe_receiver);
        }
      }
      this.d5b();
      this.e5c();
      this.h5b();
      this.i5b();
      this.d5c();
      this.c5c();
      this.k5b();
      this.l5b();
      this.m5b();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.r4t(1.0);
    this_0.x4s_1 = 1.0;
    this_0.y4s_1 = this.r59_1 * scale;
    this_0.z4s_1 = this.z58_1 * scale;
    this_0.a4t_1 = 0.0 * scale;
    this_0.b4t_1 = this.a59_1 * scale;
    this_0.c4t_1 = this.p59_1 * scale;
    this_0.d4t_1 = this.b59_1 * scale;
    this_0.e4t_1 = this.c59_1 * scale;
    this_0.f4t_1 = this.n59_1 * scale;
    tmp.j5a_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.s3() + ')';
  }
  z5a(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.o1q());
  }
  a5b(_this__u8e3s4) {
    return Companion_instance_28.p5k(_this__u8e3s4.n1q(), _this__u8e3s4.n1q());
  }
  b5b(name) {
    var tmp109_safe_receiver = this.r5a(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.m5d();
  }
  c5b() {
    var tmp111_safe_receiver = this.b5b('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_27.p5d(tmp111_safe_receiver, this.i58_1);
    }
    return Unit_instance;
  }
  d5b() {
    var tmp111_safe_receiver = this.b5b('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.v59_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.k1q(imul(bytesPerEntry, this.k58_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.v59_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.u1q(this.k58_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.w1q(this.k58_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.l59_1 = tmp_1;
    }
    return Unit_instance;
  }
  e5b() {
    var tmp111_safe_receiver = this.b5b('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.o1q() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.o1q() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.m59_1 = this.a5b(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.q1q();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.q1q();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.o1q();
      this.n59_1 = tmp111_safe_receiver.o1q();
      var created = tmp111_safe_receiver.r1q().z3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.r1q().z3(new Long(1000, 0));
      this.o59_1 = tmp111_safe_receiver.n1q();
      this.p59_1 = tmp111_safe_receiver.n1q();
      this.q59_1 = tmp111_safe_receiver.n1q();
      this.r59_1 = tmp111_safe_receiver.n1q();
      this.s59_1 = tmp111_safe_receiver.o1q();
      this.t59_1 = tmp111_safe_receiver.o1q();
      this.u59_1 = tmp111_safe_receiver.n1q();
      this.v59_1 = tmp111_safe_receiver.n1q();
      this.w59_1 = tmp111_safe_receiver.n1q();
    }
    return Unit_instance;
  }
  f5b() {
    var tmp111_safe_receiver = this.b5b('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.a5b(tmp111_safe_receiver);
      this.k58_1 = tmp111_safe_receiver.o1q();
      this.l58_1 = tmp111_safe_receiver.o1q();
      this.m58_1 = tmp111_safe_receiver.o1q();
      this.n58_1 = tmp111_safe_receiver.o1q();
      this.o58_1 = tmp111_safe_receiver.o1q();
      this.p58_1 = tmp111_safe_receiver.o1q();
      this.q58_1 = tmp111_safe_receiver.o1q();
      this.r58_1 = tmp111_safe_receiver.o1q();
      this.s58_1 = tmp111_safe_receiver.o1q();
      this.t58_1 = tmp111_safe_receiver.o1q();
      this.u58_1 = tmp111_safe_receiver.o1q();
      this.v58_1 = tmp111_safe_receiver.o1q();
      this.w58_1 = tmp111_safe_receiver.o1q();
      this.x58_1 = tmp111_safe_receiver.o1q();
    }
    return Unit_instance;
  }
  g5b() {
    var tmp111_safe_receiver = this.b5b('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.y58_1 = this.a5b(tmp111_safe_receiver);
      this.z58_1 = tmp111_safe_receiver.n1q();
      this.a59_1 = tmp111_safe_receiver.n1q();
      this.b59_1 = tmp111_safe_receiver.n1q();
      this.c59_1 = tmp111_safe_receiver.o1q();
      this.d59_1 = tmp111_safe_receiver.n1q();
      this.e59_1 = tmp111_safe_receiver.n1q();
      this.f59_1 = tmp111_safe_receiver.n1q();
      this.g59_1 = tmp111_safe_receiver.n1q();
      this.h59_1 = tmp111_safe_receiver.n1q();
      this.i59_1 = tmp111_safe_receiver.n1q();
      tmp111_safe_receiver.n1q();
      tmp111_safe_receiver.n1q();
      tmp111_safe_receiver.n1q();
      tmp111_safe_receiver.n1q();
      this.j59_1 = tmp111_safe_receiver.n1q();
      this.k59_1 = tmp111_safe_receiver.o1q();
    }
    return Unit_instance;
  }
  h5b() {
    var tmp111_safe_receiver = this.b5b('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.k59_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.d2_1;
      var last_0 = this_0.e2_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.o1q(), tmp111_safe_receiver.n1q());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).n5d_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.k58_1 - this.k59_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.d2_1;
      var last_1 = this_1.e2_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.n1q());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.x59_1 = plus_0(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  i5b() {
    var tmp111_safe_receiver = this.b5b('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.o1q();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.o1q();
          var numPalettes = tmp111_safe_receiver.o1q();
          var numColorRecords = tmp111_safe_receiver.o1q();
          var colorRecordsArrayOffset = tmp111_safe_receiver.q1q();
          var colorRecordIndices = tmp111_safe_receiver.t1q(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.q1q() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.q1q() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.q1q() : -1;
          tmp111_safe_receiver.c1q(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.v1q(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_26().o4f(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.e5a_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  j5b(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.m1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q(), _this__u8e3s4.l1q());
  }
  k5b() {
    var tmp111_safe_receiver = this.b5b('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.o1q();
      var minorVersion = tmp111_safe_receiver.o1q();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.q1q();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.q1q(), tmp111_safe_receiver.q1q(), tmp111_safe_receiver.q1q(), tmp111_safe_receiver.q1q(), this.j5b(tmp111_safe_receiver), this.j5b(tmp111_safe_receiver), tmp111_safe_receiver.o1q(), tmp111_safe_receiver.o1q(), tmp111_safe_receiver.m1q(), tmp111_safe_receiver.m1q(), tmp111_safe_receiver.m1q(), tmp111_safe_receiver.l1q());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.a1();
        while (_iterator__ex2g4s.b1()) {
          var cbi = _iterator__ex2g4s.c1();
          var glyphCount = cbi.x5d_1 - cbi.w5d_1 | 0;
          tmp111_safe_receiver.c1q(cbi.q5d_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.s5d_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.o1q(), tmp111_safe_receiver.o1q(), tmp111_safe_receiver.q1q());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.c1q(cbi.q5d_1 + subtable.b5k_1 | 0);
            var indexFormat = tmp111_safe_receiver.o1q();
            var imageFormat = tmp111_safe_receiver.o1q();
            var imageDataOffset = tmp111_safe_receiver.q1q();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.c5k() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.q1q() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.z5j_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.b5a_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.i3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  l5b() {
    var tmp111_safe_receiver = this.b5b('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.o1q();
      var minorVersion = tmp111_safe_receiver.o1q();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.b5a_1.h3().a1();
        while (_iterator__ex2g4s.b1()) {
          var i = _iterator__ex2g4s.c1();
          var format = i.p5e_1;
          if (format === 17 || format === 18) {
            i.t5e_1 = tmp111_safe_receiver.m1q();
            i.u5e_1 = tmp111_safe_receiver.m1q();
            i.v5e_1 = tmp111_safe_receiver.l1q();
            i.w5e_1 = tmp111_safe_receiver.l1q();
            i.x5e_1 = tmp111_safe_receiver.m1q();
            i.y5e_1 = format === 18 ? tmp111_safe_receiver.l1q() : i.v5e_1;
            i.z5e_1 = format === 18 ? tmp111_safe_receiver.l1q() : i.w5e_1;
            i.a5f_1 = format === 18 ? tmp111_safe_receiver.l1q() : i.x5e_1;
          }
          var dataLen = tmp111_safe_receiver.q1q();
          i.b5f_1 = tmp111_safe_receiver.f1q(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  m5b() {
    var tmp111_safe_receiver = this.b5b('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.o1q();
      var flags = tmp111_safe_receiver.o1q();
      var numStrikes = tmp111_safe_receiver.q1q();
      var strikeOffsets = tmp111_safe_receiver.w1q(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.c1q(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.o1q(), tmp111_safe_receiver.o1q(), item, toIntArrayList(tmp111_safe_receiver.w1q(this.k58_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.a1();
        if (!iterator.b1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.c1();
        if (!iterator.b1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.d5k_1;
        do {
          var e = iterator.c1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.d5k_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.b1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.k58_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.g5k_1.d1(n);
          var len = strike.g5k_1.d1(n + 1 | 0) - offset | 0;
          var start = strike.f5k_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.c1q(start);
          var originOffsetX = tmp111_safe_receiver.n1q();
          var originOffsetY = tmp111_safe_receiver.n1q();
          var graphicType = tmp111_safe_receiver.z1q(4);
          var bytes = tmp111_safe_receiver.f1q(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.b5a_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.d5k_1, strike.d5k_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.b5f_1 = bytes;
          this_0.i3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  n5b(_this__u8e3s4) {
    return _this__u8e3s4.q1q();
  }
  o5b(_this__u8e3s4) {
    return _this__u8e3s4.o1q();
  }
  p5b(_this__u8e3s4) {
    return _this__u8e3s4.n1q();
  }
  q5b(_this__u8e3s4) {
    return _this__u8e3s4.o1q();
  }
  r5b(_this__u8e3s4) {
    return _this__u8e3s4.p1q();
  }
  s5b(_this__u8e3s4) {
    return _this__u8e3s4.q1q();
  }
  t5b(_this__u8e3s4, isVar) {
    var xx = this.o5c(_this__u8e3s4);
    var yx = this.o5c(_this__u8e3s4);
    var xy = this.o5c(_this__u8e3s4);
    var yy = this.o5c(_this__u8e3s4);
    var dx = this.o5c(_this__u8e3s4);
    var dy = this.o5c(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  u5b(_this__u8e3s4, out) {
    out.n5f_1 = this.n5c(_this__u8e3s4);
    out.o5f_1 = _this__u8e3s4.o1q();
    out.p5f_1 = this.n5c(_this__u8e3s4);
    return out;
  }
  v5b(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.u5b(_this__u8e3s4, out) : $super.u5b.call(this, _this__u8e3s4, out);
  }
  w5b(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.m1q();
    var xMin = this.p5b(_this__u8e3s4);
    var yMin = this.p5b(_this__u8e3s4);
    var xMax = this.p5b(_this__u8e3s4);
    var yMax = this.p5b(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.n5b(_this__u8e3s4);
    }
    return Companion_getInstance_2().i2e(xMin, yMin, xMax, yMax);
  }
  x5b(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.w5b(_this__u8e3s4, doVar) : $super.w5b.call(this, _this__u8e3s4, doVar);
  }
  y5b(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.m1q()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.o1q();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.v5b(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  z5b(glyphID, s, c, pal, level) {
    var nodeFormat = s.m1q();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString_0(getOrNull(Companion_getInstance_36().y5c_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.m1q();
        var firstLayerIndex = s.q1q();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.f5a_1.s5g_1[firstLayerIndex + n | 0];
            this.z5b(glyphID, this.f5a_1.v5g_1.h1q(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.o1q();
        var alpha = this.n5c(s);
        if (isVar) {
          var varIndexBase = this.n5b(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.td();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.e5a_1.d1(pal).b4f_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.w51(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.r5b(s);
        var x0 = this.p5b(s);
        var y0 = this.p5b(s);
        var x1 = this.p5b(s);
        var y1 = this.p5b(s);
        var x2 = this.p5b(s);
        var y2 = this.p5b(s);
        var colorLine = this.y5b(s.h1q(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.n5b(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.k5f_1;
        var transform = Companion_getInstance_3().g29_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.m5f(paint_0, this.e5a_1.d1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.w51(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.r5b(s);
        var x0_0 = this.p5b(s);
        var y0_1 = this.p5b(s);
        var radius0 = this.o5b(s);
        var x1_0 = this.p5b(s);
        var y1_1 = this.p5b(s);
        var radius1 = this.o5b(s);
        var colorLine_0 = this.y5b(s.h1q(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.n5b(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.k5f_1;
        var transform_0 = Companion_getInstance_3().g29_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.m5f(paint_1, this.e5a_1.d1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.w51(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.r5b(s);
        var centerX = this.p5b(s);
        var centerY = this.p5b(s);
        var startAngle = this.n5c(s);
        var endAngle = this.n5c(s);
        if (isVar) {
          var varIndexBase_2 = this.n5b(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      case 10:
        var paint_2 = this.r5b(s);
        var glyphID_0 = s.o1q();
        var colr = this.d5a_1.d1(glyphID_0);
        var glyph = this.m5c(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.d52();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.w21().x5h_1), '\n'));
            }
            c.q5k(glyph.w21().x5h_1);
            this.z5b(glyphID_0, s.h1q(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.l52();
        }

        break;
      case 11:
        var glyphID_1 = s.o1q();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      case 12:
      case 13:
        var paint_3 = this.r5b(s);
        var transform_1 = this.r5b(s);
        var affine = this.t5b(s.h1q(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.d52();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.x53(affine);
          this.z5b(glyphID, s.h1q(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.l52();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.r5b(s);
        var dx = FWord__toDouble_impl_53j5qp(this.z5a(s));
        var dy = FWord__toDouble_impl_53j5qp(this.z5a(s));
        if (isVar) {
          var varIndexBase_3 = this.n5b(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.d52();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.v53(dx, -dy);
          this.z5b(glyphID, s.h1q(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.l52();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.r5b(s);
        var scaleX = this.n5c(s);
        var scaleY = this.n5c(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.p5b(s);
          var centerY_0 = this.p5b(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.td();
        }

        if (isVar) {
          var varIndexBase_4 = this.n5b(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.d52();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.r5k(numberToDouble(scaleX), numberToDouble(scaleY));
          this.z5b(glyphID, s.h1q(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.l52();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.r5b(s);
        var scale = this.n5c(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.p5b(s);
          var centerY_1 = this.p5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.n5b(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.r5b(s);
        var angle = this.n5c(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.p5b(s);
          var centerY_2 = this.p5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.n5b(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.r5b(s);
        var xSkewAngle = this.n5c(s);
        var ySkewAngle = this.n5c(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.p5b(s);
          var centerY_3 = this.p5b(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.n5b(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      case 32:
        var sourcePaint = this.r5b(s);
        var compositeMode = s.m1q();
        var backdropPaint = this.r5b(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.td('An operation is not implemented: ' + reason);
    }
  }
  a5c(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.o1q();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.o1q();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.u1q(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.o1q();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.d2_1;
        var last_0 = this_3.e2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.o1q(), _this__u8e3s4.o1q(), _this__u8e3s4.o1q());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.a1();
        if (!iterator.b1())
          throw NoSuchElementException.n6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.c1();
        var maxValue = it.j5k_1 + it.k5k_1 | 0;
        while (iterator.b1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.c1();
          var v = it_0.j5k_1 + it_0.k5k_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.a1();
        while (_iterator__ex2g4s.b1()) {
          var range = _iterator__ex2g4s.c1();
          var inductionVariable_1 = range.h5k_1;
          var last_1 = range.i5k_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.h5k_1 | 0;
              glyphArray[range.j5k_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.td('An operation is not implemented: ' + reason);
    }
  }
  b5c(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.a5c(_this__u8e3s4, hintedCount) : $super.a5c.call(this, _this__u8e3s4, hintedCount);
  }
  c5c() {
    var tmp111_safe_receiver = this.b5b('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.o1q();
      var minorVersion = tmp111_safe_receiver.o1q();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.z4(toString(message));
      }
      var scriptListOffset = this.q5b(tmp111_safe_receiver);
      var featureListOffset = this.q5b(tmp111_safe_receiver);
      var lookupListOffset = this.q5b(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.s5b(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.h1q(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.o1q();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.z1q(4);
          var scriptOffset = this.q5b(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.h1q(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.o1q();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.z1q(4);
          var featureOffset = this.q5b(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.h1q(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.o1q();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.a2k((coerceAtLeast(this_3.h2() - this_3.i2() | 0, 0) / this_3.f2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.i2();
      var nestedLast = this_3.h2();
      var stepArg = this_3.f2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.q5b(this_2);
          this_4.g2k(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.a1();
      while (_iterator__ex2g4s.b1()) {
        var lookupOffset = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.h1q(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.o1q();
        var lookupFlag = this_5.o1q();
        var subTableCount = this_5.o1q();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.t1q(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.o1q();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.h1q(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.o1q();
              var coverageOffset = this.q5b(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.n1q();
                  var coverageTable = this.b5c(this_8.h1q(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.h5a_1.m2p(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.o1q();
                  var coverageTable_0 = this.b5c(this_8.h1q(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.u1q(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.h5a_1.m2p(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.z4(toString(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.o1q();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.z4(toString(message_1));
              }

              var coverageOffset_0 = this.q5b(this_8);
              var ligatureSetCount = this_8.o1q();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.u1q(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.a5c(this_8.h1q(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.gc();
                  var codePoint = this.g5c(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.h1q(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.o1q();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.u1q(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.h1q(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.o1q();
                    var componentCount = this_19.o1q();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.u1q(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.g5c(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_12();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.ow(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.i3(ligature, value);
                  }
                  this.i5a_1.p2o(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_34().c58_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.a2u(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.b2u(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  d5c() {
    var tmp111_safe_receiver = this.b5b('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.o1q();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.o1q();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.q1q();
          var layerRecordsOffset = tmp111_safe_receiver.q1q();
          var numLayerRecords = tmp111_safe_receiver.o1q();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.h1q(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.o1q(), this_0.o1q());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.c5a_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.h1q(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.o1q(), this_1.o1q(), this_1.o1q());
              this.d5a_1.p2o(info.d5i_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.s5b(tmp111_safe_receiver);
            var layerListOffset = this.s5b(tmp111_safe_receiver);
            var clipListOffset = this.s5b(tmp111_safe_receiver);
            var varIdxMapOffset = this.s5b(tmp111_safe_receiver);
            var varStoreOffset = this.s5b(tmp111_safe_receiver);
            this.f5a_1.x5g_1.l3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.h1q(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.h1q(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.q1q();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.s5b(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.h1q(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.h1q(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.h1q(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.f5a_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.h1q(clipListOffset);
              var format = s.m1q();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.q1q();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.o1q();
                var endGlyphID = s.o1q();
                var clipBoxOffset = this.r5b(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.f5a_1.x5g_1.m2p(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.h1q(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.q1q();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.o1q();
              var paint = this.s5b(this_3);
              this.d5a_1.p2o(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  e5c() {
    var tmp111_safe_receiver = this.b5b('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.o1q();
      var numTables = tmp111_safe_receiver.o1q();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.o1q(), tmp111_safe_receiver.o1q(), tmp111_safe_receiver.q1q());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.a1();
      while (_iterator__ex2g4s.b1()) {
        var table = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.h1q(table.n5k_1);
        var format = $this$run.o1q();
        try {
          switch (format) {
            case 0:
              var length = $this$run.o1q();
              var language = $this$run.o1q();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.k1q(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.w5a(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.o1q();
              var language_0 = $this$run.o1q();
              var segCount = $this$run.o1q() / 2 | 0;
              var searchRangeS = $this$run.o1q();
              var entrySelector = $this$run.o1q();
              var rangeShift = $this$run.o1q();
              var endCount = $this$run.u1q(segCount);
              $this$run.o1q();
              var startCount = $this$run.u1q(segCount);
              var idDelta = $this$run.t1q(segCount);
              var rangeOffsetPos = $this$run.d1q();
              var idRangeOffset = $this$run.u1q(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.h1q(glyphIndexOffset).o1q();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.v5a(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.o1q();
              var language_1 = $this$run.o1q();
              var firstCode = $this$run.o1q();
              var entryCount = $this$run.o1q();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.v5a(codePoint, $this$run.o1q());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.o1q();
              var length_2 = $this$run.q1q();
              var language_2 = $this$run.q1q();
              var numGroups = $this$run.q1q();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.q1q();
                  var endCharCode = $this$run.q1q();
                  var startGlyphId = $this$run.q1q();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.v5a(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  f5c(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.z59_1.f3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  g5c(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.f5c(charIndex, default_0) : $super.f5c.call(this, charIndex, default_0);
  }
  h5c(reader, codePoint, cache) {
    var g = this.k5c(codePoint);
    var skipCount = 1;
    if (this.h58_1 && !(g == null)) {
      var subs = this.i5a_1.d1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.aw();
        var b = subs.k5d_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.mw(0, count);
            var replacement = subs.l5d_1.f3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.m5c(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.lw(skipCount);
    }
    return g;
  }
  i5c(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.h5c(reader, codePoint, cache) : $super.h5c.call(this, reader, codePoint, cache);
  }
  j5c(codePoint, cache) {
    var tmp134_safe_receiver = this.u5a(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.l5c(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  k5c(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.j5c(codePoint, cache) : $super.j5c.call(this, codePoint, cache);
  }
  l5c(index, cache, codePoint) {
    var cff = this.m5a_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.a5a_1;
      var res = this_0.d1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.v56(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.z55_1), new GlyphGraphicsPath(index, gvector.y55_1));
        this_0.p2o(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.d1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.l59_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.l59_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.a5a_1.d1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.r5a('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.m5d();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.q5c($this$runTable.h1q(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.x59_1.d1(index).n5d_1, true);
    }
    var glyph = tmp;
    if (cache && !this.g5a_1) {
      this.a5a_1.p2o(index, glyph);
    }
    return glyph;
  }
  m5c(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.l5c(index, cache, codePoint) : $super.l5c.call(this, index, cache, codePoint);
  }
  n5c(_this__u8e3s4) {
    var v = _this__u8e3s4.n1q();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  o5c(_this__u8e3s4) {
    var v = _this__u8e3s4.q1q();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  p5c(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.l1q();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.m1q();
    } else if (word && signed) {
      tmp = _this__u8e3s4.n1q();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.o1q();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  q5c(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.n1q();
    var xMin = _this__u8e3s4.n1q();
    var yMin = _this__u8e3s4.n1q();
    var xMax = _this__u8e3s4.n1q();
    var yMax = _this__u8e3s4.n1q();
    var advanceWidth = this.x59_1.d1(index).n5d_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.h1();
      do {
        var flags = _this__u8e3s4.o1q();
        var glyphIndex = _this__u8e3s4.o1q();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.p5c(_this__u8e3s4, signed, words);
        var y = this.p5c(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.n5c(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.n5c(_this__u8e3s4);
          scaleY = this.n5c(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.n5c(_this__u8e3s4);
          scale01 = this.n5c(_this__u8e3s4);
          scale10 = this.n5c(_this__u8e3s4);
          scaleY = this.n5c(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.m5c(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.o1q();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.o1q();
      var instructions = _this__u8e3s4.k1q(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.a2k();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.m1q();
        flags_0.g2k(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.m1q();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.g2k(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.ux(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.m1q();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.n1q() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.t2k(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static w4x(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_34();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.n5a(d, extName, onlyReadMetadata, enableLigatures);
    $this.v4x_1 = LinkedHashMap.gc();
    $this.o5a();
    return $this;
  }
  p5a() {
    this.v4x_1.k3(Companion_instance_27.q5a(this.e58_1.i1q()));
  }
  r5a(name) {
    return this.v4x_1.f3(name);
  }
}
class Companion_19 {
  constructor() {
    this.x5c_1 = 26;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y5c_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.z5c_1 = fillArrayVal(Array(26), null);
    this.a5d_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.b5d_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.c5d_1 = tmp_5;
    this.d5d_1 = null;
  }
  y5a() {
    var tmp0_elvis_lhs = this.e5d(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.e5d(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  f5d(nameId) {
    if (this.z5c_1[nameId] == null) {
      var nameLength = this.b5d_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.d5d_1).x1q(this.a5d_1[nameId], nameLength, this.c5d_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.ub(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.z5c_1[nameId] = tmp;
    }
    return this.z5c_1[nameId];
  }
  e5d(nameId) {
    return this.f5d(nameId.i5d_1);
  }
  j5d() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.hc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.e5d(element);
      result.i3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString(this.j5d()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.k5d_1 = maxSequence;
    this.l5d_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.r5c_1 = id;
    this.s5c_1 = checksum;
    this.t5c_1 = offset;
    this.u5c_1 = length;
    this.v5c_1 = null;
    var tmp = this;
    tmp.w5c_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  m5d() {
    return _get_ss__ndcawb(this).wx();
  }
  toString() {
    return 'Table(id=' + this.r5c_1 + ', checksum=' + this.s5c_1 + ', offset=' + this.t5c_1 + ', length=' + this.u5c_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r5c_1);
    result = imul(result, 31) + this.s5c_1 | 0;
    result = imul(result, 31) + this.t5c_1 | 0;
    result = imul(result, 31) + this.u5c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.r5c_1 === tmp0_other_with_cast.r5c_1))
      return false;
    if (!(this.s5c_1 === tmp0_other_with_cast.s5c_1))
      return false;
    if (!(this.t5c_1 === tmp0_other_with_cast.t5c_1))
      return false;
    if (!(this.u5c_1 === tmp0_other_with_cast.u5c_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.n5d_1 = advanceWidth;
    this.o5d_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.n5d_1 + ', lsb=' + this.o5d_1 + ')';
  }
  hashCode() {
    var result = this.n5d_1;
    result = imul(result, 31) + this.o5d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.n5d_1 === tmp0_other_with_cast.n5d_1))
      return false;
    if (!(this.o5d_1 === tmp0_other_with_cast.o5d_1))
      return false;
    return true;
  }
}
class Companion_21 {
  p5d(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.o1q();
    var count = s.o1q();
    var stringOffset = s.o1q();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.o1q();
        var encodingId = s.o1q();
        var languageId = s.o1q();
        var nameId = s.o1q();
        var length = s.o1q();
        var offset = s.o1q();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.b5d_1[nameId] === -1) {
          info.a5d_1[nameId] = stringOffset + offset | 0;
          info.b5d_1[nameId] = length;
          info.c5d_1[nameId] = charset;
          info.d5d_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  q5a(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.q1q() === 1953784678) {
      var majorVersion = s.o1q();
      var minorVersion = s.o1q();
      var numFonts = s.q1q();
      var tableDirectoryOffsets = s.w1q(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.q1q();
        var dsigLength = s.q1q();
        var dsigOffset = s.q1q();
      }
      s.c1q(tableDirectoryOffsets[0]);
    } else {
      s.j1q(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.o1q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.o1q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.o1q();
    var searchRange = s.o1q();
    var entrySelector = s.o1q();
    var rangeShift = s.o1q();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.d2_1;
    var last = this_2.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.z1q(4), s.q1q(), s.q1q(), s.q1q());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.gc();
    var _iterator__ex2g4s = tables.a1();
    while (_iterator__ex2g4s.b1()) {
      var table = _iterator__ex2g4s.c1();
      var tmp = table;
      tmp.v5c_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.r5c_1;
      tablesByName.i3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.i5d_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.q5d_1 = indexSubTableArrayOffset;
    this.r5d_1 = indexTablesSize;
    this.s5d_1 = numberofIndexSubTables;
    this.t5d_1 = colorRef;
    this.u5d_1 = hori;
    this.v5d_1 = vert;
    this.w5d_1 = startGlyphIndex;
    this.x5d_1 = endGlyphIndex;
    this.y5d_1 = ppemX;
    this.z5d_1 = ppemY;
    this.a5e_1 = bitDepth;
    this.b5e_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.q5d_1 + ', indexTablesSize=' + this.r5d_1 + ', numberofIndexSubTables=' + this.s5d_1 + ', colorRef=' + this.t5d_1 + ', hori=' + this.u5d_1.toString() + ', vert=' + this.v5d_1.toString() + ', startGlyphIndex=' + this.w5d_1 + ', endGlyphIndex=' + this.x5d_1 + ', ppemX=' + this.y5d_1 + ', ppemY=' + this.z5d_1 + ', bitDepth=' + this.a5e_1 + ', flags=' + this.b5e_1 + ')';
  }
  hashCode() {
    var result = this.q5d_1;
    result = imul(result, 31) + this.r5d_1 | 0;
    result = imul(result, 31) + this.s5d_1 | 0;
    result = imul(result, 31) + this.t5d_1 | 0;
    result = imul(result, 31) + this.u5d_1.hashCode() | 0;
    result = imul(result, 31) + this.v5d_1.hashCode() | 0;
    result = imul(result, 31) + this.w5d_1 | 0;
    result = imul(result, 31) + this.x5d_1 | 0;
    result = imul(result, 31) + this.y5d_1 | 0;
    result = imul(result, 31) + this.z5d_1 | 0;
    result = imul(result, 31) + this.a5e_1 | 0;
    result = imul(result, 31) + this.b5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.q5d_1 === tmp0_other_with_cast.q5d_1))
      return false;
    if (!(this.r5d_1 === tmp0_other_with_cast.r5d_1))
      return false;
    if (!(this.s5d_1 === tmp0_other_with_cast.s5d_1))
      return false;
    if (!(this.t5d_1 === tmp0_other_with_cast.t5d_1))
      return false;
    if (!this.u5d_1.equals(tmp0_other_with_cast.u5d_1))
      return false;
    if (!this.v5d_1.equals(tmp0_other_with_cast.v5d_1))
      return false;
    if (!(this.w5d_1 === tmp0_other_with_cast.w5d_1))
      return false;
    if (!(this.x5d_1 === tmp0_other_with_cast.x5d_1))
      return false;
    if (!(this.y5d_1 === tmp0_other_with_cast.y5d_1))
      return false;
    if (!(this.z5d_1 === tmp0_other_with_cast.z5d_1))
      return false;
    if (!(this.a5e_1 === tmp0_other_with_cast.a5e_1))
      return false;
    if (!(this.b5e_1 === tmp0_other_with_cast.b5e_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.c5e_1 = ascender;
    this.d5e_1 = descender;
    this.e5e_1 = widthMax;
    this.f5e_1 = caretSlopeNumerator;
    this.g5e_1 = caretSlopeDenominator;
    this.h5e_1 = caretOffset;
    this.i5e_1 = minOriginSB;
    this.j5e_1 = minAdvanceSB;
    this.k5e_1 = maxBeforeBL;
    this.l5e_1 = minAfterBL;
    this.m5e_1 = pad1;
    this.n5e_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.c5e_1 + ', descender=' + this.d5e_1 + ', widthMax=' + this.e5e_1 + ', caretSlopeNumerator=' + this.f5e_1 + ', caretSlopeDenominator=' + this.g5e_1 + ', caretOffset=' + this.h5e_1 + ', minOriginSB=' + this.i5e_1 + ', minAdvanceSB=' + this.j5e_1 + ', maxBeforeBL=' + this.k5e_1 + ', minAfterBL=' + this.l5e_1 + ', pad1=' + this.m5e_1 + ', pad2=' + this.n5e_1 + ')';
  }
  hashCode() {
    var result = this.c5e_1;
    result = imul(result, 31) + this.d5e_1 | 0;
    result = imul(result, 31) + this.e5e_1 | 0;
    result = imul(result, 31) + this.f5e_1 | 0;
    result = imul(result, 31) + this.g5e_1 | 0;
    result = imul(result, 31) + this.h5e_1 | 0;
    result = imul(result, 31) + this.i5e_1 | 0;
    result = imul(result, 31) + this.j5e_1 | 0;
    result = imul(result, 31) + this.k5e_1 | 0;
    result = imul(result, 31) + this.l5e_1 | 0;
    result = imul(result, 31) + this.m5e_1 | 0;
    result = imul(result, 31) + this.n5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.c5e_1 === tmp0_other_with_cast.c5e_1))
      return false;
    if (!(this.d5e_1 === tmp0_other_with_cast.d5e_1))
      return false;
    if (!(this.e5e_1 === tmp0_other_with_cast.e5e_1))
      return false;
    if (!(this.f5e_1 === tmp0_other_with_cast.f5e_1))
      return false;
    if (!(this.g5e_1 === tmp0_other_with_cast.g5e_1))
      return false;
    if (!(this.h5e_1 === tmp0_other_with_cast.h5e_1))
      return false;
    if (!(this.i5e_1 === tmp0_other_with_cast.i5e_1))
      return false;
    if (!(this.j5e_1 === tmp0_other_with_cast.j5e_1))
      return false;
    if (!(this.k5e_1 === tmp0_other_with_cast.k5e_1))
      return false;
    if (!(this.l5e_1 === tmp0_other_with_cast.l5e_1))
      return false;
    if (!(this.m5e_1 === tmp0_other_with_cast.m5e_1))
      return false;
    if (!(this.n5e_1 === tmp0_other_with_cast.n5e_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.o5e_1 = glyphID;
    this.p5e_1 = imageFormat;
    this.q5e_1 = offset;
    this.r5e_1 = size;
    this.s5e_1 = info;
    this.t5e_1 = height;
    this.u5e_1 = width;
    this.v5e_1 = horiBearingX;
    this.w5e_1 = horiBearingY;
    this.x5e_1 = horiAdvance;
    this.y5e_1 = vertBearingX;
    this.z5e_1 = vertBearingY;
    this.a5f_1 = vertAdvance;
    this.b5f_1 = null;
    this.c5f_1 = null;
  }
  d5f() {
    return this.s5e_1.u5d_1.d5e_1;
  }
  e5f(cache) {
    var tmp0_elvis_lhs = this.c5f_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().i5f(toSyncStream(ensureNotNull(this.b5f_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.c5f_1 = bmp;
    return bmp;
  }
  j5f(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.e5f(cache) : $super.e5f.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.o5e_1 + ', imageFormat=' + this.p5e_1 + ', offset=' + this.q5e_1 + ', size=' + this.r5e_1 + ', info=' + this.s5e_1.toString() + ', height=' + this.t5e_1 + ', width=' + this.u5e_1 + ', horiBearingX=' + this.v5e_1 + ', horiBearingY=' + this.w5e_1 + ', horiAdvance=' + this.x5e_1 + ', vertBearingX=' + this.y5e_1 + ', vertBearingY=' + this.z5e_1 + ', vertAdvance=' + this.a5f_1 + ')';
  }
  hashCode() {
    var result = this.o5e_1;
    result = imul(result, 31) + this.p5e_1 | 0;
    result = imul(result, 31) + this.q5e_1 | 0;
    result = imul(result, 31) + this.r5e_1 | 0;
    result = imul(result, 31) + this.s5e_1.hashCode() | 0;
    result = imul(result, 31) + this.t5e_1 | 0;
    result = imul(result, 31) + this.u5e_1 | 0;
    result = imul(result, 31) + this.v5e_1 | 0;
    result = imul(result, 31) + this.w5e_1 | 0;
    result = imul(result, 31) + this.x5e_1 | 0;
    result = imul(result, 31) + this.y5e_1 | 0;
    result = imul(result, 31) + this.z5e_1 | 0;
    result = imul(result, 31) + this.a5f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.o5e_1 === tmp0_other_with_cast.o5e_1))
      return false;
    if (!(this.p5e_1 === tmp0_other_with_cast.p5e_1))
      return false;
    if (!(this.q5e_1 === tmp0_other_with_cast.q5e_1))
      return false;
    if (!(this.r5e_1 === tmp0_other_with_cast.r5e_1))
      return false;
    if (!this.s5e_1.equals(tmp0_other_with_cast.s5e_1))
      return false;
    if (!(this.t5e_1 === tmp0_other_with_cast.t5e_1))
      return false;
    if (!(this.u5e_1 === tmp0_other_with_cast.u5e_1))
      return false;
    if (!(this.v5e_1 === tmp0_other_with_cast.v5e_1))
      return false;
    if (!(this.w5e_1 === tmp0_other_with_cast.w5e_1))
      return false;
    if (!(this.x5e_1 === tmp0_other_with_cast.x5e_1))
      return false;
    if (!(this.y5e_1 === tmp0_other_with_cast.y5e_1))
      return false;
    if (!(this.z5e_1 === tmp0_other_with_cast.z5e_1))
      return false;
    if (!(this.a5f_1 === tmp0_other_with_cast.a5f_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.k5f_1 = cycle;
    this.l5f_1 = stops;
  }
  m5f(paint, palette) {
    var _iterator__ex2g4s = this.l5f_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stop = _iterator__ex2g4s.c1();
      paint.o5g(stop.n5f_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.b4f_1, stop.o5f_1), stop.p5f_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.k5f_1.toString() + ', stops=' + toString(this.l5f_1) + ')';
  }
  hashCode() {
    var result = this.k5f_1.hashCode();
    result = imul(result, 31) + hashCode(this.l5f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.k5f_1.equals(tmp0_other_with_cast.k5f_1))
      return false;
    if (!equals(this.l5f_1, tmp0_other_with_cast.l5f_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.n5f_1 = stopOffset;
    this.o5f_1 = paletteIndex;
    this.p5f_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.r5g_1 = this.r3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.s5g_1 = layerList;
    this.t5g_1 = s;
    this.u5g_1 = sBaseOffset;
    this.v5g_1 = sLayerOffset;
    this.w5g_1 = sClipOffset;
    this.x5g_1 = IntIntMap.n2p();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.y5g_1 = x;
    this.z5g_1 = y;
    this.a5h_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.y5g_1 + ', y=' + this.z5g_1 + ', onCurve=' + this.a5h_1 + ')';
  }
  hashCode() {
    var result = this.y5g_1;
    result = imul(result, 31) + this.z5g_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a5h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.y5g_1 === tmp0_other_with_cast.y5g_1))
      return false;
    if (!(this.z5g_1 === tmp0_other_with_cast.z5g_1))
      return false;
    if (!(this.a5h_1 === tmp0_other_with_cast.a5h_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.b5h_1 = glyph;
    this.c5h_1 = x;
    this.d5h_1 = y;
    this.e5h_1 = scaleX;
    this.f5h_1 = scale01;
    this.g5h_1 = scale10;
    this.h5h_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString(this.b5h_1) + ', x=' + this.c5h_1 + ', y=' + this.d5h_1 + ', scaleX=' + this.e5h_1 + ', scale01=' + this.f5h_1 + ', scale10=' + this.g5h_1 + ', scaleY=' + this.h5h_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b5h_1);
    result = imul(result, 31) + this.c5h_1 | 0;
    result = imul(result, 31) + this.d5h_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.e5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g5h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h5h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.b5h_1, tmp0_other_with_cast.b5h_1))
      return false;
    if (!(this.c5h_1 === tmp0_other_with_cast.c5h_1))
      return false;
    if (!(this.d5h_1 === tmp0_other_with_cast.d5h_1))
      return false;
    if (!equals(this.e5h_1, tmp0_other_with_cast.e5h_1))
      return false;
    if (!equals(this.f5h_1, tmp0_other_with_cast.f5h_1))
      return false;
    if (!equals(this.g5h_1, tmp0_other_with_cast.g5h_1))
      return false;
    if (!equals(this.h5h_1, tmp0_other_with_cast.h5h_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.k5h_1 = $outer;
    this.i5h_1 = glyphID;
    this.j5h_1 = paletteIndex;
  }
  l5h(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.k5h_1.e5a_1, pal).b4f_1);
    var index = this.j5h_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.e1() : false) {
      tmp = this_0.d1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().g43_1);
    }
    return tmp.t4h_1;
  }
  m5h() {
    return this.l5h(0);
  }
  n5h(pal) {
    var tmp135_safe_receiver = this.k5h_1.m5c(this.i5h_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.w21();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.x5h_1, null, new RGBA(this.l5h(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.i5h_1 + ', ' + this.j5h_1 + ', ' + RGBA__toString_impl_4lw6dp(this.m5h()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.y5h(pal) : $super.y5h.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.c5i_1 = $outer;
    this.a5i_1 = glyphID;
    this.b5i_1 = paint;
  }
  y5h(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.c5i_1.f5a_1.u5g_1.h1q(this.b5i_1);
    try {
      this.c5i_1.z5b(this.a5i_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.n4y();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.a5i_1 + '][' + this.b5i_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.g5i_1 = $outer;
    this.d5i_1 = glyphID;
    this.e5i_1 = firstLayerIndex;
    this.f5i_1 = numLayers;
  }
  d1(index) {
    return this.g5i_1.c5a_1[this.e5i_1 + index | 0];
  }
  z56() {
    var tmp = 0;
    var tmp_0 = this.f5i_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.d1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  y5h(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.z56();
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.n5h(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.d5i_1 + '][' + this.f5i_1 + '](' + toString(this.z56()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.w5h_1 = glpyhIndex;
    this.x5h_1 = path;
  }
  q3d(p) {
    this.x5h_1.q3d(p);
  }
  d3e(p) {
    this.x5h_1.d3e(p);
  }
  e3e(c, a) {
    this.x5h_1.e3e(c, a);
  }
  r3d(c1, c2, a) {
    this.x5h_1.r3d(c1, c2, a);
  }
  f6() {
    this.x5h_1.f6();
  }
  x3o(p0, p1) {
    this.x5h_1.x3o(p0, p1);
  }
  y3o(rect) {
    this.x5h_1.y3o(rect);
  }
  z3o(pos, size) {
    this.x5h_1.z3o(pos, size);
  }
  a3p(x, y, width, height) {
    this.x5h_1.a3p(x, y, width, height);
  }
  b3p(center, r, start, end, counterclockwise) {
    this.x5h_1.b3p(center, r, start, end, counterclockwise);
  }
  d3p(center, radius) {
    this.x5h_1.d3p(center, radius);
  }
  e3p(delta) {
    this.x5h_1.e3p(delta);
  }
  f3p(delta) {
    this.x5h_1.f3p(delta);
  }
  k2f(m) {
    return this.x5h_1.k2f(m);
  }
  v3o() {
    return this.x5h_1.v3o();
  }
  w3o() {
    return this.x5h_1.z3d_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.w5h_1 + ', "' + toSvgPathString(this.x5h_1) + '")';
  }
  hashCode() {
    var result = this.w5h_1;
    result = imul(result, 31) + this.x5h_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.w5h_1 === tmp0_other_with_cast.w5h_1))
      return false;
    if (!this.x5h_1.equals(tmp0_other_with_cast.x5h_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.v5h_1 = $outer;
    this.o5h_1 = index;
    this.p5h_1 = xMin;
    this.q5h_1 = yMin;
    this.r5h_1 = xMax;
    this.s5h_1 = yMax;
    this.t5h_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.p5h_1;
    var yMin_0 = this.q5h_1;
    var xMax_0 = this.r5h_1;
    var yMax_0 = this.s5h_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.v5h_1.f5a_1.w5g_1;
      var glyphIDToClipOffset = this.v5h_1.f5a_1.x5g_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.gp(this.o5h_1)) {
        var clipOffset = glyphIDToClipOffset.d1(this.o5h_1);
        tmp_0 = this.v5h_1.x5b(sClipOffset.h1q(clipOffset));
      } else {
        var tmp137_safe_receiver = this.h5i();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.z5h();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.i5i();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.d26());
        xMax_0 = numberToInt(bounds.e26());
        yMin_0 = numberToInt(bounds.f26());
        yMax_0 = numberToInt(bounds.g26());
      }
    }
    var size = this.v5h_1.n59_1;
    var scale = this.v5h_1.r4t(size);
    tmp.u5h_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_2().h2e(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.t5h_1 * scale);
  }
  h5i() {
    return this.v5h_1.d5a_1.d1(this.o5h_1);
  }
  j5i() {
    return this.v5h_1.b5a_1.f3(this.o5h_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.v5i_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.s5i_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s5i_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.b5h_1.w21().x5h_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.b5h_1.o5h_1, new VectorPath(IntArrayList.a2k(gpath.t3d_1.e1()), DoubleArrayList.w2k(gpath.u3d_1.e1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_3().j29().f2a(item.e5h_1, item.h5h_1).l2a(item.c5h_1, -item.d5h_1 | 0);
      this_1.x5h_1.u3p(item.b5h_1.w21().x5h_1, m);
      destination.h(this_1);
    }
    tmp.t5i_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.t5i_1;
    var n = 0;
    while (n < this_2.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.d1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.x5h_1.t3d_1.e1() | 0;
      dataSize = dataSize + gpath_0.x5h_1.u3d_1.e1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.a2k(commandsSize), DoubleArrayList.w2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.t5i_1;
    var n_0 = 0;
    while (n_0 < this_4.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.d1(_unary__edvuaz_0);
      this_3.x5h_1.v3p(it.x5h_1);
    }
    tmp_0.u5i_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.t5h_1 + '](' + toString(this.s5i_1) + ')';
  }
  w21() {
    return this.u5i_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.g5j_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.e5j_1 = path;
    this.f5j_1 = listOf(this.e5j_1);
  }
  w21() {
    return this.e5j_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.w5j_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.p5j_1 = contoursIndices;
    this.q5j_1 = flags;
    this.r5j_1 = xPos;
    this.s5j_1 = yPos;
    this.t5j_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.w5j_1;
    var inductionVariable = 0;
    var last = this.p5j_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.p5j_1[n] + 1 | 0;
        var cend = this.p5j_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.a2k(commandSize), DoubleArrayList.w2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.w5j_1;
    var inductionVariable_0 = 0;
    var last_0 = this.p5j_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.p5j_1[n_0] + 1 | 0;
        var cend_0 = this.p5j_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.x5j(cend_0, this_1.j58_1[0]);
        var next = this.x5j(cstart_0, this_1.j58_1[1]);
        if (curr.a5h_1) {
          this_0.q3d(Vector2D.j28(curr.y5g_1, -curr.z5g_1 | 0));
        } else if (next.a5h_1) {
          this_0.q3d(Vector2D.j28(next.y5g_1, -next.z5g_1 | 0));
        } else {
          this_0.q3d(Vector2D.j28(imul(curr.y5g_1 + next.y5g_1 | 0, numberToInt(0.5)), -numberToInt((curr.z5g_1 + next.z5g_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.x5j(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.j58_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.a5h_1) {
              this_0.d3e(Vector2D.j28(curr.y5g_1, -curr.z5g_1 | 0));
            } else {
              var prev2X = prev.y5g_1;
              var prev2Y = prev.z5g_1;
              var next2X = next.y5g_1;
              var next2Y = next.z5g_1;
              if (!prev.a5h_1) {
                prev2X = numberToInt((curr.y5g_1 + prev.y5g_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.z5g_1 + prev.z5g_1 | 0) * 0.5);
                this_0.d3e(Vector2D.j28(prev2X, -prev2Y | 0));
              }
              if (!next.a5h_1) {
                next2X = numberToInt((curr.y5g_1 + next.y5g_1 | 0) * 0.5);
                next2Y = numberToInt((curr.z5g_1 + next.z5g_1 | 0) * 0.5);
              }
              this_0.d3e(Vector2D.j28(prev2X, -prev2Y | 0));
              this_0.e3e(Vector2D.j28(curr.y5g_1, -curr.z5g_1 | 0), Vector2D.j28(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.f6();
      }
       while (inductionVariable_0 < last_0);
    tmp.u5j_1 = this_0;
    this.v5j_1 = listOf(this.u5j_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.t5j_1 ? 'Dummy' : '') + '[' + this.o5h_1 + '](advance=' + this.t5h_1 + ') : ' + this.u5j_1.toString();
  }
  y5j(n) {
    return !((this.q5j_1[n] & 1) === 0);
  }
  x5j(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.y5g_1 = this.r5j_1[n];
    out.z5g_1 = this.s5j_1[n];
    out.a5h_1 = this.y5j(n);
    return out;
  }
  w21() {
    return this.u5j_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.z5j_1 = firstGlyphIndex;
    this.a5k_1 = lastGlyphIndex;
    this.b5k_1 = additionalOffsetToIndexSubtable;
  }
  c5k() {
    return this.a5k_1 - this.z5j_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.z5j_1 + ', lastGlyphIndex=' + this.a5k_1 + ', additionalOffsetToIndexSubtable=' + this.b5k_1 + ')';
  }
  hashCode() {
    var result = this.z5j_1;
    result = imul(result, 31) + this.a5k_1 | 0;
    result = imul(result, 31) + this.b5k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.z5j_1 === tmp0_other_with_cast.z5j_1))
      return false;
    if (!(this.a5k_1 === tmp0_other_with_cast.a5k_1))
      return false;
    if (!(this.b5k_1 === tmp0_other_with_cast.b5k_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.d5k_1 = ppem;
    this.e5k_1 = ppi;
    this.f5k_1 = strikeOffset;
    this.g5k_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.d5k_1 + ', ppi=' + this.e5k_1 + ', strikeOffset=' + this.f5k_1 + ', offsets=' + this.g5k_1.toString() + ')';
  }
  hashCode() {
    var result = this.d5k_1;
    result = imul(result, 31) + this.e5k_1 | 0;
    result = imul(result, 31) + this.f5k_1 | 0;
    result = imul(result, 31) + this.g5k_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.d5k_1 === tmp0_other_with_cast.d5k_1))
      return false;
    if (!(this.e5k_1 === tmp0_other_with_cast.e5k_1))
      return false;
    if (!(this.f5k_1 === tmp0_other_with_cast.f5k_1))
      return false;
    if (!this.g5k_1.equals(tmp0_other_with_cast.g5k_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.h5k_1 = start;
    this.i5k_1 = endInclusive;
    this.j5k_1 = index;
    this.k5k_1 = (this.i5k_1 - this.h5k_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.h5k_1 + ', endInclusive=' + this.i5k_1 + ', index=' + this.j5k_1 + ')';
  }
  hashCode() {
    var result = this.h5k_1;
    result = imul(result, 31) + this.i5k_1 | 0;
    result = imul(result, 31) + this.j5k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.h5k_1 === tmp0_other_with_cast.h5k_1))
      return false;
    if (!(this.i5k_1 === tmp0_other_with_cast.i5k_1))
      return false;
    if (!(this.j5k_1 === tmp0_other_with_cast.j5k_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.l5k_1 = platformId;
    this.m5k_1 = encodingId;
    this.n5k_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.l5k_1 + ', encodingId=' + this.m5k_1 + ', offset=' + this.n5k_1 + ')';
  }
  hashCode() {
    var result = this.l5k_1;
    result = imul(result, 31) + this.m5k_1 | 0;
    result = imul(result, 31) + this.n5k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.l5k_1 === tmp0_other_with_cast.l5k_1))
      return false;
    if (!(this.m5k_1 === tmp0_other_with_cast.m5k_1))
      return false;
    if (!(this.n5k_1 === tmp0_other_with_cast.n5k_1))
      return false;
    return true;
  }
}
class Companion_22 {
  p5k(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.u5k_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp.w5k_1 = destination;
  }
  d1(index) {
    var tmp0_elvis_lhs = this.w5k_1.f3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.u5k_1 = id;
    this.v5k_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.x5k_1 = Companion_getInstance_14().qw('EXIF');
  }
  y5k(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  z5k(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.y5k(ss, info, debug, $completion) : $super.y5k.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.a5l_1 = function_0;
  }
  ui(a, b) {
    return this.a5l_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.a5l_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.h1();
      var tmp0_iterator = frames.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.h5l_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.j5l_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.t5l_1 = frames;
    this.u5l_1 = direction;
    this.v5l_1 = name;
    this.w5l_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_1(this.t5l_1);
    tmp_1.x5l_1 = tmp0_elvis_lhs == null ? ImageFrame.y5l(0) : tmp0_elvis_lhs;
  }
}
class Companion_24 {
  z5l(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_33.a5m(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.b5m_1 = function_0;
  }
  ui(a, b) {
    return this.b5m_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.b5m_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_1(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.z2i();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_1(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.a2j();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.e5m_1 = new Mixin();
    this.f5m_1 = frames;
    this.g5m_1 = loopCount;
    this.h5m_1 = width;
    this.i5m_1 = height;
    this.j5m_1 = layers;
    this.k5m_1 = animations;
    this.l5m_1 = name;
    this.m5m_1 = new ImageAnimation(this.f5m_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.k5m_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.v5l_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp_1.n5m_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.f5m_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.hc(capacity_0);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.s3();
      destination_0.i3(tmp$ret$3, element_0);
    }
    tmp_2.o5m_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.f5m_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.p5m_1 = sortedWith(this_2, tmp$ret$6);
  }
  ay(_set____db54di) {
    this.e5m_1.ay(_set____db54di);
  }
  by() {
    return this.e5m_1.by();
  }
  q5m() {
    var tmp173_safe_receiver = firstOrNull_1(this.p5m_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.c5m();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString(this.f5m_1) + ')';
  }
}
class Companion_25 {
  r5m(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_30.z5l([item]);
      destination.h(tmp$ret$0);
    }
    return new ImageDataContainer(destination);
  }
  z5l(bitmaps) {
    return Companion_instance_31.r5m(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.s5m_1 = imageDatas;
    var tmp = this;
    tmp.t5m_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.u5m_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  v5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5m_1;
    imageDatasByName$factory();
    return this_0.u1();
  }
  w5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5m_1;
    default$factory();
    return this_0.u1();
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_32 = this;
    this.g3x_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.h3x_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.i3x_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_42();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.x5m_1 = filename;
    this.y5m_1 = width;
    this.z5m_1 = height;
    this.a5n_1 = premultiplied;
    this.b5n_1 = asumePremultiplied;
    this.c5n_1 = requestedMaxSize;
    this.d5n_1 = debug;
    this.e5n_1 = preferKotlinDecoder;
    this.f5n_1 = tryNativeDecode;
    this.g5n_1 = format;
    this.h5n_1 = out;
    this.i5n_1 = extra;
  }
  ay(_set____db54di) {
    this.i5n_1 = _set____db54di;
  }
  by() {
    return this.i5n_1;
  }
  j5n() {
    return this;
  }
  k5n() {
    var tmp0_elvis_lhs = this.a5n_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  l5n(filename) {
    return this.m5n(filename);
  }
  n5n(file) {
    return this.l5n(get_baseName(file));
  }
  o5n(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  m5n(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.x5m_1 : filename;
    width = width === VOID ? this.y5m_1 : width;
    height = height === VOID ? this.z5m_1 : height;
    premultiplied = premultiplied === VOID ? this.a5n_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.b5n_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.c5n_1 : requestedMaxSize;
    debug = debug === VOID ? this.d5n_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.e5n_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.f5n_1 : tryNativeDecode;
    format = format === VOID ? this.g5n_1 : format;
    out = out === VOID ? this.h5n_1 : out;
    extra = extra === VOID ? this.i5n_1 : extra;
    return $super === VOID ? this.o5n(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.o5n.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.x5m_1 + ', width=' + this.y5m_1 + ', height=' + this.z5m_1 + ', premultiplied=' + this.a5n_1 + ', asumePremultiplied=' + this.b5n_1 + ', requestedMaxSize=' + this.c5n_1 + ', debug=' + this.d5n_1 + ', preferKotlinDecoder=' + this.e5n_1 + ', tryNativeDecode=' + this.f5n_1 + ', format=' + toString_0(this.g5n_1) + ', out=' + toString_0(this.h5n_1) + ', extra=' + toString_0(this.i5n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x5m_1);
    result = imul(result, 31) + (this.y5m_1 == null ? 0 : this.y5m_1) | 0;
    result = imul(result, 31) + (this.z5m_1 == null ? 0 : this.z5m_1) | 0;
    result = imul(result, 31) + (this.a5n_1 == null ? 0 : getBooleanHashCode(this.a5n_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b5n_1) | 0;
    result = imul(result, 31) + (this.c5n_1 == null ? 0 : this.c5n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d5n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e5n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f5n_1) | 0;
    result = imul(result, 31) + (this.g5n_1 == null ? 0 : hashCode(this.g5n_1)) | 0;
    result = imul(result, 31) + (this.h5n_1 == null ? 0 : hashCode(this.h5n_1)) | 0;
    result = imul(result, 31) + (this.i5n_1 == null ? 0 : hashCode(this.i5n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.x5m_1 === tmp0_other_with_cast.x5m_1))
      return false;
    if (!(this.y5m_1 == tmp0_other_with_cast.y5m_1))
      return false;
    if (!(this.z5m_1 == tmp0_other_with_cast.z5m_1))
      return false;
    if (!(this.a5n_1 == tmp0_other_with_cast.a5n_1))
      return false;
    if (!(this.b5n_1 === tmp0_other_with_cast.b5n_1))
      return false;
    if (!(this.c5n_1 == tmp0_other_with_cast.c5n_1))
      return false;
    if (!(this.d5n_1 === tmp0_other_with_cast.d5n_1))
      return false;
    if (!(this.e5n_1 === tmp0_other_with_cast.e5n_1))
      return false;
    if (!(this.f5n_1 === tmp0_other_with_cast.f5n_1))
      return false;
    if (!equals(this.g5n_1, tmp0_other_with_cast.g5n_1))
      return false;
    if (!equals(this.h5n_1, tmp0_other_with_cast.h5n_1))
      return false;
    if (!equals(this.i5n_1, tmp0_other_with_cast.i5n_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static q5n(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.f5f_1 = mimeType;
    var tmp = $this;
    tmp.g5f_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.h5f_1 = toSet(destination);
    return $this;
  }
  j5n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g5f_1;
    decodingProps$factory();
    return this_0.u1();
  }
  s5n(s, props) {
    return this.r5n(s, props).w5m();
  }
  t5n(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.p5n(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.v5n_1 = bmp.x3z_1;
      this_0.w5n_1 = bmp.y3z_1;
      this_0.x5n_1 = bmp.z3z_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  p5n(s, props) {
    return this.s5n(s, props).q5m();
  }
  y5n(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.t5n(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  z5n(s, props) {
    return this.p5n(s, props);
  }
  i5f(s, props, $super) {
    props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
    return $super === VOID ? this.z5n(s, props) : $super.z5n.call(this, s, props);
  }
  a5o(data, props) {
    return this.p5n(openSync(data), props);
  }
  b5o(data, props, $completion) {
    return this.a5o(data, props);
  }
  c5o(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString(this.h5f_1) + ')';
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static h5o(formats) {
    var $this = this.q5n(['']);
    $this.g5o_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static i5o(formats) {
    return this.h5o(toList_1(formats));
  }
  j5o(_set____db54di) {
    var this_0 = this.g5o_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  k5o() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.g5o_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  l5o() {
    return this.k5o();
  }
  toString() {
    return 'ImageFormats(' + this.l5o().e1() + ')' + toString(this.l5o());
  }
  t5n(s, props) {
    if (this.l5o().g1())
      return null;
    var _iterator__ex2g4s = this.l5o().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.t5n(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  r5n(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.l5o().a1();
      while (_iterator__ex2g4s.b1()) {
        var format = _iterator__ex2g4s.c1();
        if (format.y5n(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.r5n(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.da('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
}
class ImageFormatsMutable extends ImageFormats {
  static r5o() {
    var $this = this.i5o([]);
    $this.q5o_1 = new NonRecursiveLock();
    return $this;
  }
  static s5o(formats) {
    var $this = this.r5o();
    $this.t5o(formats.slice());
    return $this;
  }
  t5o(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.q5o_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.j5o(minus(plus_1(this.k5o(), formats), this));
    return this;
  }
}
class Companion_27 {
  u5o(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.v5o(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  a5m(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.u5o(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.u5o.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static y5l(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.e5l_1 = new Mixin();
    $this.f5l_1 = index;
    $this.g5l_1 = fastTime;
    $this.h5l_1 = layerData;
    $this.i5l_1 = firstOrNull_1($this.h5l_1);
    return $this;
  }
  ay(_set____db54di) {
    this.e5l_1.ay(_set____db54di);
  }
  by() {
    return this.e5l_1.by();
  }
  w5o() {
    return toDuration_0(this.g5l_1);
  }
  static v5o(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.y5l(index, get_fast(time), layerData);
  }
  x5o() {
    var tmp177_safe_receiver = this.i5l_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.s5l_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  y5o() {
    var tmp178_safe_receiver = this.i5l_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.k5l_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  z5o() {
    var tmp179_safe_receiver = this.i5l_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.l5l_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  d5m() {
    var tmp180_safe_receiver = this.i5l_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.m5l_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  z2i() {
    return this.x5o().x3f_1;
  }
  a2j() {
    return this.x5o().y3f_1;
  }
  c5m() {
    var tmp182_safe_receiver = this.i5l_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.c5m();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  s3() {
    return this.x5o().s3f_1;
  }
  toString() {
    return 'ImageFrame(' + this.x5o().toString() + ', time=' + Duration__toString_impl_8d916b(this.w5o()) + ', targetX=' + this.y5o() + ', targetY=' + this.z5o() + ', main=' + this.d5m() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.j5l_1 = layer;
    this.k5l_1 = targetX;
    this.l5l_1 = targetY;
    this.m5l_1 = main;
    this.n5l_1 = includeInAtlas;
    this.o5l_1 = tilemap;
    this.p5l_1 = ninePatchSlice;
    this.q5l_1 = null;
    this.r5l_1 = null;
    this.s5l_1 = slice;
  }
  z2i() {
    return this.s5l_1.x3f_1;
  }
  a2j() {
    return this.s5l_1.y3f_1;
  }
  c5m() {
    if (get_bmp(this.s5l_1).x3z_1 === this.z2i() && get_bmp(this.s5l_1).y3z_1 === this.a2j())
      return get_bmp(this.s5l_1);
    if (this.q5l_1 == null)
      this.q5l_1 = extract_0(this.s5l_1);
    return ensureNotNull(this.q5l_1);
  }
}
class ImageInfo {
  constructor() {
    this.u5n_1 = new Mixin();
    this.v5n_1 = 0;
    this.w5n_1 = 0;
    this.x5n_1 = 8;
  }
  ay(_set____db54di) {
    this.u5n_1.ay(_set____db54di);
  }
  by() {
    return this.u5n_1.by();
  }
  toString() {
    var tmp = this.v5n_1;
    var tmp_0 = this.w5n_1;
    var tmp_1 = this.x5n_1;
    var tmp183_safe_receiver = this.by();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString_0(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a5p_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.b5l_1 = index;
    this.c5l_1 = name;
    this.d5l_1 = type;
  }
}
class NativeImageFormatProvider {
  d5p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  x5p(_this__u8e3s4, props) {
    return this.z5p(_this__u8e3s4, props);
  }
  z5p(image, props) {
    return this.y5p(toBitmap_0(image.m3v()), props);
  }
  w5p(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  b5o(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  a5q(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  c5o(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  x4d(width, height, premultiplied) {
    return BitmapNativeImage.f5q(Bitmap32.q3z(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  w4d(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.x4d(bmp.x3z_1, bmp.y3z_1, bmp.d40_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.b40_1;
    if (true) {
      this_0.k40();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.t47(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.g5q(bmp, Companion_getInstance_0().o25_1);
      }finally {
        ctx.l18();
      }
    }finally {
      result = true ? this_0.m40(rect) : 0;
    }
    return this_0;
  }
  b5q(bmp) {
    return BitmapNativeImage.v5p(bmp);
  }
  y5p(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.b5n_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.a5n_1 == null || props.a5n_1 === _this__u8e3s4.d40_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.u47();
    if (props.b5n_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.d40_1 && props.a5n_1 === false) {
      out.c4b();
    } else if (_this__u8e3s4.d40_1 && props.a5n_1 === true) {
      out.b4b();
    }
    return this.b5q(out);
  }
  b5p(_this__u8e3s4, props) {
    return new NativeImageResult(this.y5p(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  d5p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  e5p(bmp) {
    return BitmapNativeImage.v5p(bmp);
  }
  c5p(bmp, props) {
    var bmp32 = bmp.u47();
    return new NativeImageResult(this.e5p(props.b5n_1 ? asumePremultiplied(bmp32) : props.k5n() ? bmp32.y4a() : bmp32.z4a()));
  }
  x4d(width, height, premultiplied) {
    return this.e5p(Bitmap32.q3z(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  w4d(bmp) {
    return this.e5p(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.x3z_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.y3z_1 : originalHeight;
    this.c5q_1 = image;
    this.d5q_1 = originalWidth;
    this.e5q_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.c5q_1.toString() + ', originalWidth=' + this.d5q_1 + ', originalHeight=' + this.e5q_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.c5q_1);
    result = imul(result, 31) + this.d5q_1 | 0;
    result = imul(result, 31) + this.e5q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.c5q_1, tmp0_other_with_cast.c5q_1))
      return false;
    if (!(this.d5q_1 === tmp0_other_with_cast.d5q_1))
      return false;
    if (!(this.e5q_1 === tmp0_other_with_cast.e5q_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static f5q(bitmap) {
    var $this = this.v4d(bitmap.x3z_1, bitmap.y3z_1, bitmap, bitmap.d40_1);
    $this.t5p_1 = bitmap;
    $this.u5p_1 = $this.t5p_1.n3z_1;
    return $this;
  }
  s3() {
    return 'BitmapNativeImage';
  }
  static v5p(bitmap) {
    return this.f5q(bitmap.u47());
  }
  t47(antialiasing) {
    return this.t5p_1.t47(antialiasing);
  }
  j40() {
    return this.t5p_1;
  }
  u40(x, y, width, height, out, offset) {
    return this.t5p_1.u40(x, y, width, height, out, offset);
  }
  w40(x, y, width, height, out, offset) {
    return this.t5p_1.w40(x, y, width, height, out, offset);
  }
  x40(x, y, v) {
    return this.t5p_1.x40(x, y, v);
  }
  v40(x, y) {
    return this.t5p_1.v40(x, y);
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.j5q_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp.l5q_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.m5q_1 = startingRow;
    this.n5q_1 = startingCol;
    this.o5q_1 = rowIncrement;
    this.p5q_1 = colIncrement;
    this.q5q_1 = blockHeight;
    this.r5q_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.p5q_1;
    var tmp$ret$0 = log2(x);
    tmp.s5q_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.m5q_1 + ', startingCol=' + this.n5q_1 + ', rowIncrement=' + this.o5q_1 + ', colIncrement=' + this.p5q_1 + ', blockHeight=' + this.q5q_1 + ', blockWidth=' + this.r5q_1 + ')';
  }
  hashCode() {
    var result = this.m5q_1;
    result = imul(result, 31) + this.n5q_1 | 0;
    result = imul(result, 31) + this.o5q_1 | 0;
    result = imul(result, 31) + this.p5q_1 | 0;
    result = imul(result, 31) + this.q5q_1 | 0;
    result = imul(result, 31) + this.r5q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.m5q_1 === tmp0_other_with_cast.m5q_1))
      return false;
    if (!(this.n5q_1 === tmp0_other_with_cast.n5q_1))
      return false;
    if (!(this.o5q_1 === tmp0_other_with_cast.o5q_1))
      return false;
    if (!(this.p5q_1 === tmp0_other_with_cast.p5q_1))
      return false;
    if (!(this.q5q_1 === tmp0_other_with_cast.q5q_1))
      return false;
    if (!(this.r5q_1 === tmp0_other_with_cast.r5q_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.j5q_1 = id;
    this.k5q_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.t5q_1 = width;
    this.u5q_1 = height;
    this.v5q_1 = bitsPerChannel;
    this.w5q_1 = colorspace;
    this.x5q_1 = compressionmethod;
    this.y5q_1 = filtermethod;
    this.z5q_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.w5q_1.r3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.a5r_1 = tmp_0;
    this.b5r_1 = imul(imul(this.t5q_1, this.a5r_1), this.v5q_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.c5r_1 = header;
    this.d5r_1 = _UByteArrayInt___init__impl__xif7bu_0(this.c5r_1.b5r_1);
    this.e5r_1 = _UByteArrayInt___init__impl__xif7bu_0(this.c5r_1.b5r_1);
    this.f5r_1 = Companion_instance_15.f4b(this.c5r_1.t5q_1);
  }
  p5r() {
    var temp = this.e5r_1;
    this.e5r_1 = this.d5r_1;
    this.d5r_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.q5r_1 = $data;
    this.r5r_1 = $info;
  }
  ud($completion) {
    return EXIF_getInstance().z5k(openAsync(readAll_0(this.q5r_1)), this.r5r_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static s5r() {
    PNG_instance = null;
    var $this = this.q5n(['png']);
    PNG_instance = $this;
    $this.j5r_1 = -1991225785;
    $this.k5r_1 = 218765834;
    $this.l5r_1 = listOf_0([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.m5r_1 = listOf(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  t5n(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  r5n(s, props) {
    var tmp = Companion_instance_31;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.z5l([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  t5r(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  n5r(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.t5r(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.td('An operation is not implemented: ' + reason);
    }
  }
  o5r(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.n5r(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.n5r.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  x5r(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.w5r(n, yFloat));
      }
       while (!(n === x1));
  }
  y5r(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.n3z_1);
    var inductionVariable = rect.f26();
    var last = rect.g26();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.x3z_1);
        this.x5r(cols, offset, rect.d26(), rect.e26() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  z5r(bmp, rect, $super) {
    rect = rect === VOID ? bmp.p3z_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.y5r(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.y5r.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.u5r_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().g41_1);
  }
  v5r(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.u5r_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  w5r(x, y) {
    return this.u5r_1;
  }
  x5r(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.u5r_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_30 {
  constructor() {
    this.a5s_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.b5s_1 = Companion_instance_18.w4r(256);
  }
  d5s(fill, state) {
    fill.e5s(this.b5s_1);
    this.c5s_1 = fill.f5s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_3().g29_1.z2a(fill.a5g_1).z2a(state.v4t_1));
    return this;
  }
  g5s(x, y) {
    return _get_fill__d6ivc8(this).h5s(Vector2D.q2a(x, y));
  }
  w5r(x, y) {
    return color(this, this.g5s(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.i5s_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.j5s_1 = 0.0;
    this.k5s_1 = 0.0;
    this.l5s_1 = 0.0;
    this.m5s_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.n5s_1 = get_bmp(tmp$ret$0);
    this.o5s_1 = Companion_getInstance_3().g29_1;
    this.p5s_1 = true;
    this.q5s_1 = Companion_getInstance_3().g29_1;
  }
  r5s(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.i5s_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.u5s_1, fill.v5s_1);
    _set_texture__qu271y(this, fill.y5s_1);
    this.o5s_1 = fill.t5s_1;
    this.p5s_1 = fill.w5s_1;
    this.q5s_1 = Companion_getInstance_3().g29_1.s2a(state.v4t_1).s2a(fill.t5s_1).t2a();
    return this;
  }
  z5s(x, y) {
    return this.n5s_1.d41(x, y);
  }
  a5t(x, y) {
    return this.n5s_1.n49(numberToInt(x), numberToInt(y));
  }
  w5r(x, y) {
    var mat = this.q5s_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.q2a(x, y);
      if (mat.b26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.w27(mat.y29(p.m25_1, p.n25_1), mat.b2a(p.m25_1, p.n25_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.q2a(this.l5s_1, this.m5s_1);
    var p_0 = Vector2D.w27(this_0.m25_1 * that.m25_1, this_0.n25_1 * that.n25_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.i5s_1, p_0);
    var that_0 = Vector2D.q2a(this.j5s_1, this.k5s_1);
    var t = Vector2D.w27(this_1.m25_1 * that_0.m25_1, this_1.n25_1 * that_0.n25_1);
    return this.p5s_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.z5s(t.m25_1, t.n25_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.a5t(t.m25_1, t.n25_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  w5r(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  x5r(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_31 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.w2k() : stops;
    colors = colors === VOID ? IntArrayList.a2k() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_3().g29_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_5().d25_1 : startAngle;
    this.q5f_1 = kind;
    this.r5f_1 = x0;
    this.s5f_1 = y0;
    this.t5f_1 = r0;
    this.u5f_1 = x1;
    this.v5f_1 = y1;
    this.w5f_1 = r1;
    this.x5f_1 = stops;
    this.y5f_1 = colors;
    this.z5f_1 = cycle;
    this.a5g_1 = transform;
    this.b5g_1 = interpolationMethod;
    this.c5g_1 = units;
    this.d5g_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_3().g29_1.m2a(-this.r5f_1, -this.s5f_1).h2a(1.0 / clamp_1(Companion_getInstance_0().n2f(this.r5f_1, this.s5f_1, this.u5f_1, this.v5f_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_5();
    var x0_0 = this.r5f_1;
    var y0_0 = this.s5f_1;
    var x1_0 = this.u5f_1;
    var y1_0 = this.v5f_1;
    var up = Companion_getInstance_0().s25_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.e5g_1 = tmp_0.e2a(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.f5g_1 = this.a5g_1.t2a();
    this.g5g_1 = Companion_getInstance_3().g29_1.s2a(this.e5g_1).s2a(this.f5g_1);
    this.h5g_1 = 2 * this.t5f_1 * this.w5f_1;
    this.i5g_1 = this.b5t(this.t5f_1);
    this.j5g_1 = this.b5t(this.w5f_1);
    this.k5g_1 = this.s5f_1 - this.v5f_1;
    this.l5g_1 = this.t5f_1 - this.w5f_1;
    this.m5g_1 = this.r5f_1 - this.u5f_1;
    this.n5g_1 = 1.0 / (this.b5t(this.t5f_1 - this.w5f_1) - this.b5t(this.r5f_1 - this.u5f_1) - this.b5t(this.s5f_1 - this.v5f_1));
  }
  w53() {
    return this.a5g_1;
  }
  e5s(out) {
    return _fillColors(Companion_instance_37, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.x5f_1, this.y5f_1, true);
  }
  o5g(stop, color) {
    return this.c5t(stop, color);
  }
  c5t(stop, color) {
    this.x5f_1.e2l(stop);
    this.y5f_1.j2k(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  h5s(p) {
    var tmp;
    switch (this.q5f_1.r3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.f5g_1;
          if (this_0.b26()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.w27(this_0.y29(p.m25_1, p.n25_1), this_0.b2a(p.m25_1, p.n25_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_0().a2h(Vector2D.w27(this.r5f_1, this.s5f_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.f5g_1;
          if (this_1.b26()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.w27(this_1.y29(p.m25_1, p.n25_1), this_1.b2a(p.m25_1, p.n25_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.jl();
        var y = _destruct__k2r9zo.kl();
        var tmp_0 = -this.w5f_1 * this.l5g_1 + this.m5g_1 * (this.u5f_1 - x) + this.k5g_1 * (this.v5f_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.j5g_1 * (this.b5t(this.r5f_1 - x) + this.b5t(this.s5f_1 - y)) - this.h5g_1 * ((this.r5f_1 - x) * (this.u5f_1 - x) + (this.s5f_1 - y) * (this.v5f_1 - y)) + this.i5g_1 * (this.b5t(this.u5f_1 - x) + this.b5t(this.v5f_1 - y)) - this.b5t(this.u5f_1 * this.s5f_1 - x * this.s5f_1 - this.r5f_1 * this.v5f_1 + x * this.v5f_1 + this.r5f_1 * y - this.u5f_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.n5g_1;
        break;
      default:
        tmp = this.g5g_1.x29(p);
        break;
    }
    return this.z5f_1.f5t(tmp);
  }
  b5t(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  wx() {
    return this.f5s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.a5g_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.q5f_1.r3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.r5f_1 + ', ' + this.s5f_1 + '], [' + this.u5f_1 + ', ' + this.v5f_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.r5f_1 + ', ' + this.s5f_1 + ', ' + this.t5f_1 + '], [' + this.u5f_1 + ', ' + this.v5f_1 + ', ' + this.w5f_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.r5f_1 + ', ' + this.s5f_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.tb(tmp);
    this_0.tb(', stops=' + this.x5f_1.toString() + ', colors=' + colorsToString_0(this, this.y5f_1) + ', cycle=' + this.z5f_1.toString() + ', transform=' + this.a5g_1.toString() + ', interpolationMethod=' + this.b5g_1.toString() + ', units=' + this.c5g_1.toString() + ')');
    return this_0.toString();
  }
  g5t(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  f5s(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.q5f_1 : kind;
    x0 = x0 === VOID ? this.r5f_1 : x0;
    y0 = y0 === VOID ? this.s5f_1 : y0;
    r0 = r0 === VOID ? this.t5f_1 : r0;
    x1 = x1 === VOID ? this.u5f_1 : x1;
    y1 = y1 === VOID ? this.v5f_1 : y1;
    r1 = r1 === VOID ? this.w5f_1 : r1;
    stops = stops === VOID ? this.x5f_1 : stops;
    colors = colors === VOID ? this.y5f_1 : colors;
    cycle = cycle === VOID ? this.z5f_1 : cycle;
    transform = transform === VOID ? this.a5g_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.b5g_1 : interpolationMethod;
    units = units === VOID ? this.c5g_1 : units;
    startAngle = startAngle === VOID ? this.d5g_1 : startAngle;
    return $super === VOID ? this.g5t(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.g5t.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.q5f_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.r5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v5f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w5f_1) | 0;
    result = imul(result, 31) + this.x5f_1.hashCode() | 0;
    result = imul(result, 31) + this.y5f_1.hashCode() | 0;
    result = imul(result, 31) + this.z5f_1.hashCode() | 0;
    result = imul(result, 31) + this.a5g_1.hashCode() | 0;
    result = imul(result, 31) + this.b5g_1.hashCode() | 0;
    result = imul(result, 31) + this.c5g_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.d5g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.q5f_1.equals(tmp0_other_with_cast.q5f_1))
      return false;
    if (!equals(this.r5f_1, tmp0_other_with_cast.r5f_1))
      return false;
    if (!equals(this.s5f_1, tmp0_other_with_cast.s5f_1))
      return false;
    if (!equals(this.t5f_1, tmp0_other_with_cast.t5f_1))
      return false;
    if (!equals(this.u5f_1, tmp0_other_with_cast.u5f_1))
      return false;
    if (!equals(this.v5f_1, tmp0_other_with_cast.v5f_1))
      return false;
    if (!equals(this.w5f_1, tmp0_other_with_cast.w5f_1))
      return false;
    if (!this.x5f_1.equals(tmp0_other_with_cast.x5f_1))
      return false;
    if (!this.y5f_1.equals(tmp0_other_with_cast.y5f_1))
      return false;
    if (!this.z5f_1.equals(tmp0_other_with_cast.z5f_1))
      return false;
    if (!this.a5g_1.equals(tmp0_other_with_cast.a5g_1))
      return false;
    if (!this.b5g_1.equals(tmp0_other_with_cast.b5g_1))
      return false;
    if (!this.c5g_1.equals(tmp0_other_with_cast.c5g_1))
      return false;
    if (!equals(this.d5g_1, tmp0_other_with_cast.d5g_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  wx() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_3().g29_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.s5s_1 = bitmap;
    this.t5s_1 = transform;
    this.u5s_1 = cycleX;
    this.v5s_1 = cycleY;
    this.w5s_1 = smooth;
    this.x5s_1 = units;
    this.y5s_1 = this.s5s_1.j40();
  }
  w53() {
    return this.t5s_1;
  }
  h5t() {
    return this.u5s_1.i5t();
  }
  j5t() {
    return this.v5s_1.i5t();
  }
  wx() {
    return this.k5t(VOID, this.t5s_1);
  }
  toString() {
    return 'BitmapPaint(' + toString(this.s5s_1) + ', cycle=(' + this.u5s_1.toString() + ', ' + this.v5s_1.toString() + '), smooth=' + this.w5s_1 + ', transform=' + this.t5s_1.toString() + ')';
  }
  l5t(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  k5t(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.s5s_1 : bitmap;
    transform = transform === VOID ? this.t5s_1 : transform;
    cycleX = cycleX === VOID ? this.u5s_1 : cycleX;
    cycleY = cycleY === VOID ? this.v5s_1 : cycleY;
    smooth = smooth === VOID ? this.w5s_1 : smooth;
    units = units === VOID ? this.x5s_1 : units;
    return $super === VOID ? this.l5t(bitmap, transform, cycleX, cycleY, smooth, units) : $super.l5t.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.s5s_1);
    result = imul(result, 31) + this.t5s_1.hashCode() | 0;
    result = imul(result, 31) + this.u5s_1.hashCode() | 0;
    result = imul(result, 31) + this.v5s_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w5s_1) | 0;
    result = imul(result, 31) + this.x5s_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.s5s_1, tmp0_other_with_cast.s5s_1))
      return false;
    if (!this.t5s_1.equals(tmp0_other_with_cast.t5s_1))
      return false;
    if (!this.u5s_1.equals(tmp0_other_with_cast.u5s_1))
      return false;
    if (!this.v5s_1.equals(tmp0_other_with_cast.v5s_1))
      return false;
    if (!(this.w5s_1 === tmp0_other_with_cast.w5s_1))
      return false;
    if (!this.x5s_1.equals(tmp0_other_with_cast.x5s_1))
      return false;
    return true;
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp263_font = get_DefaultTtfFont();
    tmp.a5u_1 = new Style(tmp263_font, 16.0);
  }
}
class Line {
  static k5u(nodes, defaultLineStyle) {
    defaultLineStyle = defaultLineStyle === VOID ? null : defaultLineStyle;
    var $this = createThis(this);
    $this.m5t_1 = new Mixin();
    $this.n5t_1 = nodes;
    $this.o5t_1 = defaultLineStyle;
    var tmp = $this;
    tmp.p5t_1 = lazy(RichTextData$Line$defaultStyle$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.q5t_1 = lazy(RichTextData$Line$defaultLastStyle$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.r5t_1 = lazy(RichTextData$Line$text$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.s5t_1 = lazy(RichTextData$Line$width$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.t5t_1 = lazy(RichTextData$Line$maxLineHeight$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.u5t_1 = lazy(RichTextData$Line$maxHeight$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.v5t_1 = lazy(RichTextData$Line$allFonts$delegate$lambda($this));
    return $this;
  }
  ay(_set____db54di) {
    this.m5t_1.ay(_set____db54di);
  }
  by() {
    return this.m5t_1.by();
  }
  static l5u(nodes) {
    return this.k5u(toList_1(nodes));
  }
  c5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5t_1;
    defaultStyle$factory();
    return this_0.u1();
  }
  m5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q5t_1;
    defaultLastStyle$factory();
    return this_0.u1();
  }
  b5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r5t_1;
    text$factory();
    return this_0.u1();
  }
  z2i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s5t_1;
    width$factory_0();
    return this_0.u1();
  }
  n5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5t_1;
    maxLineHeight$factory();
    return this_0.u1();
  }
  o5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5t_1;
    maxHeight$factory();
    return this_0.u1();
  }
  p5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5t_1;
    allFonts$factory_0();
    return this_0.u1();
  }
  q5u() {
    var out = toDeque(this.n5t_1);
    $l$loop_2: while (true) {
      var first = firstOrNull_0(out);
      var last = lastOrNull_1(out);
      if (first instanceof TextNode) {
        if (isBlank(first.x5t_1)) {
          out.qk();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimStart' call
        var this_0 = first.x5t_1;
        var trimmed = toString(trimStart(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        if (!(trimmed === first.x5t_1)) {
          out.qk();
          out.z2l(first.r5u(trimmed));
          continue $l$loop_2;
        }
      }
      if (last instanceof TextNode) {
        if (isBlank(last.x5t_1)) {
          out.sk();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimEnd' call
        var this_1 = last.x5t_1;
        var trimmed_0 = toString(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (!(trimmed_0 === last.x5t_1)) {
          out.sk();
          out.y2l(last.r5u(trimmed_0));
          continue $l$loop_2;
        }
      }
      break $l$loop_2;
    }
    return Line.k5u(toList(out));
  }
  toString() {
    return 'Line(nodes=' + toString(this.n5t_1) + ', defaultLineStyle=' + toString_0(this.o5t_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.n5t_1);
    result = imul(result, 31) + (this.o5t_1 == null ? 0 : this.o5t_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!equals(this.n5t_1, tmp0_other_with_cast.n5t_1))
      return false;
    if (!equals(this.o5t_1, tmp0_other_with_cast.o5t_1))
      return false;
    return true;
  }
}
class Node {}
function get_lineHeight() {
  return this.a2j();
}
class Style {
  constructor(font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_48();
    textSize = textSize === VOID ? 16.0 : textSize;
    italic = italic === VOID ? false : italic;
    bold = bold === VOID ? false : bold;
    underline = underline === VOID ? false : underline;
    color = color === VOID ? null : color;
    canBreak = canBreak === VOID ? true : canBreak;
    this.d5u_1 = font;
    this.e5u_1 = textSize;
    this.f5u_1 = italic;
    this.g5u_1 = bold;
    this.h5u_1 = underline;
    this.i5u_1 = color;
    this.j5u_1 = canBreak;
  }
  s5u(font, textSize, italic, bold, underline, color, canBreak) {
    return new Style(font, textSize, italic, bold, underline, color, canBreak);
  }
  t5u(font, textSize, italic, bold, underline, color, canBreak, $super) {
    font = font === VOID ? this.d5u_1 : font;
    textSize = textSize === VOID ? this.e5u_1 : textSize;
    italic = italic === VOID ? this.f5u_1 : italic;
    bold = bold === VOID ? this.g5u_1 : bold;
    underline = underline === VOID ? this.h5u_1 : underline;
    color = color === VOID ? this.i5u_1 : color;
    canBreak = canBreak === VOID ? this.j5u_1 : canBreak;
    var tmp;
    if ($super === VOID) {
      tmp = this.s5u(font, textSize, italic, bold, underline, color, canBreak);
    } else {
      var tmp_0 = $super.s5u;
      var tmp_1 = color;
      tmp = tmp_0.call(this, font, textSize, italic, bold, underline, tmp_1 == null ? null : new RGBA(tmp_1), canBreak);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.d5u_1);
    var tmp_0 = this.i5u_1;
    return 'Style(font=' + tmp + ', textSize=' + this.e5u_1 + ', italic=' + this.f5u_1 + ', bold=' + this.g5u_1 + ', underline=' + this.h5u_1 + ', color=' + toString_0(tmp_0 == null ? null : new RGBA(tmp_0)) + ', canBreak=' + this.j5u_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d5u_1);
    result = imul(result, 31) + getNumberHashCode(this.e5u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f5u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g5u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h5u_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.i5u_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.i5u_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Style))
      return false;
    var tmp0_other_with_cast = other instanceof Style ? other : THROW_CCE();
    if (!equals(this.d5u_1, tmp0_other_with_cast.d5u_1))
      return false;
    if (!equals(this.e5u_1, tmp0_other_with_cast.e5u_1))
      return false;
    if (!(this.f5u_1 === tmp0_other_with_cast.f5u_1))
      return false;
    if (!(this.g5u_1 === tmp0_other_with_cast.g5u_1))
      return false;
    if (!(this.h5u_1 === tmp0_other_with_cast.h5u_1))
      return false;
    var tmp = this.i5u_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.i5u_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!(this.j5u_1 === tmp0_other_with_cast.j5u_1))
      return false;
    return true;
  }
}
class TextNode {
  constructor(text, style) {
    style = style === VOID ? Companion_getInstance_48().a5u_1 : style;
    this.w5t_1 = new Mixin();
    this.x5t_1 = text;
    this.y5t_1 = style;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!contains(this.x5t_1, _Char___init__impl__6a9atx(10))) {
      // Inline function 'korlibs.image.text.TextNode.<anonymous>' call
      var message = 'Single RichTextData nodes cannot have line breaks';
      throw IllegalArgumentException.l(toString(message));
    }
    var tmp = this;
    tmp.z5t_1 = lazy(RichTextData$TextNode$bounds$delegate$lambda(this));
  }
  ay(_set____db54di) {
    this.w5t_1.ay(_set____db54di);
  }
  by() {
    return this.w5t_1.by();
  }
  b5u() {
    return this.x5t_1;
  }
  i5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5t_1;
    bounds$factory();
    return this_0.u1();
  }
  z2i() {
    return this.i5i().z2i();
  }
  o4s() {
    return this.i5i().o4s();
  }
  a2j() {
    return this.i5i().q51();
  }
  u5u(text, style) {
    return new TextNode(text, style);
  }
  r5u(text, style, $super) {
    text = text === VOID ? this.x5t_1 : text;
    style = style === VOID ? this.y5t_1 : style;
    return $super === VOID ? this.u5u(text, style) : $super.u5u.call(this, text, style);
  }
  toString() {
    return 'TextNode(text=' + this.x5t_1 + ', style=' + this.y5t_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x5t_1);
    result = imul(result, 31) + this.y5t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextNode))
      return false;
    var tmp0_other_with_cast = other instanceof TextNode ? other : THROW_CCE();
    if (!(this.x5t_1 === tmp0_other_with_cast.x5t_1))
      return false;
    if (!this.y5t_1.equals(tmp0_other_with_cast.y5t_1))
      return false;
    return true;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_39 = this;
    this.v5u_1 = Regex.oh('\\W+');
  }
  w5u(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextNode) {
      tmp = _this__u8e3s4.r5u(VOID, _this__u8e3s4.y5t_1.t5u(VOID, VOID, VOID, VOID, VOID, VOID, false));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  x5u(maxLineWidth, line, addNode) {
    var chunk = RichTextData.f5v([Line.k5u(plus_0(listOf(this.w5u(addNode)), line.n5t_1))]).g5v(maxLineWidth, true);
    var nodes = first(chunk.z5u_1).n5t_1;
    return Line.k5u(plus_2(drop(nodes, 1), first(nodes)));
  }
  h5v(text) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return emptyList();
    var parts = this.i5v(text);
    if (parts.e1() === 1) {
      return splitInChunks(text, 1);
    } else {
      return parts;
    }
  }
  i5v(text) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = splitKeep(text, this.v5u_1);
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.text.matches' call
      if (Companion_getInstance_49().v5u_1.ph(element)) {
        // Inline function 'kotlin.text.map' call
        // Inline function 'kotlin.text.mapTo' call
        var destination_0 = ArrayList.w(charSequenceLength(element));
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(element)) {
          var item = charSequenceGet(element, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>.<anonymous>' call
          var tmp$ret$1 = toString_1(item);
          destination_0.h(tmp$ret$1);
        }
        tmp = destination_0;
      } else {
        tmp = listOf(element);
      }
      var list = tmp;
      addAll(destination, list);
    }
    return destination;
  }
}
class RichTextData {
  static j5v(lines, defaultStyle) {
    Companion_getInstance_49();
    var tmp;
    if (defaultStyle === VOID) {
      var tmp260_safe_receiver = firstOrNull_1(lines);
      var tmp0_elvis_lhs = tmp260_safe_receiver == null ? null : tmp260_safe_receiver.c5u();
      tmp = tmp0_elvis_lhs == null ? Companion_getInstance_48().a5u_1 : tmp0_elvis_lhs;
    } else {
      tmp = defaultStyle;
    }
    defaultStyle = tmp;
    var $this = createThis(this);
    $this.y5u_1 = new Mixin();
    $this.z5u_1 = lines;
    $this.a5v_1 = defaultStyle;
    var tmp_0 = $this;
    tmp_0.b5v_1 = lazy(RichTextData$text$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.c5v_1 = lazy(RichTextData$width$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.d5v_1 = lazy(RichTextData$height$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.e5v_1 = lazy(RichTextData$allFonts$delegate$lambda($this));
    return $this;
  }
  ay(_set____db54di) {
    this.y5u_1.ay(_set____db54di);
  }
  by() {
    return this.y5u_1.by();
  }
  k5v(element) {
    return this.z5u_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof Line))
      return false;
    return this.k5v(element instanceof Line ? element : THROW_CCE());
  }
  l5v(elements) {
    return this.z5u_1.a3(elements);
  }
  a3(elements) {
    return this.l5v(elements);
  }
  d1(index) {
    return this.z5u_1.d1(index);
  }
  m5v(element) {
    return this.z5u_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof Line))
      return -1;
    return this.m5v(element instanceof Line ? element : THROW_CCE());
  }
  g1() {
    return this.z5u_1.g1();
  }
  a1() {
    return this.z5u_1.a1();
  }
  b3() {
    return this.z5u_1.b3();
  }
  i1(index) {
    return this.z5u_1.i1(index);
  }
  c3(fromIndex, toIndex) {
    return this.z5u_1.c3(fromIndex, toIndex);
  }
  e1() {
    return this.z5u_1.e1();
  }
  static f5v(lines) {
    Companion_getInstance_49();
    return this.j5v(toList_1(lines));
  }
  static n5v(text, style) {
    Companion_getInstance_49();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split_0(text, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.RichTextData.<init>.<anonymous>' call
      var tmp$ret$0 = Line.l5u([new TextNode(item, style)]);
      destination.h(tmp$ret$0);
    }
    return this.j5v(destination);
  }
  static o5v(text, font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_49();
    font = font === VOID ? Companion_getInstance_48().a5u_1.d5u_1 : font;
    textSize = textSize === VOID ? Companion_getInstance_48().a5u_1.e5u_1 : textSize;
    italic = italic === VOID ? Companion_getInstance_48().a5u_1.f5u_1 : italic;
    bold = bold === VOID ? Companion_getInstance_48().a5u_1.g5u_1 : bold;
    underline = underline === VOID ? Companion_getInstance_48().a5u_1.h5u_1 : underline;
    color = color === VOID ? Companion_getInstance_48().a5u_1.i5u_1 : color;
    canBreak = canBreak === VOID ? Companion_getInstance_48().a5u_1.j5u_1 : canBreak;
    return this.n5v(text, new Style(font, textSize, italic, bold, underline, color, canBreak));
  }
  z2i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c5v_1;
    width$factory();
    return this_0.u1();
  }
  a2j() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d5v_1;
    height$factory();
    return this_0.u1();
  }
  p5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e5v_1;
    allFonts$factory();
    return this_0.u1();
  }
  q5u() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.z5u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.RichTextData.trimSpaces.<anonymous>' call
      var tmp$ret$0 = item.q5u();
      destination.h(tmp$ret$0);
    }
    return RichTextData.j5v(destination);
  }
  p5v(maxLineWidth, maxHeight, includePartialLines, ellipsis, trimSpaces, includeFirstLineAlways) {
    var out = this;
    var removedWords = false;
    if (!(maxLineWidth === Infinity)) {
      out = out.q5v(maxLineWidth);
    }
    if (!(maxHeight === Infinity)) {
      // Inline function 'kotlin.also' call
      var this_0 = out.r5v(maxHeight, includePartialLines, includeFirstLineAlways);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.limit.<anonymous>' call
      if (!this_0.equals(out))
        removedWords = true;
      out = this_0;
    }
    var tmp;
    if (!(maxLineWidth === Infinity) && !(ellipsis == null) && removedWords) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !out.z5u_1.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      var line = last(out.z5u_1);
      var lastLine = Companion_getInstance_49().x5u(maxLineWidth, last(out.z5u_1), new TextNode(ellipsis, line.m5u()));
      out = RichTextData.j5v(plus_2(dropLast(out, 1), lastLine));
    }
    if (trimSpaces) {
      out = out.q5u();
    }
    return out;
  }
  r5v(maxHeight, includePartialLines, includeFirstLineAlways) {
    var currentHeight = 0.0;
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.h1();
    var _iterator__ex2g4s = this.z5u_1.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      currentHeight = currentHeight + line.n5u();
      if (currentHeight >= maxHeight) {
        if (includePartialLines || (includeFirstLineAlways && outLines.g1())) {
          // Inline function 'kotlin.collections.plusAssign' call
          outLines.h(line);
        }
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      outLines.h(line);
    }
    return RichTextData.j5v(outLines);
  }
  g5v(maxLineWidth, splitLetters) {
    var maxLineWidth_0 = coerceAtLeast_0(maxLineWidth, 0.1);
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.h1();
    var currentLineWidth = {_v: 0.0};
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentLine = ArrayList.h1();
    var _iterator__ex2g4s = this.z5u_1.a1();
    done: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.also' call
      var this_0 = TGenDeque.x2l();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
      this_0.a2m(line.n5t_1);
      var deque = this_0;
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!deque.g1()) {
          break $l$loop;
        }
        var node = deque.qk();
        var width = node.z2i();
        if (currentLineWidth._v >= maxLineWidth_0) {
          wordWrap$finishLine(currentLine, outLines, currentLineWidth);
        }
        var fullyFitsInLine = width <= maxLineWidth_0;
        var fitsInRemainingLine = currentLineWidth._v + width <= maxLineWidth_0;
        var tmp;
        if (node instanceof TextNode) {
          tmp = (node.y5t_1.j5u_1 && (!fullyFitsInLine || splitLetters));
        } else {
          tmp = false;
        }
        if (tmp) {
          var division = Companion_getInstance_49().h5v(node.x5t_1);
          if (division.e1() === 1) {
            if (!fitsInRemainingLine) {
              wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            }
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList.w(collectionSizeOrDefault(division, 10));
            var tmp0_iterator = division.a1();
            while (tmp0_iterator.b1()) {
              var item = tmp0_iterator.c1();
              // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
              var tmp$ret$4 = node.r5u(item);
              destination.h(tmp$ret$4);
            }
            deque.c2m(destination);
          }
        } else {
          if (!fitsInRemainingLine) {
            wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            wordWrap$addNode(currentLine, currentLineWidth, node);
          }
        }
      }
      wordWrap$finishLine(currentLine, outLines, currentLineWidth);
    }
    return RichTextData.j5v(outLines);
  }
  q5v(maxLineWidth, splitLetters, $super) {
    splitLetters = splitLetters === VOID ? false : splitLetters;
    return $super === VOID ? this.g5v(maxLineWidth, splitLetters) : $super.g5v.call(this, maxLineWidth, splitLetters);
  }
  toString() {
    return 'RichTextData(lines=' + toString(this.z5u_1) + ', defaultStyle=' + this.a5v_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.z5u_1);
    result = imul(result, 31) + this.a5v_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextData))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextData ? other : THROW_CCE();
    if (!equals(this.z5u_1, tmp0_other_with_cast.z5u_1))
      return false;
    if (!this.a5v_1.equals(tmp0_other_with_cast.a5v_1))
      return false;
    return true;
  }
}
class Placement {
  constructor(text, pos, size, font, fillStyle, stroke) {
    this.t5v_1 = text;
    this.u5v_1 = pos;
    this.v5v_1 = size;
    this.w5v_1 = font;
    this.x5v_1 = fillStyle;
    this.y5v_1 = stroke;
  }
  toString() {
    return 'Placement(text=' + this.t5v_1 + ', pos=' + this.u5v_1.toString() + ', size=' + this.v5v_1 + ', font=' + toString(this.w5v_1) + ', fillStyle=' + toString_0(this.x5v_1) + ', stroke=' + toString_0(this.y5v_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t5v_1);
    result = imul(result, 31) + this.u5v_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v5v_1) | 0;
    result = imul(result, 31) + hashCode(this.w5v_1) | 0;
    result = imul(result, 31) + (this.x5v_1 == null ? 0 : hashCode(this.x5v_1)) | 0;
    result = imul(result, 31) + (this.y5v_1 == null ? 0 : this.y5v_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Placement))
      return false;
    var tmp0_other_with_cast = other instanceof Placement ? other : THROW_CCE();
    if (!(this.t5v_1 === tmp0_other_with_cast.t5v_1))
      return false;
    if (!this.u5v_1.equals(tmp0_other_with_cast.u5v_1))
      return false;
    if (!equals(this.v5v_1, tmp0_other_with_cast.v5v_1))
      return false;
    if (!equals(this.w5v_1, tmp0_other_with_cast.w5v_1))
      return false;
    if (!equals(this.x5v_1, tmp0_other_with_cast.x5v_1))
      return false;
    if (!equals(this.y5v_1, tmp0_other_with_cast.y5v_1))
      return false;
    return true;
  }
}
class RichTextDataPlacements {
  constructor(placements) {
    placements = placements === VOID ? fastArrayListOf([]) : placements;
    this.s5v_1 = placements;
  }
  a5w(element) {
    return this.s5v_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof Placement))
      return false;
    return this.a5w(element instanceof Placement ? element : THROW_CCE());
  }
  b5w(elements) {
    return this.s5v_1.a3(elements);
  }
  a3(elements) {
    return this.b5w(elements);
  }
  d1(index) {
    return this.s5v_1.d1(index);
  }
  c5w(element) {
    return this.s5v_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof Placement))
      return -1;
    return this.c5w(element instanceof Placement ? element : THROW_CCE());
  }
  g1() {
    return this.s5v_1.g1();
  }
  a1() {
    return this.s5v_1.a1();
  }
  b3() {
    return this.s5v_1.b3();
  }
  i1(index) {
    return this.s5v_1.i1(index);
  }
  c3(fromIndex, toIndex) {
    return this.s5v_1.c3(fromIndex, toIndex);
  }
  e1() {
    return this.s5v_1.e1();
  }
  toString() {
    return 'RichTextDataPlacements(placements=' + this.s5v_1.toString() + ')';
  }
  hashCode() {
    return this.s5v_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextDataPlacements))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextDataPlacements ? other : THROW_CCE();
    if (!this.s5v_1.equals(tmp0_other_with_cast.s5v_1))
      return false;
    return true;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_40 = this;
    this.j5w_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.k5w_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.l5w_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.m5w_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n5w_1 = [new VerticalAlign(this.j5w_1), new VerticalAlign(this.k5w_1), new VerticalAlign(this.m5w_1), new VerticalAlign(this.l5w_1)];
    this.o5w_1 = toList_1(this.n5w_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_50();
    this.p5w_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.p5w_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.p5w_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.p5w_1, other);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_41 = this;
    this.d5w_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.e5w_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.f5w_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.g5w_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5w_1 = [new HorizontalAlign(this.e5w_1), new HorizontalAlign(this.f5w_1), new HorizontalAlign(this.g5w_1), new HorizontalAlign(this.d5w_1)];
    this.i5w_1 = toList_1(this.h5w_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_51();
    this.q5w_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.q5w_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.q5w_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.q5w_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_42 = this;
    this.k4z_1 = listOf_0([new HorizontalAlign(Companion_getInstance_51().e5w_1), new HorizontalAlign(Companion_getInstance_51().f5w_1), new HorizontalAlign(Companion_getInstance_51().g5w_1), new HorizontalAlign(Companion_getInstance_51().d5w_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.k4z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.q5w_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_50().j5w_1);
      destination.h(tmp$ret$0);
    }
    tmp.l4z_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.k4z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.q5w_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_50().m5w_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.m4z_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.k4z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var item_1 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.q5w_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_50().k5w_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.n4z_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.k4z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.a1();
    while (tmp0_iterator_2.b1()) {
      var item_2 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.q5w_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_50().l5w_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.o4z_1 = destination_2;
    this.p4z_1 = plus_0(plus_0(plus_0(this.l4z_1, this.m4z_1), this.n4z_1), this.o4z_1);
    this.q4z_1 = this.l4z_1.d1(0);
    this.r4z_1 = this.l4z_1.d1(1);
    this.s4z_1 = this.l4z_1.d1(2);
    this.t4z_1 = this.l4z_1.d1(3);
    this.u4z_1 = this.m4z_1.d1(0);
    this.v4z_1 = this.m4z_1.d1(1);
    this.w4z_1 = this.m4z_1.d1(2);
    this.x4z_1 = this.m4z_1.d1(3);
    this.y4z_1 = this.l4z_1.d1(0);
    this.z4z_1 = this.l4z_1.d1(1);
    this.a50_1 = this.l4z_1.d1(2);
    this.b50_1 = this.l4z_1.d1(3);
    this.c50_1 = this.n4z_1.d1(0);
    this.d50_1 = this.n4z_1.d1(1);
    this.e50_1 = this.n4z_1.d1(2);
    this.f50_1 = this.n4z_1.d1(3);
    this.g50_1 = this.o4z_1.d1(0);
    this.h50_1 = this.o4z_1.d1(1);
    this.i50_1 = this.o4z_1.d1(2);
    this.j50_1 = this.o4z_1.d1(3);
  }
  r5w(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_51().e5w_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_51().f5w_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_51().g5w_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_51().d5w_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_50().j5w_1) ? this.l4z_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_50().m5w_1) ? this.m4z_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_50().k5w_1) ? this.n4z_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_50().l5w_1) ? this.o4z_1.d1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_52();
    this.i51_1 = horizontal;
    this.j51_1 = vertical;
    this.k51_1 = Anchor2D.a25(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.i51_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.j51_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.j51_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.i51_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.i51_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.j51_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.i51_1, tmp0_other_with_cast.i51_1))
      return false;
    if (!equals(this.j51_1, tmp0_other_with_cast.j51_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_4().m26() : bounds;
    this.m51_1 = maxLineHeight;
    this.n51_1 = maxX;
    this.o51_1 = bounds;
  }
  p51(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.n51_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.o51_1, 0.0);
  }
  e54(dx) {
    this.n51_1 = this.n51_1 + dx;
  }
  u5w(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.m51_1;
    var b = fontMetrics.o4s();
    tmp.m51_1 = Math.max(a, b);
  }
  v5w() {
  }
  t2q() {
    this.n51_1 = 0.0;
    this.o51_1 = Companion_getInstance_4().h26_1;
    this.m51_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.m51_1 + ', maxX=' + this.n51_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.o51_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.m51_1);
    result = imul(result, 31) + getNumberHashCode(this.n51_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.o51_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.m51_1, tmp0_other_with_cast.m51_1))
      return false;
    if (!equals(this.n51_1, tmp0_other_with_cast.n51_1))
      return false;
    if (!equals(this.o51_1, tmp0_other_with_cast.o51_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.c51_1 = Companion_getInstance_4().m26();
    this.d51_1 = Companion_getInstance_4().m26();
    this.e51_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f51_1 = ArrayList.h1();
    this.g51_1 = new LineStats();
  }
  h51() {
    return this.e51_1;
  }
  w5w() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.f51_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.m51_1;
    }
    return sum;
  }
  u53(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.f51_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.n51_1);
  }
  l51(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.w5w());
  }
  t2q() {
    super.t2q();
    this.e51_1 = 0;
    this.d51_1 = Companion_getInstance_4().h26_1;
    this.c51_1 = Companion_getInstance_4().h26_1;
    this.g51_1.t2q();
    this.f51_1.l3();
  }
  i53(reader, codePoint) {
    var g = this.c54(reader, codePoint);
    add_0(this, g.m4t_1);
    this.g51_1.u5w(this.l53_1);
    return g;
  }
  e54(x) {
    super.e54(x);
    this.g51_1.e54(x);
  }
  f54(y, end) {
    super.f54(y, end);
    this.e51_1 = this.e51_1 + 1 | 0;
    this.g51_1.u5w(this.l53_1);
    this.g51_1.v5w();
    this.f51_1.h(this.g51_1);
    this.g51_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.x5w_1 = maxTop;
    this.y5w_1 = minBottom;
    this.z5w_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.x5w_1 + ', minBottom=' + this.y5w_1 + ', maxLineHeight=' + this.z5w_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x5w_1);
    result = imul(result, 31) + getNumberHashCode(this.y5w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.x5w_1, tmp0_other_with_cast.x5w_1))
      return false;
    if (!equals(this.y5w_1, tmp0_other_with_cast.y5w_1))
      return false;
    if (!equals(this.z5w_1, tmp0_other_with_cast.z5w_1))
      return false;
    return true;
  }
}
class Entry_1 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.a5x_1 = tex;
    this.b5x_1 = x;
    this.c5x_1 = y;
    this.d5x_1 = sx;
    this.e5x_1 = sy;
    this.f5x_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.tb('Entry(');
    this_0.tb("'" + this.a5x_1.s3f_1 + "', " + numberToInt(this.b5x_1) + ', ' + numberToInt(this.c5x_1) + ', ' + this.a5x_1.x3f_1 + ', ' + this.a5x_1.y3f_1);
    if (!(this.d5x_1 === 1.0)) {
      this_0.tb(', sx=' + get_niceStr_0(this.d5x_1));
    }
    if (!(this.e5x_1 === 1.0)) {
      this_0.tb(', sy=' + get_niceStr_0(this.e5x_1));
    }
    if (!equals(this.f5x_1, get_radians(0))) {
      this_0.tb(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.f5x_1)));
    }
    this_0.tb(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.a5x_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b5x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c5x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d5x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e5x_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f5x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!this.a5x_1.equals(tmp0_other_with_cast.a5x_1))
      return false;
    if (!equals(this.b5x_1, tmp0_other_with_cast.b5x_1))
      return false;
    if (!equals(this.c5x_1, tmp0_other_with_cast.c5x_1))
      return false;
    if (!equals(this.d5x_1, tmp0_other_with_cast.d5x_1))
      return false;
    if (!equals(this.e5x_1, tmp0_other_with_cast.e5x_1))
      return false;
    if (!equals(this.f5x_1, tmp0_other_with_cast.f5x_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.q5x_1 = Companion_getInstance_52().q4z_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r5x_1 = ArrayList.h1();
    this.s5x_1 = doubleArrayListOf(new Float64Array([]));
    this.t5x_1 = doubleArrayListOf(new Float64Array([]));
    this.u5x_1 = doubleArrayListOf(new Float64Array([]));
    this.v5x_1 = doubleArrayListOf(new Float64Array([]));
    this.w5x_1 = doubleArrayListOf(new Float64Array([]));
    this.x5x_1 = new DoubleVectorArrayList(4);
    this.y5x_1 = MatrixTransform.q2b();
  }
  z5x() {
    return this.q5x_1.j51_1;
  }
  e1() {
    return this.s5x_1.e1();
  }
  a5y() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.x5x_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.y27(n, 0));
        while (out.e1() <= line) {
          out.h(new LineInfo());
        }
        var lineInfo = out.d1(line);
        var top = this_0.y27(n, 1);
        var bottom = this_0.y27(n, 2);
        var lineHeight = this_0.y27(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.x5w_1;
        tmp.x5w_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.y5w_1;
        tmp_0.y5w_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.z5w_1;
        tmp_1.z5w_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  b5y(n) {
    return n >= this.e1() ? Companion_getInstance_2().i26_1 : Companion_getInstance_2().h2e(this.s5x_1.d1(n), this.t5x_1.d1(n), this.s5x_1.d1(n) + this.r5x_1.d1(n).x3f_1 * this.u5x_1.d1(n), this.t5x_1.d1(n) + this.r5x_1.d1(n).y3f_1 * this.v5x_1.d1(n));
  }
  h3a() {
    if (this.e1() === 0) {
      return Companion_getInstance_2().i26_1;
    }
    var bb = Companion_getInstance_4().m26();
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.b5y(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  c5y(n, out) {
    out.a5x_1 = this.r5x_1.d1(n);
    out.b5x_1 = this.s5x_1.d1(n);
    out.c5x_1 = this.t5x_1.d1(n);
    out.d5x_1 = this.u5x_1.d1(n);
    out.e5x_1 = this.v5x_1.d1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_5();
    var ratio = this.w5x_1.d1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.f5x_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  d5y() {
    this.b54(Companion_getInstance_0().o25_1);
    this.r5x_1.l3();
    this.s5x_1.l3();
    this.t5x_1.l3();
    this.u5x_1.l3();
    this.v5x_1.l3();
    this.w5x_1.l3();
    this.x5x_1.l3();
    this.z53(0);
  }
  i53(reader, codePoint) {
    var tmp = this.y53();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.zv_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.c54(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.zv_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.d1(codePoint);
    var x = g.c4s_1;
    var tmp_0 = g.d4s_1;
    var tmp295_subject = this.z5x();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_50().m5w_1) ? bf.x3g() : bf.o4s() * _VerticalAlign___get_ratio__impl__b3ilr8(this.z5x()));
    var fontScale = this.o53_1 / bf.n4s();
    this.y5x_1 = get_immutable(this.w53()).u2a();
    this.r5x_1.h(g.b4s_1);
    this.s5x_1.sz(this.xw().m25_1 + this.w53().y29(x, y) * fontScale);
    this.t5x_1.sz(this.xw().n25_1 + this.w53().b2a(x, y) * fontScale);
    this.u5x_1.sz(this.y5x_1.i2b_1 * fontScale);
    this.v5x_1.sz(this.y5x_1.j2b_1 * fontScale);
    this.w5x_1.sz(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.y5x_1.m2b_1)));
    this.x5x_1.c2l(this.t53(), this.l53_1.y4s_1, this.l53_1.c4t_1, this.l53_1.o4s());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.e5y_1 = $getVersion;
    this.f5y_1 = $handler;
  }
  s5w() {
    return this.e5y_1();
  }
  g5y(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.t2q();
    _this__u8e3s4.a54(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.gw()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.jw());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.hw(1));
      var startPos = reader.zv_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.f54(_this__u8e3s4.o4s(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.zv_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.c54(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.zv_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.d54(Companion_getInstance_3().g29_1);
        this.f5y_1(_this__u8e3s4, reader, c, g, g.n4t_1 + _this__u8e3s4.q4t(c, c1));
      }
      if (reader.zv_1 <= startPos) {
        reader.lw(1);
      }
    }
    _this__u8e3s4.f54(_this__u8e3s4.o4s(), true);
  }
  t5w(_this__u8e3s4, text, size, defaultFont) {
    return this.g5y(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.h5y_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  s5w() {
    return this.h5y_1.s5w();
  }
  i5y(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.h5y_1.t5w(_this__u8e3s4, Companion_getInstance_12().qw(text), size, defaultFont);
  }
  t5w(_this__u8e3s4, text, size, defaultFont) {
    return this.i5y(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.j5y_1 = intArrayListOf(new Int32Array([]));
    this.k5y_1 = intArrayListOf(new Int32Array([]));
    this.t2q();
  }
  e1() {
    return this.j5y_1.e1();
  }
  t2q() {
    this.j5y_1.l3();
    this.k5y_1.l3();
  }
  h3m(x0, x1) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.j5y_1.ux(n);
        var xmax = this.k5y_1.ux(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.j5y_1.n2k(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.k5y_1.n2k(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.j5y_1.g2k(x0);
    this.k5y_1.g2k(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.w5y_1 = $outer;
    this.l5y_1 = get_DEFAULT(Companion_getInstance_53());
    this.m5y_1 = NoneFiller_getInstance();
    this.n5y_1 = -1;
    this.o5y_1 = -1;
    this.p5y_1 = new Float32Array(this.e1());
    this.q5y_1 = new Int32Array(this.e1());
    this.r5y_1 = Companion_instance_18.w4r(this.e1());
    this.s5y_1 = Companion_instance_18.w4r(this.e1());
    this.t5y_1 = new SegmentHandler();
    this.u5y_1 = 0;
    this.v5y_1 = 1.0;
  }
  e1() {
    return this.w5y_1.z5y_1.x3z_1;
  }
  j5z() {
    return this.w5y_1.z5y_1.x3z_1 - 1 | 0;
  }
  t2q() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.t5y_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.j5y_1.ux(n);
        var xmax = this_0.k5y_1.ux(n);
        fill_0(this.p5y_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.q5y_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.u5y_1 = 0;
    this.t5y_1.t2q();
  }
  k5z(x0, x1, y0) {
    if (this.j5z() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.j5z(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.j5z(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.j5z());
    var i1 = coerceIn(b, 0, this.j5z());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.o5y_1 === y)) {
      if (y >= 0) {
        this.qc();
      }
      this.o5y_1 = y;
      this.t2q();
    }
    if (!(this.n5y_1 === y0)) {
      this.n5y_1 = y0;
      this.u5y_1 = this.u5y_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.t5y_1.h3m(i0, i1);
      this.l5z(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l5z(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.l5z(i1, i1m / 20);
      }
    }
  }
  l5z(x, ratio) {
    var mask = 1 << this.u5y_1;
    if ((this.q5y_1[x] & mask) === 0) {
      this.q5y_1[x] = this.q5y_1[x] | mask;
      var _array__4zh2yp = this.p5y_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  qc() {
    var containsUpper = this.w5y_1.z5y_1.y3z_1;
    var containsArg = this.o5y_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.v5y_1);
    var scale_0 = 1.0 / this.u5y_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.t5y_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.j5y_1.ux(n);
        var xmax = this_0.k5y_1.ux(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.m5y_1.x5r(this.s5y_1, 0, xmin, xmax, this.o5y_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.p5y_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.s5y_1, xmin, this.p5y_1, xmin, count);
        var index = this.w5y_1.z5y_1.s40(0, this.o5y_1) + x | 0;
        if (this.w5y_1.z5y_1.d40_1) {
          arraycopy(this.w5y_1.z5y_1.n3z_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r5y_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.w5y_1.z5y_1.n3z_1), index, this.r5y_1, x, count);
        }
        this.l5y_1.m5z(this.r5y_1, x, this.s5y_1, x, count);
        if (this.w5y_1.z5y_1.d40_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r5y_1), x, this.w5y_1.z5y_1.n3z_1, index, count);
        } else {
          depremultiply(this.r5y_1, x, _RgbaArray___init__impl__oib4y4(this.w5y_1.z5y_1.n3z_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.y5z_1 = false;
    this.z5z_1 = 0;
  }
  qc() {
    return Unit_instance;
  }
  b60() {
    var _unary__edvuaz = this.z5z_1;
    this.z5z_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  c60() {
    this.z5z_1 = this.z5z_1 - 1 | 0;
    if (this.z5z_1 === 0) {
      this.qc();
    }
  }
  d60(state, fill, winding) {
    var rstate = state;
    if (fill && !this.f60(state.f4u_1)) {
      rstate = state.wx();
      rstate.f4u_1 = toBitmapPaint(rstate.f4u_1, state);
    }
    this.x5z(rstate, fill, winding);
  }
  e60(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.d60(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.d60.call(this, state, fill, winding);
    }
    return tmp;
  }
  x5z(state, fill, winding) {
    return Unit_instance;
  }
  f60(_this__u8e3s4) {
    return true;
  }
  g60(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.w29().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.z3o(pos, size);
    } else {
      this_0.g3p(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.e60(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_3().g29_1, size.e2g(toFloat(image.e1()))).k2a(pos))), true);
  }
  l18() {
    this.qc();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.z5y_1 = bmp;
    this.a5z_1 = antialiasing;
    this.b5z_1 = this.z5y_1.p3z_1.x2f();
    this.c5z_1 = new Rasterizer();
    this.d5z_1 = new ColorFiller();
    this.e5z_1 = new GradientFiller();
    this.f5z_1 = new BitmapFiller();
    this.g5z_1 = new ScanlineWriter(this);
    this.h5z_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.i5z_1 = new StrokeToFill();
  }
  z2i() {
    return this.z5y_1.x3z_1;
  }
  a2j() {
    return this.z5y_1.y3z_1;
  }
  x5z(state, fill, winding) {
    var style = fill ? state.f4u_1 : state.e4u_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.d5z_1.v5r(style.t4h_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.e5z_1.d5s(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.f5z_1.r5s(style, state);
          } else {
            throw NotImplementedError.td();
          }
        }
      }
    }
    var filler = tmp;
    this.g5z_1.l5y_1 = state.m4u_1;
    this.c5z_1.t2q();
    this.c5z_1.n5z_1 = this.y5z_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.x4t_1;
    } else {
      this.h5z_1.l3();
      var tmp306_$receiver = state.x4t_1;
      var tmp307_lineWidth = state.a60();
      var tmp308_joins = state.c4u_1;
      var tmp309_startCap = state.a4u_1;
      var tmp310_endCap = state.b4u_1;
      var tmp311_miterLimit = state.d4u_1;
      var tmp312_temp = this.i5z_1;
      var tmp313_outFill = this.h5z_1;
      var tmp314_lineDash = state.n4u_1;
      var tmp315_lineDashOffset = state.o4u_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.w4t_1 == null)) {
      this.c5z_1.r5z_1.m3l_1 = ensureNotNull(state.w4t_1).v3d_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.w4t_1);
      var i = Vector2D.h28();
      var l = Vector2D.h28();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c5z_1.r5z_1.f6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.t3d_1;
      var n_0 = 0;
      while (n_0 < this_1.e1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.ux(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.u3d_1.d1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.w27(tmp_1, this_0.u3d_1.d1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.jl();
            var y = it.kl();
            this.c5z_1.r5z_1.p3m(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.u3d_1.d1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.w27(tmp_2, this_0.u3d_1.d1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.jl();
            var y_0 = it_0.kl();
            this.c5z_1.r5z_1.p3m(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.u3d_1.d1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.w27(tmp_3, this_0.u3d_1.d1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.u3d_1.d1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.w27(tmp_4, this_0.u3d_1.d1(_unary__edvuaz_7));
            var sum = Companion_getInstance_0().d2h(l, c) + Companion_getInstance_0().d2h(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.h28()};
            var prevPos = {_v: Vector2D.h28()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_10().ox_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_7().q3b(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_7().q3b(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.jl();
                var y_1 = it_1.kl();
                this.c5z_1.r5z_1.p3m(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.u3d_1.d1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.w27(tmp_5, this_0.u3d_1.d1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.u3d_1.d1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.w27(tmp_6, this_0.u3d_1.d1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.u3d_1.d1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.w27(tmp_7, this_0.u3d_1.d1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_0().d2h(l, c0) + Companion_getInstance_0().d2h(c0, c1) + Companion_getInstance_0().d2h(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.h28()};
            var prevPos_0 = {_v: Vector2D.h28()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_10().ox_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_7().p3b(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_7().p3b(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.jl();
                var y_2 = it_2.kl();
                this.c5z_1.r5z_1.p3m(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.jl();
            var y_3 = destruct.kl();
            this.c5z_1.r5z_1.p3m(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.c5z_1.r5z_1.f6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c5z_1.r5z_1.f6();
      }
    }
    var tmp_8 = this.c5z_1.q5z_1;
    tmp_8.m3l_1 = winding == null ? ensureNotNull(state.x4t_1).v3d_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.h28();
    var l_0 = Vector2D.h28();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c5z_1.q5z_1.f6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.t3d_1;
    var n_4 = 0;
    while (n_4 < this_2.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.ux(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.u3d_1.d1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.w27(tmp_9, fillPath.u3d_1.d1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.jl();
          var y_4 = it_3.kl();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5z_1.q5z_1.p3m(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.u3d_1.d1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.w27(tmp_10, fillPath.u3d_1.d1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.jl();
          var y_5 = it_4.kl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5z_1.q5z_1.p3m(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.u3d_1.d1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.w27(tmp_11, fillPath.u3d_1.d1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.u3d_1.d1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.w27(tmp_12, fillPath.u3d_1.d1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_0().d2h(l_0, c_0) + Companion_getInstance_0().d2h(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.h28()};
          var prevPos_1 = {_v: Vector2D.h28()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_10().ox_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_7().q3b(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_7().q3b(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.jl();
              var y_6 = it_5.kl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.c5z_1.q5z_1.p3m(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.u3d_1.d1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.w27(tmp_13, fillPath.u3d_1.d1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.u3d_1.d1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.w27(tmp_14, fillPath.u3d_1.d1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.u3d_1.d1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.w27(tmp_15, fillPath.u3d_1.d1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_0().d2h(l_0, c0_0) + Companion_getInstance_0().d2h(c0_0, c1_0) + Companion_getInstance_0().d2h(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.h28()};
          var prevPos_2 = {_v: Vector2D.h28()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_10().ox_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_7().p3b(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_7().p3b(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.jl();
              var y_7 = it_6.kl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.c5z_1.q5z_1.p3m(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.jl();
          var y_8 = destruct_0.kl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5z_1.q5z_1.p3m(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.c5z_1.q5z_1.f6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c5z_1.q5z_1.f6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.h60_1 = $func;
  }
  m5z(dst, dstN, src, srcN, count) {
    return this.h60_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_43 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_53();
    tmp.i60_1 = tmp_0.j60(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  j60(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_38 {
  h3p() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.m60_1 = op;
  }
  m5z(dst, dstN, src, srcN, count) {
    this.m60_1.m5z(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_3().g29_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_50().m5w_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_51().e5w_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.v4t_1 = transform;
    this.w4t_1 = clip;
    this.x4t_1 = path;
    this.y4t_1 = lineScaleMode;
    this.z4t_1 = lineWidth;
    this.a4u_1 = startLineCap;
    this.b4u_1 = endLineCap;
    this.c4u_1 = lineJoin;
    this.d4u_1 = miterLimit;
    this.e4u_1 = strokeStyle;
    this.f4u_1 = fillStyle;
    this.g4u_1 = fontRegistry;
    this.h4u_1 = font;
    this.i4u_1 = fontSize;
    this.j4u_1 = verticalAlign;
    this.k4u_1 = horizontalAlign;
    this.l4u_1 = globalAlpha;
    this.m4u_1 = globalCompositeOperation;
    this.n4u_1 = lineDash;
    this.o4u_1 = lineDashOffset;
    var tmp = this;
    tmp.p4u_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  n60() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p4u_1;
    transformTransform$factory();
    return this_0.u1();
  }
  a60() {
    var tmp = this.z4t_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.n60().s2b();
    return tmp * Math.abs(this_0);
  }
  f52(value) {
    this.a4u_1 = value;
    this.b4u_1 = value;
  }
  y51() {
    return this.a4u_1;
  }
  wx() {
    var tmp = this.v4t_1;
    var tmp319_safe_receiver = this.w4t_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.wx();
    var tmp_1 = this.x4t_1.wx();
    var tmp320_safe_receiver = this.n4u_1;
    return this.o60(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.wx());
  }
  p60(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  o60(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.v4t_1 : transform;
    clip = clip === VOID ? this.w4t_1 : clip;
    path = path === VOID ? this.x4t_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.y4t_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.z4t_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.a4u_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.b4u_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.c4u_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.d4u_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.e4u_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.f4u_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.g4u_1 : fontRegistry;
    font = font === VOID ? this.h4u_1 : font;
    fontSize = fontSize === VOID ? this.i4u_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.j4u_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.k4u_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.l4u_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.m4u_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.n4u_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.o4u_1 : lineDashOffset;
    return $super === VOID ? this.p60(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.p60.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.v4t_1.toString() + ', clip=' + toString_0(this.w4t_1) + ', path=' + this.x4t_1.toString() + ', lineScaleMode=' + this.y4t_1.toString() + ', lineWidth=' + this.z4t_1 + ', startLineCap=' + this.a4u_1.toString() + ', endLineCap=' + this.b4u_1.toString() + ', lineJoin=' + this.c4u_1.toString() + ', miterLimit=' + this.d4u_1 + ', strokeStyle=' + toString(this.e4u_1) + ', fillStyle=' + toString(this.f4u_1) + ', fontRegistry=' + toString_0(this.g4u_1) + ', font=' + toString_0(this.h4u_1) + ', fontSize=' + this.i4u_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.j4u_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.k4u_1) + ', globalAlpha=' + this.l4u_1 + ', globalCompositeOperation=' + toString(this.m4u_1) + ', lineDash=' + toString_0(this.n4u_1) + ', lineDashOffset=' + this.o4u_1 + ')';
  }
  hashCode() {
    var result = this.v4t_1.hashCode();
    result = imul(result, 31) + (this.w4t_1 == null ? 0 : this.w4t_1.hashCode()) | 0;
    result = imul(result, 31) + this.x4t_1.hashCode() | 0;
    result = imul(result, 31) + this.y4t_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4t_1) | 0;
    result = imul(result, 31) + this.a4u_1.hashCode() | 0;
    result = imul(result, 31) + this.b4u_1.hashCode() | 0;
    result = imul(result, 31) + this.c4u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4u_1) | 0;
    result = imul(result, 31) + hashCode(this.e4u_1) | 0;
    result = imul(result, 31) + hashCode(this.f4u_1) | 0;
    result = imul(result, 31) + (this.g4u_1 == null ? 0 : hashCode(this.g4u_1)) | 0;
    result = imul(result, 31) + (this.h4u_1 == null ? 0 : hashCode(this.h4u_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i4u_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.j4u_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.k4u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l4u_1) | 0;
    result = imul(result, 31) + hashCode(this.m4u_1) | 0;
    result = imul(result, 31) + (this.n4u_1 == null ? 0 : hashCode(this.n4u_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.v4t_1.equals(tmp0_other_with_cast.v4t_1))
      return false;
    if (!equals(this.w4t_1, tmp0_other_with_cast.w4t_1))
      return false;
    if (!this.x4t_1.equals(tmp0_other_with_cast.x4t_1))
      return false;
    if (!this.y4t_1.equals(tmp0_other_with_cast.y4t_1))
      return false;
    if (!equals(this.z4t_1, tmp0_other_with_cast.z4t_1))
      return false;
    if (!this.a4u_1.equals(tmp0_other_with_cast.a4u_1))
      return false;
    if (!this.b4u_1.equals(tmp0_other_with_cast.b4u_1))
      return false;
    if (!this.c4u_1.equals(tmp0_other_with_cast.c4u_1))
      return false;
    if (!equals(this.d4u_1, tmp0_other_with_cast.d4u_1))
      return false;
    if (!equals(this.e4u_1, tmp0_other_with_cast.e4u_1))
      return false;
    if (!equals(this.f4u_1, tmp0_other_with_cast.f4u_1))
      return false;
    if (!equals(this.g4u_1, tmp0_other_with_cast.g4u_1))
      return false;
    if (!equals(this.h4u_1, tmp0_other_with_cast.h4u_1))
      return false;
    if (!equals(this.i4u_1, tmp0_other_with_cast.i4u_1))
      return false;
    if (!equals(this.j4u_1, tmp0_other_with_cast.j4u_1))
      return false;
    if (!equals(this.k4u_1, tmp0_other_with_cast.k4u_1))
      return false;
    if (!equals(this.l4u_1, tmp0_other_with_cast.l4u_1))
      return false;
    if (!equals(this.m4u_1, tmp0_other_with_cast.m4u_1))
      return false;
    if (!equals(this.n4u_1, tmp0_other_with_cast.n4u_1))
      return false;
    if (!equals(this.o4u_1, tmp0_other_with_cast.o4u_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.v47_1 = renderer;
    this.w47_1 = defaultFontRegistry;
    this.x47_1 = defaultFont;
    this.y47_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.w47_1, this.x47_1);
    this.z47_1 = _TGenStack___init__impl__yynjgt();
    this.a48_1 = Vector2D.h28();
    this.b48_1 = Vector2D.h28();
  }
  q60() {
    return this.v47_1.z2i();
  }
  r60() {
    return this.v47_1.a2j();
  }
  s60(state, fill, winding) {
    return this.v47_1.d60(state, fill, winding);
  }
  t60(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.s60(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.s60.call(this, state, fill, winding);
    }
    return tmp;
  }
  u60(image, pos, size, transform) {
    return this.v47_1.g60(image, pos, size, transform);
  }
  v60() {
    return this.v47_1.l18();
  }
  w60() {
    return this.v47_1.b60();
  }
  x60() {
    return this.v47_1.c60();
  }
  z2i() {
    return this.q60();
  }
  a2j() {
    return this.r60();
  }
  l18() {
    this.v60();
  }
  y60() {
    return this.w60();
  }
  z60() {
    return this.x60();
  }
  a61(value) {
    this.y47_1.y4t_1 = value;
  }
  e52(value) {
    this.y47_1.z4t_1 = value;
  }
  x51() {
    return this.y47_1.z4t_1;
  }
  f52(value) {
    this.y47_1.f52(value);
  }
  y51() {
    return this.y47_1.y51();
  }
  h52(value) {
    this.y47_1.d4u_1 = value;
  }
  a52() {
    return this.y47_1.d4u_1;
  }
  b61(value) {
    this.y47_1.a4u_1 = value;
  }
  c61(value) {
    this.y47_1.b4u_1 = value;
  }
  g52(value) {
    this.y47_1.c4u_1 = value;
  }
  z51() {
    return this.y47_1.c4u_1;
  }
  d61(value) {
    this.y47_1.e4u_1 = value;
  }
  e61() {
    return this.y47_1.e4u_1;
  }
  s4u(value) {
    this.y47_1.f4u_1 = value;
  }
  r4u() {
    return this.y47_1.f4u_1;
  }
  y53() {
    return this.y47_1.h4u_1;
  }
  n4s() {
    return this.y47_1.i4u_1;
  }
  z5x() {
    return this.y47_1.j4u_1;
  }
  f61() {
    return this.y47_1.k4u_1;
  }
  g61() {
    return Companion_getInstance_52().r5w(this.f61(), this.z5x());
  }
  i52(value) {
    this.y47_1.n4u_1 = value;
  }
  b52() {
    return this.y47_1.n4u_1;
  }
  j52(value) {
    this.y47_1.o4u_1 = value;
  }
  c52() {
    return this.y47_1.o4u_1;
  }
  d52() {
    TGenStack__push_impl_9yh33t(this.z47_1, this.y47_1.wx());
  }
  l52() {
    this.y47_1 = TGenStack__pop_impl_qisxa0(this.z47_1);
  }
  r5k(sx, sy) {
    this.y47_1.v4t_1 = this.y47_1.v4t_1.i2a(sx, sy);
  }
  q4u(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.r5k(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.r5k.call(this, sx, sy);
    }
    return tmp;
  }
  v53(tx, ty) {
    this.y47_1.v4t_1 = this.y47_1.v4t_1.r2a(tx, ty);
  }
  x53(m) {
    this.y47_1.v4t_1 = this.y47_1.v4t_1.s2a(m);
  }
  h61(_set____db54di) {
    this.a48_1 = _set____db54di;
  }
  i61() {
    return this.a48_1;
  }
  j61(_set____db54di) {
    this.b48_1 = _set____db54di;
  }
  w3o() {
    return this.b48_1;
  }
  v3o() {
    return this.y47_1.x4t_1.v3o();
  }
  f6() {
    this.y47_1.x4t_1.f6();
    this.j61(this.i61());
  }
  q3d(p) {
    this.y47_1.x4t_1.q3d(trans(this, p));
    this.j61(p);
    this.h61(p);
  }
  d3e(p) {
    this.y47_1.x4t_1.d3e(trans(this, p));
    this.j61(p);
  }
  e3e(c, a) {
    this.y47_1.x4t_1.e3e(trans(this, c), trans(this, a));
    this.j61(a);
  }
  r3d(c1, c2, a) {
    this.y47_1.x4t_1.r3d(trans(this, c1), trans(this, c2), trans(this, a));
    this.j61(a);
  }
  q5k(path) {
    if (this.g1())
      this.y47_1.x4t_1.v3d_1 = path.v3d_1;
    write_0(this, path);
  }
  p54(d) {
    d.o54(this);
  }
  t4u(x, y, width, height) {
    this.k50();
    this.a3p(x, y, width, height);
    this.t51();
  }
  k50() {
    this.y47_1.x4t_1 = new VectorPath();
  }
  s51() {
    if (!equals(this.y47_1.e4u_1, NonePaint_instance)) {
      this.t60(this.y47_1, false);
    }
  }
  k61(winding) {
    if (!equals(this.y47_1.f4u_1, NonePaint_instance)) {
      this.s60(this.y47_1, true, winding);
    }
  }
  t51(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.k61(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.k61.call(this, winding);
    }
    return tmp;
  }
  l61(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.r4u();
    this.s4u(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.k61(winding);
    }finally {
      this.s4u(oldStyle);
    }
  }
  w51(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.l61(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.l61.call(this, paint, winding);
    }
    return tmp;
  }
  k52(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.e61();
    this.d61(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.s51();
    }finally {
      this.d61(oldStyle);
    }
  }
  m61(path, winding) {
    if (!(path == null)) {
      if (this.y47_1.w4t_1 == null) {
        this.y47_1.w4t_1 = new VectorPath();
      }
      ensureNotNull(this.y47_1.w4t_1).l3();
      ensureNotNull(this.y47_1.w4t_1).v3d_1 = winding;
      ensureNotNull(this.y47_1.w4t_1).v3p(path);
      if (path === this.y47_1.x4t_1) {
        path.l3();
      }
    } else {
      this.y47_1.w4t_1 = null;
    }
  }
  n61(path, winding, $super) {
    path = path === VOID ? this.y47_1.x4t_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.m61(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.m61.call(this, path, winding);
    }
    return tmp;
  }
  o61(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.r4u() : this.e61() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  z5v(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_0().o25_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.y53() : font;
    size = size === VOID ? this.n4s() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.g61() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.o61(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.o61.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  u4u(image, pos, size) {
    return this.u60(image, pos, size, this.y47_1.v4t_1);
  }
  g5q(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.e1()) : size;
    var tmp;
    if ($super === VOID) {
      this.u4u(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.u4u.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_45 = this;
    this.p61_1 = values_6();
  }
}
class CycleMethod extends Enum {
  i5t() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  f5t(ratio) {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  q61(ratio) {
    return this.f5t(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.r61_1 = beziers;
    var tmp = this;
    tmp.s61_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.t61_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.u61_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.v61_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.w61_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.x61_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.y61_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  j62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s61_1;
    red$factory();
    return this_0.u1();
  }
  k62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t61_1;
    green$factory();
    return this_0.u1();
  }
  l62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u61_1;
    blue$factory();
    return this_0.u1();
  }
  z61() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v61_1;
    allProjected$factory();
    return this_0.u1();
  }
  e62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w61_1;
    redProjected$factory();
    return this_0.u1();
  }
  f62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x61_1;
    greenProjected$factory();
    return this_0.u1();
  }
  g62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y61_1;
    blueProjected$factory();
    return this_0.u1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.h62_1 = bezier;
    this.i62_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.h62_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.i62_1) + ')';
  }
  hashCode() {
    var result = this.h62_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.i62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.h62_1.equals(tmp0_other_with_cast.h62_1))
      return false;
    if (!(this.i62_1 === tmp0_other_with_cast.i62_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.a62_1 = beziers;
    this.b62_1 = new ProjectedPoint();
    this.c62_1 = Companion_getInstance_8().j29();
  }
  d62(point) {
    return Companion_getInstance_0().d2h(point, this.w3c(point));
  }
  w3c(point) {
    if (this.a62_1.g1())
      return Vector2D.j28(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a62_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.d1(_unary__edvuaz).h3c().g27(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.h28();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.a62_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.d1(_unary__edvuaz_0);
        if (it.h3c().f27(point) > minDistSq) {
          break $l$block;
        }
        it.u3c(point, this.b62_1);
        if (this.b62_1.k3b_1 < bminDistSq) {
          bminDistSq = this.b62_1.k3b_1;
          out = this.b62_1.i3b_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.m62(path) : getPath(path);
}
function get_bounds() {
  return this.n62(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.w21();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_3(Companion_getInstance_4().m26(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_2().l26() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.w21();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.v3p(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.y47_1.v4t_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.k50();
    var tmp348_safe_receiver = this.w21();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.v62() == null)) {
      draw_0(ensureNotNull(this.v62()), c);
      c.n61();
    }
    c.x53(get_immutable(this.w53()));
    this.z62(c);
  }finally {
    c.y47_1.v4t_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_3().g29_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.o62_1 = path;
    this.p62_1 = clip;
    this.q62_1 = paint;
    this.r62_1 = transform;
    this.s62_1 = globalAlpha;
    var tmp = this;
    tmp.t62_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.u62_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  w21() {
    return this.o62_1;
  }
  v62() {
    return this.p62_1;
  }
  w53() {
    return this.r62_1;
  }
  w62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t62_1;
    pathCurvesList$factory();
    return this_0.u1();
  }
  x62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u62_1;
    clipCurvesList$factory();
    return this_0.u1();
  }
  y62() {
    return this.w62().e1() === 1 && get_isConvex(first(this.w62())) && this.x62() == null;
  }
  z62(c) {
    c.l61(this.q62_1, this.o62_1.v3d_1);
  }
  toString() {
    return 'FillShape(path=' + this.o62_1.toString() + ', clip=' + toString_0(this.p62_1) + ', paint=' + toString(this.q62_1) + ', transform=' + this.r62_1.toString() + ', globalAlpha=' + this.s62_1 + ')';
  }
  hashCode() {
    var result = this.o62_1.hashCode();
    result = imul(result, 31) + (this.p62_1 == null ? 0 : this.p62_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.q62_1) | 0;
    result = imul(result, 31) + this.r62_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.s62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.o62_1.equals(tmp0_other_with_cast.o62_1))
      return false;
    if (!equals(this.p62_1, tmp0_other_with_cast.p62_1))
      return false;
    if (!equals(this.q62_1, tmp0_other_with_cast.q62_1))
      return false;
    if (!this.r62_1.equals(tmp0_other_with_cast.r62_1))
      return false;
    if (!equals(this.s62_1, tmp0_other_with_cast.s62_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.a63_1 = components;
  }
  n62(includeStrokes) {
    var bb = Companion_getInstance_4().m26();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a63_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.n62(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  o54(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.y60();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.a63_1;
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.d1(_unary__edvuaz).o54(c);
        }
        break $l$block;
      }finally {
        c.z60();
      }
    }
    return Unit_instance;
  }
  m62(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a63_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).m62(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.a63_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.c63_1 = path;
    this.d63_1 = clip;
    this.e63_1 = paint;
    this.f63_1 = transform;
    this.g63_1 = strokeInfo;
    this.h63_1 = globalAlpha;
    this.i63_1 = thickness$factory(this.g63_1);
    this.j63_1 = scaleMode$factory(this.g63_1);
    this.k63_1 = startCap$factory(this.g63_1);
    this.l63_1 = endCap$factory(this.g63_1);
    this.m63_1 = join$factory(this.g63_1);
    this.n63_1 = miterLimit$factory(this.g63_1);
    this.o63_1 = dash$factory(this.g63_1);
    this.p63_1 = dashOffset$factory(this.g63_1);
    var tmp = this;
    tmp.q63_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  w21() {
    return this.c63_1;
  }
  v62() {
    return this.d63_1;
  }
  w53() {
    return this.f63_1;
  }
  n62(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_3(Companion_getInstance_4().m26(), this.c63_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.g63_1.z37_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.r3r(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.k2e();
    return tmp0_elvis_lhs == null ? Companion_getInstance_2().i26_1 : tmp0_elvis_lhs;
  }
  r63(c) {
    c.a61(this.g63_1.b38_1);
    c.e52(this.g63_1.z37_1);
    c.b61(this.g63_1.c38_1);
    c.c61(this.g63_1.d38_1);
    c.g52(this.g63_1.e38_1);
    c.h52(this.g63_1.f38_1);
    c.i52(this.g63_1.g38_1);
    c.j52(this.g63_1.h38_1);
  }
  z62(c) {
    this.r63(c);
    c.k52(this.e63_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.c63_1.toString() + ', clip=' + toString_0(this.d63_1) + ', paint=' + toString(this.e63_1) + ', transform=' + this.f63_1.toString() + ', strokeInfo=' + this.g63_1.toString() + ', globalAlpha=' + this.h63_1 + ')';
  }
  hashCode() {
    var result = this.c63_1.hashCode();
    result = imul(result, 31) + (this.d63_1 == null ? 0 : this.d63_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.e63_1) | 0;
    result = imul(result, 31) + this.f63_1.hashCode() | 0;
    result = imul(result, 31) + this.g63_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h63_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.c63_1.equals(tmp0_other_with_cast.c63_1))
      return false;
    if (!equals(this.d63_1, tmp0_other_with_cast.d63_1))
      return false;
    if (!equals(this.e63_1, tmp0_other_with_cast.e63_1))
      return false;
    if (!this.f63_1.equals(tmp0_other_with_cast.f63_1))
      return false;
    if (!this.g63_1.equals(tmp0_other_with_cast.g63_1))
      return false;
    if (!equals(this.h63_1, tmp0_other_with_cast.h63_1))
      return false;
    return true;
  }
}
class TextShape {
  t63() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s63_1;
    primitiveShapes$factory();
    return this_0.u1();
  }
}
class EmptyShape {
  n62(includeStrokes) {
    return Companion_getInstance_2().l26();
  }
  o54(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_56());
    var tmp = this;
    tmp.k4y_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.l4y_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.m4y_1 = ArrayList.h1();
  }
  q60() {
    return this.k4y_1;
  }
  r60() {
    return this.l4y_1;
  }
  s60(state, fill, winding) {
    if (state.x4t_1.g1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.x4t_1.wx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.v3d_1 = winding == null ? this_0.v3d_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.w4t_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.wx();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.v3d_1 = winding == null ? tmp368_safe_receiver.v3d_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.v4t_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.m4y_1;
      var element = new FillShape(path, clip, state.f4u_1.wx(), transform, state.l4u_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.m4y_1;
      var tmp_2 = state.e4u_1.wx();
      var tmp369_thickness = state.z4t_1;
      var tmp370_scaleMode = state.y4t_1;
      var tmp371_startCap = state.a4u_1;
      var tmp372_endCap = state.b4u_1;
      var tmp373_join = state.c4u_1;
      var tmp374_dash = state.n4u_1;
      var tmp375_dashOffset = state.o4u_1;
      var tmp376_miterLimit = state.d4u_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.l4u_1);
      this_2.h(element_0);
    }
  }
  u60(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.z3o(pos, size);
    this.t60(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_3().g29_1, size.e2g(toFloat(image.e1()))).k2a(pos))), true);
  }
  v60() {
  }
  w60() {
    return 0;
  }
  x60() {
  }
  n4y() {
    return this.m4y_1.e1() === 1 ? first(this.m4y_1) : new CompoundShape(toList(this.m4y_1));
  }
  o54(c) {
    c.p54(this.n4y());
  }
}
class SvgPath {
  b63(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.h1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.t3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.ux(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.u3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.w27(tmp, path.u3d_1.d1(_unary__edvuaz_1));
          var x = destruct.jl();
          var y = destruct.kl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.u3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.w27(tmp_0, path.u3d_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.jl();
          var y_0 = destruct_0.kl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.u3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.w27(tmp_1, path.u3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.u3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.w27(tmp_2, path.u3d_1.d1(_unary__edvuaz_7));
          var x1 = destruct_1.jl();
          var y1 = destruct_1.kl();
          var x2 = destruct_2.jl();
          var y2 = destruct_2.kl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.u3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.w27(tmp_3, path.u3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.u3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.w27(tmp_4, path.u3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.u3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.w27(tmp_5, path.u3d_1.d1(_unary__edvuaz_13));
          var x1_0 = destruct_3.jl();
          var y1_0 = destruct_3.kl();
          var x2_0 = destruct_4.jl();
          var y2_0 = destruct_4.kl();
          var x3 = destruct_5.jl();
          var y3 = destruct_5.kl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.n5z_1 = false;
    this.o5z_1 = 2;
    this.p5z_1 = 1;
    this.q5z_1 = new PolygonScanline();
    this.r5z_1 = new PolygonScanline();
    this.s5z_1 = new IntSegmentSet();
    this.t5z_1 = new IntSegmentSet();
    this.u5z_1 = new IntSegmentSet();
    this.v5z_1 = IntArrayList.a2k(1024);
  }
  t2q() {
    this.q5z_1.t2q();
    this.r5z_1.t2q();
  }
  u63(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.t2q();
    }
    var xmin = this.d3m(bounds.d26());
    var xmax = this.d3m(bounds.e26());
    var tempRect = this.q5z_1.h3a();
    // Inline function 'kotlin.math.max' call
    var a = bounds.f26();
    var b = tempRect.f26();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.d3m(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.g26();
    var b_0 = tempRect.g26();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.d3m(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.v5z_1.l3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.v3m() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.v3m()) / this.p5z_1 | 0) / q | 0) | 0;
        this.v5z_1.g2k(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.v5z_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.ux(_unary__edvuaz);
      this.q5z_1.q3m(y_0, winding, this.s5z_1);
      edgesChecked = edgesChecked + this.q5z_1.b3m_1 | 0;
      if (this.r5z_1.x27()) {
        this.r5z_1.q3m(y_0, this.r5z_1.m3l_1, this.t5z_1);
        edgesChecked = edgesChecked + this.r5z_1.b3m_1 | 0;
        this.u5z_1.y37(this.s5z_1, this.t5z_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.r5z_1.x27() ? this.u5z_1 : this.s5z_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.q37_1.ux(n_1), this_1.r37_1.ux(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.y63(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  w5z(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.o5z_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.u63(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.u63.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_56();
    super();
    this.b64_1 = width;
    this.c64_1 = height;
  }
  z2i() {
    return this.b64_1;
  }
  a2j() {
    return this.c64_1;
  }
}
class Companion_40 extends DummyRenderer {
  constructor() {
    Companion_instance_46 = null;
    super(128, 128);
    Companion_instance_46 = this;
  }
}
class HtmlCanvas {
  t3v(width, height) {
    if (Companion_getInstance_11().mu()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  y64(width, height) {
    return HtmlCanvas_instance.t3v(width, height);
  }
  z64(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  a65(bmp, canvas) {
    return this.z64(_RgbaArray___init__impl__oib4y4(bmp.z4a().n3z_1), bmp.x3z_1, bmp.y3z_1, canvas);
  }
  d64(bmp) {
    return this.a65(bmp, this.y64(bmp.x3z_1, bmp.y3z_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  d5p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  w5p(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  x4d(width, height, premultiplied) {
    return HtmlNativeImage.x64(HtmlCanvas_instance.t3v(width, height));
  }
  w4d(bmp) {
    return HtmlNativeImage.x64(HtmlImage_instance.d64(bmp.j40()));
  }
}
class HtmlNativeImage extends NativeImage {
  static g65(texSourceBase, width, height) {
    var $this = this.v4d(width, height, texSourceBase, true);
    $this.s64_1 = texSourceBase;
    $this.t64_1 = $this.s64_1;
    var tmp = $this;
    tmp.u64_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.v64_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.w64_1 = Monotonic_instance.ej();
    return $this;
  }
  s3() {
    return 'HtmlNativeImage';
  }
  static d65(img) {
    return this.g65(img, img.width, img.height);
  }
  static x64(canvas) {
    return this.g65(canvas, canvas.width, canvas.height);
  }
  f65() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u64_1;
    lazyCanvasElement$factory();
    return this_0.u1();
  }
  h65() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v64_1;
    ctx$factory();
    return this_0.u1();
  }
  u40(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.s64_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.ej();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.w64_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.w64_1 = now;
        this.h65().clearRect(0.0, 0.0, width, height);
        this.h65().drawImage(this.s64_1, 0.0, 0.0);
      }
    }
    var idata = this.h65().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.e40_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  w40(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.h65().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.e40_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.h65().putImageData(idata, x, y);
  }
  t47(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.f65()));
  }
  i65(type, quality) {
    return this.f65().toDataURL(type, quality);
  }
  j65(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.i65(type, quality) : $super.i65.call(this, type, quality);
  }
}
class BrowserImage {
  b65(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  l65(img) {
    return this.e65(img, img.width, img.height);
  }
  e65(img, width, height) {
    var canvas = HtmlCanvas_instance.t3v(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  c65(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.r19();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_11().mu()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.d17();
  }
  k65(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
    return $super === VOID ? this.c65(jsUrl, props, $completion) : $super.c65.call(this, jsUrl, props, $completion);
  }
  p3v(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.o65_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p65_1 = this.o65_1.getContext('2d');
    this.q65_1 = NaN;
    this.r65_1 = null;
  }
  z2i() {
    return this.o65_1.width;
  }
  a2j() {
    return this.o65_1.height;
  }
  v65(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.x5f_1.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.x5f_1.ux(n);
        var color = paint.y5f_1.ux(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  t65(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.t4h_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.q5f_1.r3_1) {
            case 0:
              tmp_0 = this.v65(this.p65_1.createLinearGradient(_this__u8e3s4.r5f_1, _this__u8e3s4.s5f_1, _this__u8e3s4.u5f_1, _this__u8e3s4.v5f_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.v65(this.p65_1.createRadialGradient(_this__u8e3s4.r5f_1, _this__u8e3s4.s5f_1, _this__u8e3s4.t5f_1, _this__u8e3s4.u5f_1, _this__u8e3s4.v5f_1, _this__u8e3s4.w5f_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.p65_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.p65_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.d5g_1), _this__u8e3s4.r5f_1, _this__u8e3s4.s5f_1);
                tmp_1 = this.v65(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.s5s_1).t64_1;
            tmp = this.p65_1.createPattern(tmp$ret$3, _this__u8e3s4.h5t() && _this__u8e3s4.j5t() ? 'repeat' : _this__u8e3s4.h5t() ? 'repeat-x' : _this__u8e3s4.j5t() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  w65(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  x65(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.q3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  s65(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.w65(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.x65(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  u65(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.l29_1, m.m29_1, m.n29_1, m.o29_1, m.p29_1, m.q29_1);
  }
  g60(image, pos, size, transform) {
    this.p65_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.p65_1.setTransform(transform.l29_1, transform.m29_1, transform.n29_1, transform.o29_1, transform.p29_1, transform.q29_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).t64_1;
      this.p65_1.drawImage(tmp$ret$2, pos.m25_1, pos.n25_1, size.r26_1, size.s26_1);
    }finally {
      this.p65_1.restore();
    }
  }
  y65(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.t3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.ux(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.u3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.w27(tmp, path.u3d_1.d1(_unary__edvuaz_1));
          var x = destruct.jl();
          var y = destruct.kl();
          this.p65_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.u3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.w27(tmp_0, path.u3d_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.jl();
          var y_0 = destruct_0.kl();
          this.p65_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.u3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.w27(tmp_1, path.u3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.u3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.w27(tmp_2, path.u3d_1.d1(_unary__edvuaz_7));
          var cx = destruct_1.jl();
          var cy = destruct_1.kl();
          var ax = destruct_2.jl();
          var ay = destruct_2.kl();
          this.p65_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.u3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.w27(tmp_3, path.u3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.u3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.w27(tmp_4, path.u3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.u3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.w27(tmp_5, path.u3d_1.d1(_unary__edvuaz_13));
          var cx1 = destruct_3.jl();
          var cy1 = destruct_3.kl();
          var cx2 = destruct_4.jl();
          var cy2 = destruct_4.kl();
          var ax_0 = destruct_5.jl();
          var ay_0 = destruct_5.kl();
          this.p65_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.p65_1.closePath();
          break;
      }
    }
  }
  x5z(state, fill, winding) {
    if (state.x4t_1.g1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.p65_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.w4t_1;
        if (!(clip == null)) {
          this.p65_1.beginPath();
          this.y65(clip);
          this.p65_1.clip(this.z65(winding == null ? clip.v3d_1 : winding));
        }
        this.p65_1.beginPath();
        this.y65(state.x4t_1);
        this.u65(this.p65_1, state.v4t_1);
        if (fill) {
          transformPaint(this, state.f4u_1);
          this.p65_1.fill(this.z65(winding == null ? state.x4t_1.v3d_1 : winding));
        } else {
          transformPaint(this, state.e4u_1);
          var lineDash = state.n4u_1;
          if (!(lineDash == null)) {
            this.p65_1.lineDashOffset = state.o4u_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.w2k();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.a1();
            while (_iterator__ex2g4s.b1()) {
              var v = _iterator__ex2g4s.c1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.sz(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.p65_1.setLineDash(tmp$ret$3);
          }
          this.p65_1.stroke();
        }
        break $l$block;
      }finally {
        this.p65_1.restore();
      }
    }
  }
  z65(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.r3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.y2t() <= 0.25;
}
function *_generator_readAtlas__e60am7(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  var tmp = _this__u8e3s4.c24(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var content = tmp;
  var tmp_0;
  if (startsWith(content, '{')) {
    tmp_0 = Companion_instance_6.l3x(content);
  } else if (startsWith(content, '<')) {
    tmp_0 = Companion_instance_6.k3x(content);
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(10))) {
    tmp_0 = Companion_instance_6.j3x(content);
  } else if (startsWith(content, '\r\n')) {
    tmp_0 = Companion_instance_6.j3x(content);
  } else {
    var tmp_1 = firstOrNull(content);
    var message = "Unexpected atlas starting with '" + toString_0(tmp_1 == null ? null : new Char(tmp_1)) + "'";
    throw IllegalStateException.z4(toString(message));
  }
  var info = tmp_0;
  var folder = _this__u8e3s4.x23();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = info.a3x_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.hc(capacity);
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.image.atlas.readAtlas.<anonymous>' call
    var tmp_2 = readBitmapSlice(folder.bi(element.k3w_1), VOID, VOID, props, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var pair = to(element.k3w_1, tmp_2);
    destination.i3(pair.hl_1, pair.il_1);
  }
  var textures = destination;
  return new Atlas(textures, info);
}
function readAtlas(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAtlas__e60am7.bind(VOID, _this__u8e3s4, props), $completion);
}
var Companion_instance_5;
function Companion_getInstance_15() {
  return Companion_instance_5;
}
function toRect(_this__u8e3s4, $this) {
  return RectangleInt.h2f(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
}
function toSize(_this__u8e3s4, $this) {
  return SizeInt.x2g(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
}
function createEntry($this, name, it) {
  var rotated = _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80(it, 'rotated'));
  var sourceSize = toSize(Dyn__get_impl_6l2p80(it, 'sourceSize'), $this);
  var spriteSourceSize = toRect(Dyn__get_impl_6l2p80(it, 'spriteSourceSize'), $this);
  var sW = sourceSize.v2g_1;
  var sH = sourceSize.w2g_1;
  var frame = toRect(Dyn__get_impl_6l2p80(it, 'frame'), $this);
  return new Region(name, !rotated ? frame : RectangleInt.h2f(frame.d2f_1, frame.e2f_1, frame.g2f_1, frame.f2f_1), RectangleInt.h2f(spriteSourceSize.d2f_1, spriteSourceSize.e2f_1, sW, sH), rotated ? Companion_getInstance_6().h3f_1 : Companion_getInstance_6().e3f_1);
}
function loadText$point(_this__u8e3s4) {
  var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(44)]), VOID, 2);
  // Inline function 'kotlin.text.trim' call
  var this_0 = first(list);
  var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp = toInt(tmp$ret$0);
  // Inline function 'kotlin.text.trim' call
  var this_1 = last(list);
  var tmp$ret$1 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  return Vector2D.j28(tmp, toInt(tmp$ret$1));
}
function loadText$size(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.atlas.Companion.loadText.size.<anonymous>' call
  var it = loadText$point(_this__u8e3s4);
  return SizeInt.x2g(numberToInt(it.m25_1), numberToInt(it.n25_1));
}
function loadText$keyValue(_this__u8e3s4) {
  var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(58)]), VOID, 2);
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.text.trim' call
  var this_0 = first(list);
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
  // Inline function 'kotlin.text.trim' call
  var this_1 = last(list);
  var tmp$ret$3 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  return to(tmp, tmp$ret$3);
}
function loadText$filter(_this__u8e3s4) {
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  switch (_this__u8e3s4.toLowerCase()) {
    case 'nearest':
      return false;
    case 'linear':
      return true;
    case 'mipmap':
      return true;
    case 'mipmapnearestnearest':
      return false;
    case 'mipmaplinearnearest':
      return false;
    case 'mipmapnearestlinear':
      return false;
    case 'mipmaplinearlinear':
      return false;
    default:
      return false;
  }
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.x3y_1);
  $this.p3y_1 = Companion_instance_1.i3e(width, height);
  $this.v3y_1 = Bitmap32.q3z(width, height, VOID, $this.r3y_1);
  $this.w3y_1.l3();
  $this.w3y_1.h($this.v3y_1);
  $this.y3y_1.l3();
  $this.x3y_1.l3();
  var _iterator__ex2g4s = slices.a1();
  while (_iterator__ex2g4s.b1()) {
    var entry = _iterator__ex2g4s.c1();
    $this.r3z(entry.n3y_1, entry.o3y_1, entry.n3y_1.s3f_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.t3y_1.r3_1) {
    case 0:
      reconstructWithSize($this, imul($this.z2i(), 2), imul($this.a2j(), 2));
      break;
    case 1:
      if (bmp.x3f_1 > $this.z2i() || bmp.y3f_1 > $this.a2j()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.z2i() + 'x' + $this.a2j() + ') to hold a slice of (' + bmp.x3f_1 + 'x' + bmp.y3f_1 + ')';
        throw IllegalStateException.z4(toString(message));
      }

      $this.p3y_1 = Companion_instance_1.i3e($this.z2i(), $this.a2j());
      $this.v3y_1 = Bitmap32.q3z($this.z2i(), $this.a2j(), VOID, $this.r3y_1);
      $this.w3y_1.h($this.v3y_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.x3z_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.u40(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.i40_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.b40_1;
  if (false) {
    this_0.k40();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.t47(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.l18();
    }
  }finally {
    result = false ? this_0.m40(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.d40_1 = true;
  _this__u8e3s4.e40_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.p40();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.c48_1.v2f();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.pl(new RGBA($this.c48_1.d48(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_7;
function Companion_getInstance_17() {
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.l49($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).n3z_1);
  var width = _this__u8e3s4.e26() - _this__u8e3s4.d26() | 0;
  var inductionVariable = _this__u8e3s4.f26();
  var last = _this__u8e3s4.g26();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.s40(_this__u8e3s4.d26(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.d26() + ', top=' + _this__u8e3s4.f26() + ', right=' + _this__u8e3s4.e26() + ', bottom=' + _this__u8e3s4.g26();
        throw IllegalStateException.z4(toString(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.f26(), area.d26(), area.g26(), area.e26(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.n3z_1;
  var x0Index = _this__u8e3s4.s40(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.s40(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.x3z_1 | 0;
      x1Index = x1Index + _this__u8e3s4.x3z_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.s40(x, areaTop), data, _this__u8e3s4.s40(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.s40(x, areaBottom - 1 | 0), data, _this__u8e3s4.s40(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_9;
function Companion_getInstance_19() {
  BitmapChannel_initEntries();
  if (Companion_instance_9 === VOID)
    new Companion_3();
  return Companion_instance_9;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_19();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.p3f_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.x3g();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.h2f(0, 0, _this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_6().e3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_1().y28_1 : padding;
  var left = clamp(bounds.d26(), 0, _this__u8e3s4.x3z_1);
  var top = clamp(bounds.f26(), 0, _this__u8e3s4.y3z_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_0.i2e(left, top, clamp(bounds.e26(), left, _this__u8e3s4.x3z_1), clamp(bounds.g26(), top, _this__u8e3s4.y3z_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.q3f_1) ? _this__u8e3s4.p3f_1.f2f_1 : _this__u8e3s4.p3f_1.g2f_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.q3f_1) ? _this__u8e3s4.p3f_1.g2f_1 : _this__u8e3s4.p3f_1.f2f_1;
  var tmp = get_container(_this__u8e3s4).s47(w + _this__u8e3s4.r3f_1.w28() | 0, h + _this__u8e3s4.r3f_1.x28() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).r47(_this__u8e3s4.q3f_1);
  raw.f47(0, 0, out, _this__u8e3s4.r3f_1.c29_1, _this__u8e3s4.r3f_1.z28_1, raw.x3z_1, raw.y3z_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_6().e3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_1().y28_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.h2f(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).s47(_this__u8e3s4.p3f_1.f2f_1, _this__u8e3s4.p3f_1.g2f_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).c47(_this__u8e3s4.p3f_1.d2f_1, _this__u8e3s4.p3f_1.e2f_1, out, 0, 0, _this__u8e3s4.p3f_1.f2f_1, _this__u8e3s4.p3f_1.g2f_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_17().f48(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().j41_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_17().f48(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().e41_1)), VOID, 'white');
  }
}
var Companion_instance_10;
function Companion_getInstance_20() {
  return Companion_instance_10;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.i47(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.v40(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.a4c(x + dx | 0, y + dy | 0) + d < this$0.a4c(x, y)) {
    this$0.w4b(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.x4b(x, y) | 0;
    var y_0 = y - this$0.y4b(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.z4b(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.c4c(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.s40(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.q3z(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().w4d(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().x4d(width, height, premultiplied);
}
var Companion_instance_11;
function Companion_getInstance_21() {
  if (Companion_instance_11 === VOID)
    Companion_5.m4e();
  return Companion_instance_11;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_17().g48(_this__u8e3s4.x3z_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.y3z_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.d40_1);
  out.x49(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.m4f();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.f4f_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.f4f_1);
  }
  if (!(effect.i4f_1 === 0) || !(effect.g4f_1 === 0) || !(effect.h4f_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.g4f_1, effect.h4f_1, effect.i4f_1, effect.j4f_1);
  }
  if (!(effect.k4f_1 === 0)) {
    borderInline(_this__u8e3s4, effect.k4f_1, effect.l4f_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.x3z_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.y3z_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.x4a(_this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1);
  var t2 = Bitmap8.x4a(_this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_19().d1(n);
      _this__u8e3s4.b4a(channel, t1);
      arraycopy_0(t1.j49(), 0, t2.j49(), 0, t2.v2f());
      gaussBlur(t1.j49(), t2.j49(), _this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1, r_0);
      _this__u8e3s4.a4a(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.x4a(_this__u8e3s4.x3z_1 + imul(r, 2) | 0, _this__u8e3s4.y3z_1 + imul(r, 2) | 0);
  Companion_instance_8.e4b(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.x3z_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.y3z_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.x4a(_this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1);
  arraycopy_0(_this__u8e3s4.j49(), 0, t2.j49(), 0, _this__u8e3s4.v2f());
  gaussBlur(t2.j49(), _this__u8e3s4.j49(), _this__u8e3s4.x3z_1, _this__u8e3s4.y3z_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().f41_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.y3z_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.x3z_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.a4c(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.m49(x, y, Companion_getInstance_26().n4f(rcolor, out.n49(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().f41_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.wx();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.c4a(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.d40_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.d49_1, n, Companion_getInstance_26().o4f(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.j40();
  _this__u8e3s4.v49(Colors_getInstance().j41_1);
  _this__u8e3s4.y49(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.y49(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.y4f()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.y4f());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_26().o4f(_this__u8e3s4.z4f(c), _this__u8e3s4.a4g(c), _this__u8e3s4.b4g(c), _this__u8e3s4.c4g(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.y4f() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var ColorAdd_NEUTRAL;
var Companion_instance_12;
function Companion_getInstance_22() {
  return Companion_instance_12;
}
function computeColorMul($this) {
  if (!$this.n4g_1)
    return Unit_instance;
  $this.n4g_1 = false;
  $this.p4g_1 = Companion_getInstance_26().s4c($this.f4g_1, $this.g4g_1, $this.h4g_1, $this.i4g_1);
}
function computeColorAdd($this) {
  if (!$this.o4g_1)
    return Unit_instance;
  $this.o4g_1 = false;
  var tmp = $this;
  // Inline function 'korlibs.image.color.Companion.invoke' call
  var r = $this.j4g_1;
  var g = $this.k4g_1;
  var b = $this.l4g_1;
  var a = $this.m4g_1;
  tmp.q4g_1 = _ColorAdd___init__impl__q78um5(ColorAdd_pack(r, g, b, a));
}
function _ColorAdd___init__impl__q78um5(value) {
  return value;
}
function _ColorAdd___get_value__impl__up0ct3($this) {
  return $this;
}
function _ColorAdd___get_r__impl__j9xkne($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 0 | 0) & 255);
}
function _ColorAdd___get_g__impl__itrhk1($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 8 | 0) & 255);
}
function _ColorAdd___get_b__impl__grv87a($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 16 | 0) & 255);
}
function _ColorAdd___get_a__impl__c1r8ux($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 24 | 0) & 255);
}
function _ColorAdd___get_rf__impl__4xdwim($this) {
  return _ColorAdd___get_r__impl__j9xkne($this) / 255;
}
function _ColorAdd___get_gf__impl__v9pxpl($this) {
  return _ColorAdd___get_g__impl__itrhk1($this) / 255;
}
function _ColorAdd___get_bf__impl__nvdxpq($this) {
  return _ColorAdd___get_b__impl__grv87a($this) / 255;
}
function _ColorAdd___get_af__impl__60q32p($this) {
  return _ColorAdd___get_a__impl__c1r8ux($this) / 255;
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function ColorAdd_unpackComponent(v) {
  _init_properties_ColorTransform_kt__w2ajah();
  return imul(v - 127 | 0, 2);
}
function ColorAdd_pack(r, g, b, a) {
  _init_properties_ColorTransform_kt__w2ajah();
  return ColorAdd_packComponent(r) << 0 | ColorAdd_packComponent(g) << 8 | ColorAdd_packComponent(b) << 16 | ColorAdd_packComponent(a) << 24;
}
function ColorAdd_packComponent(v) {
  _init_properties_ColorTransform_kt__w2ajah();
  return clamp(127 + (v >> 1) | 0, 0, 255);
}
var properties_initialized_ColorTransform_kt_ub7zbp;
function _init_properties_ColorTransform_kt__w2ajah() {
  if (!properties_initialized_ColorTransform_kt_ub7zbp) {
    properties_initialized_ColorTransform_kt_ub7zbp = true;
    ColorAdd_NEUTRAL = _ColorAdd___init__impl__q78um5(2139062143);
  }
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var MaterialColors_instance;
function MaterialColors_getInstance() {
  if (MaterialColors_instance === VOID)
    new MaterialColors();
  return MaterialColors_instance;
}
var Companion_instance_14;
function Companion_getInstance_24() {
  if (Companion_instance_14 === VOID)
    new Companion_8();
  return Companion_instance_14;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains_0(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.f4r_1, element instanceof RGBA ? element.t4h_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.t4h_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.f4r_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.f4r_1, element instanceof RGBA ? element.t4h_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.f4r_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.f4r_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_ad__impl__pt5rdj($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.yb(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.ub(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.yb(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.ub(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.t4h_1, other instanceof RGBA ? other.t4h_1 : THROW_CCE());
}
function RGBA__interpolateWith_impl_mw7p5y($this, ratio, other) {
  return Companion_getInstance_26().k4r($this, other, ratio);
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
function RGBA__times_impl_wehs9n($this, other) {
  return Companion_getInstance_26().l4r($this, other);
}
var Companion_instance_16;
function Companion_getInstance_26() {
  if (Companion_instance_16 === VOID)
    new Companion_10();
  return Companion_instance_16;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.t4h_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().j41_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_26();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.o4f(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_17;
function Companion_getInstance_27() {
  return Companion_instance_17;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_18;
function Companion_getInstance_28() {
  return Companion_instance_18;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.x4r_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_17.v4r(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_19;
function Companion_getInstance_29() {
  return Companion_instance_19;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.b4s_1).j40();
  };
}
var Companion_instance_20;
function Companion_getInstance_30() {
  return Companion_instance_20;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.a4v_1;
    var baseline = 0.0;
    var tmp = -this$0.f4v_1;
    var tmp_0 = -this$0.f4v_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.b4v_1.h3().a1();
    while (_iterator__ex2g4s.b1()) {
      var glyph = _iterator__ex2g4s.c1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.b4s_1.x3f_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.y4u_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.b4v_1.d1(this$0.b4v_1.g3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.k4v() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.y4u_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.c24(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.l8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.td('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull_0(xml.bi('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.w11('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull_0(xml.bi('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.w11('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull_0(xml.bi('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.w11('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull_0(xml.bi('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.y11('fieldType');
  var _iterator__ex2g4s = get(xml.bi('pages'), 'page').a1();
  while (_iterator__ex2g4s.b1()) {
    var page = _iterator__ex2g4s.c1();
    var id = page.u11('id');
    var file = page.s11('file');
    var texFile = fntFile.x23().bi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.i3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.bi('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.u11('page');
    var tmp0_elvis_lhs_0 = textures.f3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first_0(textures.h3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.u11('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.f3h(item.u11('x'), item.u11('y'), item.u11('width'), item.u11('height'));
      tmp_1 = atlas.n40(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.n3y_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.f3h(item.u11('x'), item.u11('y'), item.u11('width'), item.u11('height')) : tmp1_elvis_lhs_0, item.u11('xoffset'), item.u11('yoffset'), item.u11('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.bi('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.u11('first'), item_0.u11('second'), item_0.u11('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.a4s_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_19.y4r(item_2.h4s_1, item_2.i4s_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_9().hz(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.d1(n).q2x_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.x23().bi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.i3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.q2x_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.f3(page_0);
    var texture = tmp0_elvis_lhs == null ? first_0(textures.h3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.f3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.n40(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.n3y_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.f3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.q2x_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.a4s_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_19.y4r(item_2.h4s_1, item_2.i4s_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.h1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.h1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).a1();
  while (_iterator__ex2g4s.b1()) {
    var rline = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.text.trim' call
    var line = toString(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.gc();
    var _iterator__ex2g4s_0 = split(line, charArrayOf([_Char___init__impl__6a9atx(32)])).a1();
    while (_iterator__ex2g4s_0.b1()) {
      var part = _iterator__ex2g4s_0.c1();
      var _destruct__k2r9zo = plus_0(split(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf_0(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.d1(1);
      // Inline function 'kotlin.collections.set' call
      map.i3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.f3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.f3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.f3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.z4(toString(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.x23().bi(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice(mipmaps(tmp_0, mipmaps_0));
      textures.i3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.f3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.f3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.f3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.f3(page);
      var texture = tmp5_elvis_lhs == null ? first_0(textures.h3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.f3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.n40(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.n3y_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.f3h(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.f3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.f3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.f3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.hc(capacity);
  var tmp0_iterator = glyphs.a1();
  while (tmp0_iterator.b1()) {
    var element_1 = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.a4s_1;
    destination.i3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_19.y4r(it.h4s_1, it.i4s_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.m4s();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.u4s();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.t4s();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.k4v();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.w4x(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.kr_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.h4t(size);
  var gmetrics = _this__u8e3s4.p4t(size, codePoint, VOID, reader);
  var gx = -gmetrics.d26();
  var gy = gmetrics.a2j() + gmetrics.f26();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.z2i()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.a2j()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.q3z(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.b40_1;
  if (true) {
    image.k40();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.t47(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.l18();
    }
  }finally {
    result = true ? image.m40(rect) : 0;
  }
  var imageOut = applyEffect(image.u47(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.w27(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_3().g29_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf(glyph);
  var tmp_1 = listOf(listOf(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.n4y();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.w3d_1 = false;
    this_0.a3p(this$0.q4y_1.d26(), -this$0.r4y_1.z4s_1, this$0.q4y_1.n4t_1, this$0.r4y_1.o4s());
    return applyTransform(this_0, Companion_getInstance_3().j29().k2a(this$0.p4y_1).s2a(this$0.s4y_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.z4y());
    var tmp;
    if (!(curves.k39_1.e1() === 4)) {
      println('curves=' + curves.k39_1.e1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.a4z().k39_1.d1(3).g3d();
    var tmp$ret$0 = Line2D.f28(this_0.e28_1, this_0.d28_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.a4z().k39_1.d1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_0().o25_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_52().u4z_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.k50();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.i4z_1 = glyphs.l50_1;
    outMetrics.j4z_1 = glyphs.m50_1;
    var fmetrics = _this__u8e3s4.h4t(size);
    outMetrics.g4z_1 = fmetrics;
    var metrics = outMetrics.h4z_1;
    metrics.p50_1.r50(fmetrics);
    metrics.q50_1 = glyphs.m50_1.e1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.m50_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_4().m26();
      var _iterator__ex2g4s = item.a1();
      while (_iterator__ex2g4s.b1()) {
        var g = _iterator__ex2g4s.c1();
        bb = plus_3(bb, g.z4y());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.h(tmp$ret$0);
    }
    tmp_1.o50_1 = destination;
    metrics.n50_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_4().m26(), metrics.o50_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_52().q4z_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.w4s(size, out.p50_1);
  out.q50_1 = actions.h51();
  var bb = Companion_getInstance_4().m26();
  var dy = 0.0;
  var lineBounds = FastArrayList.sy();
  var offsetY = actions.l51(align.j51_1, out.p50_1);
  var _iterator__ex2g4s = actions.f51_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var offsetX = line.p51(align.i51_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.q51(), line.n51_1, line.m51_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.m51_1;
  }
  out.o50_1 = lineBounds;
  out.n50_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function getTextBoundsWithGlyphs(_this__u8e3s4, size, text, renderer, align) {
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_52().u4z_1 : align;
  var font = _this__u8e3s4;
  // Inline function 'kotlin.also' call
  var this_0 = new TextMetricsResult();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.getTextBoundsWithGlyphs.<anonymous>' call
  var tmp74_pos = Companion_getInstance_0().o25_1;
  drawText(font, null, size, text, null, tmp74_pos, false, renderer, align, this_0);
  return this_0;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.s4u($paint);
  font.v4u(_this__u8e3s4, $size, $codePoint, Vector2D.w27(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.t51();
  } else {
    _this__u8e3s4.s51();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.u51_1;
        var strokeInfo = stroke == null ? null : stroke.v51_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.w51(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.z37_1;
              var lineCap = strokeInfo.c38_1;
              var lineJoin = strokeInfo.e38_1;
              var miterLimit = strokeInfo.f38_1;
              var lineDash = strokeInfo.g38_1;
              var lineDashOffset = strokeInfo.h38_1;
              if (false) {
                tmp67_safe_receiver.k50();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.d52();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.e52(numberToDouble(lineWidth));
                tmp67_safe_receiver.f52(lineCap);
                tmp67_safe_receiver.g52(lineJoin);
                tmp67_safe_receiver.h52(numberToDouble(miterLimit));
                tmp67_safe_receiver.i52(lineDash);
                tmp67_safe_receiver.j52(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.k52(stroke_0);
              }finally {
                tmp67_safe_receiver.l52();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.x51();
            var lineCap_0 = tmp67_safe_receiver.y51();
            var lineJoin_0 = tmp67_safe_receiver.z51();
            var miterLimit_0 = tmp67_safe_receiver.a52();
            var lineDash_0 = tmp67_safe_receiver.b52();
            var lineDashOffset_0 = tmp67_safe_receiver.c52();
            if (false) {
              tmp67_safe_receiver.k50();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.d52();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.e52(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.f52(lineCap_0);
              tmp67_safe_receiver.g52(lineJoin_0);
              tmp67_safe_receiver.h52(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.i52(lineDash_0);
              tmp67_safe_receiver.j52(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.k52(stroke_0);
            }finally {
              tmp67_safe_receiver.l52();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.t51();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.s51();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.k50();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.z4y();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.a4z();
  }, null);
}
function caretStart$factory() {
  return getPropertyCallableRef('caretStart', 1, KProperty1, function (receiver) {
    return receiver.b4z();
  }, null);
}
function caretEnd$factory() {
  return getPropertyCallableRef('caretEnd', 1, KProperty1, function (receiver) {
    return receiver.c4z();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.y23(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77.bind(VOID, _this__u8e3s4, preload, props, mipmaps), $completion);
}
var SystemFontRegistryOrNull;
function get_lazyBitmap(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmap$delegate;
    var property = lazyBitmap$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_21;
function Companion_getInstance_31() {
  if (Companion_instance_21 === VOID)
    new Companion_15();
  return Companion_instance_21;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.z54_1.d1(this$0.z54_1.g3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.k4v() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.t54_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.w54_1.b4t_1 - this$0.w54_1.d4t_1;
    var tmp78_size = this$0.w54_1.x4s_1;
    var tmp79_top = this$0.w54_1.y4s_1;
    var tmp80_ascent = this$0.w54_1.z4s_1;
    var tmp81_baseline = this$0.w54_1.a4t_1;
    var tmp82_maxWidth = this$0.w54_1.e4t_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function get_lazyBitmap_0(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp;
  if (isInterface(_this__u8e3s4, VectorFont)) {
    tmp = get_lazyBitmap(_this__u8e3s4);
  } else {
    if (isInterface(_this__u8e3s4, BitmapFont)) {
      tmp = _this__u8e3s4;
    } else {
      throw NotImplementedError.td();
    }
  }
  return tmp;
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmap$factory() {
  return getPropertyCallableRef('lazyBitmap', 1, KProperty1, function (receiver) {
    return get_lazyBitmap(receiver);
  }, null);
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.t4s();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.k4v();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.u4s();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_22;
function Companion_getInstance_32() {
  Op_initEntries();
  if (Companion_instance_22 === VOID)
    new Companion_16();
  return Companion_instance_22;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_32();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_23;
function Companion_getInstance_33() {
  Op_initEntries_0();
  if (Companion_instance_23 === VOID)
    new Companion_17();
  return Companion_instance_23;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_33();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_24;
function Companion_getInstance_34() {
  if (Companion_instance_24 === VOID)
    new Companion_18();
  return Companion_instance_24;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.w5c_1;
  ss$factory();
  return this_0.u1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.v5c_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.g1q($table.t5c_1, $table.u5c_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_25;
function Companion_getInstance_35() {
  return Companion_instance_25;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_26;
function Companion_getInstance_36() {
  Colrv1Paint_initEntries();
  if (Companion_instance_26 === VOID)
    new Companion_20();
  return Companion_instance_26;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_36();
}
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_28;
function Companion_getInstance_38() {
  return Companion_instance_28;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.z23($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.w4x(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd.bind(VOID, _this__u8e3s4, onlyReadMetadata, enableLigatures), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_29;
function Companion_getInstance_39() {
  DataFormat_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_23();
  return Companion_instance_29;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_39();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.xv(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.z4(toString(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.x5k_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.b2u(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.v1r_1.l2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_39();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.d1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.x5k_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.a2u(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.v5k_1(nComponent);
          this_1.b2u(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.v5k_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.x5k_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.a2u(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.b2u(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_6().e3f_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_6().i3f_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_6().g3f_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_6().k3f_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_6().l3f_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_6().f3f_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_6().j3f_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_6().h3f_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_6().e3f_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.vt());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.vt());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.b5l_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.b5l_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_30;
function Companion_getInstance_40() {
  return Companion_instance_30;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.d5m()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.c5m().x3z_1, b.c5m().y3z_1), imul(b.c5m().z3z_1, b.c5m().z3z_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.d5m()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.c5m().x3z_1, a.c5m().y3z_1), imul(a.c5m().z3z_1, a.c5m().z3z_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_31;
function Companion_getInstance_41() {
  return Companion_instance_31;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.s5m_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.l5m_1;
      destination.i3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.v5m().f3(null);
    return tmp0_elvis_lhs == null ? first(this$0.s5m_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.v5m();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.w5m();
  }, null);
}
var tilesetBorder$delegate;
var Companion_instance_32;
function Companion_getInstance_42() {
  if (Companion_instance_32 === VOID)
    new Companion_26();
  return Companion_instance_32;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.p5n(tmp, props.n5n(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.m5n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.j5n();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.h1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.l5o();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.k5o();
  }, function (receiver, value) {
    return receiver.j5o(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.k5o();
  }, function (receiver, value) {
    return receiver.j5o(value);
  });
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_34;
function Companion_getInstance_44() {
  Type_initEntries();
  if (Companion_instance_34 === VOID)
    new Companion_28();
  return Companion_instance_34;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_44();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.n3f_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.n3f_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.n3f_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.n3f_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.j5n(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.u3z(result.u47(), Unit_instance, name).n3y_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  var prop = !(file == null) ? props.n5n(file) : props;
  var rformats = !prop.f5n_1 ? listOf(prop.g5n_1) : prop.g5n_1 == null ? listOf(null) : prop.e5n_1 ? listOf_0([prop.g5n_1, null]) : listOf_0([null, prop.g5n_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.a1();
  while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.b5o(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.c5o(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.td();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.b5n_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.a2u(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.b2u(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_42().g3x_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.j5n(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().qw('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.b5n_1 || props.a5n_1 === false) {
    return $this.b5p(get_RegisteredImageFormats().a5o(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.c5p(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.b5n_1 || props.a5n_1 === false) {
    return $this.b5p(get_RegisteredImageFormats().a5o(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.b5p($this.x5p(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.m23(path).a24($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.d5p(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.d5p(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.c5q_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.w5p(file.q21(), file.w21(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.c5q_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.a5q(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.m3v());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.q3z(_this__u8e3s4.h3v_1, _this__u8e3s4.i3v_1, _this__u8e3s4.j3v_1, _this__u8e3s4.k3v_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_35;
function Companion_getInstance_45() {
  Colorspace_initEntries();
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_45();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.bt();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.t5q_1;
  var height = header.u5q_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.a5r_1);
  var databb = uncompress(pngdata.gt(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.c5r_1.a5r_1;
  var row32 = context.f5r_1;
  var tmp_2;
  if (header.a5r_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_26().o4f(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.x4a(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.q3z(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.z5q_1 === 1 ? $this.l5r_1 : $this.m5r_1;
  var _iterator__ex2g4s = passes.a1();
  while (_iterator__ex2g4s.b1()) {
    var pass = _iterator__ex2g4s.c1();
    var progression = step(until(pass.m5q_1, height), pass.o5q_1);
    var inductionVariable_0 = progression.d2_1;
    var last_0 = progression.e2_1;
    var step_0 = progression.f2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.n5q_1;
        var colIncrement = pass.p5q_1;
        var pixelsInThisRow = width >>> pass.s5q_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.a5r_1), header.v5q_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.e5r_1;
        var lastRow = context.d5r_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.o5r(filter, lastRow, currentRow, header.a5r_1);
          switch (header.v5q_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.b41(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.b41(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.b41(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.m4b(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.v5q_1;
              throw IllegalStateException.z4(toString(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.v5q_1 === 8) {
            $this.n5r(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_24(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_26(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.td('An operation is not implemented: ' + reason);
            }
            bmp32.d4b(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.v5q_1;
            throw IllegalStateException.z4(toString(message_0));
          }
        }
        context.p5r();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_45().l5q_1.f3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.v5n_1 = this_0.t5q_1;
      $info.w5n_1 = this_0.u5q_1;
      $info.x5n_1 = imul(this_0.v5q_1, this_0.w5q_1.k5q_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().l2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.y13(asByteArray(rgbPalette), 0, data.a().l2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().l2();
      paletteCount._v = Math.max(a_0, b_0);
      data.y13(asByteArray(aPalette), 0, data.a().l2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.et(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.s5r();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.s5o([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_36;
function Companion_getInstance_46() {
  return Companion_instance_36;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.c5s_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.b5s_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.n5s_1 = value;
  $this.j5s_1 = $this.n5s_1.x3z_1;
  $this.k5s_1 = $this.n5s_1.y3z_1;
  $this.l5s_1 = 1.0 / $this.j5s_1;
  $this.m5s_1 = 1.0 / $this.k5s_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.v5r(_this__u8e3s4.t4h_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.d5s(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.r5s(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.td();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.e1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().g43_1 : _RGBA___init__impl__lqpay5(colors.nk());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.nk()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.ux(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.ux(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_26().k4r(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.p2k()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.d1(n) * NCOLORS);
}
var Companion_instance_37;
function Companion_getInstance_47() {
  return Companion_instance_37;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.t2k()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.t4h_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().f41_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function RichTextData$Line$defaultStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.n5t_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp261_safe_receiver = firstOrNull_1(destination);
    var tmp0_elvis_lhs = tmp261_safe_receiver == null ? null : tmp261_safe_receiver.y5t_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.o5t_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_48().a5u_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$defaultLastStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.n5t_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp262_safe_receiver = lastOrNull_0(destination);
    var tmp0_elvis_lhs = tmp262_safe_receiver == null ? null : tmp262_safe_receiver.y5t_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.o5t_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_48().a5u_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$text$delegate$lambda$lambda(it) {
  var tmp0_elvis_lhs = it.b5u();
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function RichTextData$Line$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.n5t_1, '', VOID, VOID, VOID, VOID, RichTextData$Line$text$delegate$lambda$lambda);
  };
}
function RichTextData$Line$width$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n5t_1.g1()) {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var tmp0_iterator = this$0.n5t_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        var tmp_0 = sum;
        // Inline function 'korlibs.image.text.Line.width$delegate.<anonymous>.<anonymous>' call
        sum = tmp_0 + element.z2i();
      }
      tmp = sum;
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
}
function RichTextData$Line$maxLineHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n5t_1.g1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.n5t_1.a1();
      if (!iterator.b1())
        throw NoSuchElementException.n6();
      // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.c1().o4s();
      while (iterator.b1()) {
        // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.c1().o4s();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.c5u())).o4s();
    }
    return tmp;
  };
}
function RichTextData$Line$maxHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n5t_1.g1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.n5t_1.a1();
      if (!iterator.b1())
        throw NoSuchElementException.n6();
      // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.c1().a2j();
      while (iterator.b1()) {
        // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.c1().a2j();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.c5u())).a2j();
    }
    return tmp;
  };
}
function RichTextData$Line$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.j1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Line.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.n5t_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var node = _iterator__ex2g4s.c1();
      if (node instanceof TextNode) {
        this_0.h(node.y5t_1.d5u_1);
      }
    }
    return this_0;
  };
}
var Companion_instance_38;
function Companion_getInstance_48() {
  if (Companion_instance_38 === VOID)
    new Companion_32();
  return Companion_instance_38;
}
function RichTextData$TextNode$bounds$delegate$lambda(this$0) {
  return function () {
    return getTextBounds(this$0.y5t_1.d5u_1, this$0.y5t_1.e5u_1, this$0.x5t_1);
  };
}
var Companion_instance_39;
function Companion_getInstance_49() {
  if (Companion_instance_39 === VOID)
    new Companion_33();
  return Companion_instance_39;
}
function wordWrap$addNode(currentLine, currentLineWidth, node) {
  var lastNode = lastOrNull_0(currentLine);
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!currentLine.g1()) {
    tmp_4 = node instanceof TextNode;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = lastNode instanceof TextNode;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = lastNode.r5u(node.x5t_1).equals(node);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = node.y5t_1.j5u_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = node.x5t_1;
    tmp_0 = !isBlank(this_0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = lastNode.x5t_1;
    tmp = !isBlank(this_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    removeLast(currentLine);
    currentLineWidth._v = currentLineWidth._v - lastNode.i5i().z2i();
    return wordWrap$addNode(currentLine, currentLineWidth, node.r5u(lastNode.x5t_1 + node.x5t_1));
  } else {
    currentLine.h(node);
    currentLineWidth._v = currentLineWidth._v + node.z2i();
  }
}
function wordWrap$finishLine(currentLine, outLines, currentLineWidth) {
  if (currentLine.g1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var element = Line.k5u(toList(currentLine));
  outLines.h(element);
  currentLine.l3();
  currentLineWidth._v = 0.0;
}
function RichTextData$text$delegate$lambda$lambda(it) {
  return it.b5u();
}
function RichTextData$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.z5u_1, '\n', VOID, VOID, VOID, VOID, RichTextData$text$delegate$lambda$lambda);
  };
}
function RichTextData$width$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = this$0.z5u_1.a1();
    if (!iterator.b1())
      throw NoSuchElementException.n6();
    // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
    var maxValue = iterator.c1().z2i();
    while (iterator.b1()) {
      // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
      var v = iterator.c1().z2i();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    return maxValue;
  };
}
function RichTextData$height$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this$0.z5u_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.RichTextData.height$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.n5u();
    }
    return sum;
  };
}
function RichTextData$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.j1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.RichTextData.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.z5u_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      this_0.f1(line.p5u());
    }
    return this_0;
  };
}
function width$factory() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.z2i();
  }, null);
}
function height$factory() {
  return getPropertyCallableRef('height', 1, KProperty1, function (receiver) {
    return receiver.a2j();
  }, null);
}
function allFonts$factory() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.p5u();
  }, null);
}
function defaultStyle$factory() {
  return getPropertyCallableRef('defaultStyle', 1, KProperty1, function (receiver) {
    return receiver.c5u();
  }, null);
}
function defaultLastStyle$factory() {
  return getPropertyCallableRef('defaultLastStyle', 1, KProperty1, function (receiver) {
    return receiver.m5u();
  }, null);
}
function text$factory() {
  return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
    return receiver.b5u();
  }, null);
}
function width$factory_0() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.z2i();
  }, null);
}
function maxLineHeight$factory() {
  return getPropertyCallableRef('maxLineHeight', 1, KProperty1, function (receiver) {
    return receiver.n5u();
  }, null);
}
function maxHeight$factory() {
  return getPropertyCallableRef('maxHeight', 1, KProperty1, function (receiver) {
    return receiver.o5u();
  }, null);
}
function allFonts$factory_0() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.p5u();
  }, null);
}
function bounds$factory() {
  return getPropertyCallableRef('bounds', 1, KProperty1, function (receiver) {
    return receiver.i5i();
  }, null);
}
function drawRichText(_this__u8e3s4, text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, textRangeStart, textRangeEnd) {
  bounds = bounds === VOID ? Companion_getInstance_2().e2e(0, 0, _this__u8e3s4.z2i(), _this__u8e3s4.a2j()) : bounds;
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_52().q4z_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  var result = place(text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways);
  var n = 0;
  var metrics = new TextMetricsResult();
  var _iterator__ex2g4s = result.s5v_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var place_0 = _iterator__ex2g4s.c1();
    var tmp275_text = place_0.t5v_1;
    var tmp276_pos = place_0.u5v_1;
    var tmp277_size = place_0.v5v_1;
    var tmp278_font = place_0.w5v_1;
    var tmp279_fillStyle = place_0.x5v_1;
    var tmp280_stroke = place_0.y5v_1;
    var tmp281_align = Companion_getInstance_52().u4z_1;
    var tmp282_textRangeStart = textRangeStart - n | 0;
    var tmp283_textRangeEnd = textRangeEnd - n | 0;
    var tmp284_renderer = get_DefaultStringTextRenderer();
    _this__u8e3s4.z5v(tmp275_text, tmp276_pos, VOID, VOID, tmp278_font, tmp277_size, tmp284_renderer, tmp281_align, metrics, tmp279_fillStyle, tmp280_stroke, tmp282_textRangeStart, tmp283_textRangeEnd);
    n = n + metrics.i4z_1.e1() | 0;
  }
  return n;
}
function place(_this__u8e3s4, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, out) {
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_52().q4z_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  out = out === VOID ? new RichTextDataPlacements() : out;
  var text = _this__u8e3s4;
  out.s5v_1.l3();
  if (text.z5u_1.g1())
    return out;
  var tmp272_maxLineWidth = wordWrap ? bounds.y25_1 : Infinity;
  var tmp273_maxHeight = bounds.z25_1;
  var rtext = text.p5v(tmp272_maxLineWidth, tmp273_maxHeight, includePartialLines, ellipsis, true, includeFirstLineAlways);
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!rtext.z5u_1.g1()) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = dropLast(rtext.z5u_1, 1).a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp_0 = sum;
      // Inline function 'korlibs.image.text.place.<anonymous>' call
      sum = tmp_0 + element.n5u();
    }
    tmp = sum + last(rtext.z5u_1).o5u();
  } else {
    tmp = 0.0;
  }
  var totalHeight = tmp;
  var y = {_v: bounds.x25_1 + (bounds.z25_1 - totalHeight) * _VerticalAlign___get_ratioFake0__impl__5adpb3(align.j51_1)};
  var _iterator__ex2g4s = rtext.z5u_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var x = {_v: bounds.w25_1 - HorizontalAlign__getOffsetX_impl_urzzxf(align.i51_1, line.z2i()) + HorizontalAlign__getOffsetX_impl_urzzxf(align.i51_1, bounds.y25_1)};
    var wordSpacing = equals(align.i51_1, Companion_getInstance_51().d5w_1) ? (bounds.y25_1 - line.z2i()) / (line.n5t_1.e1() - 1) : 0.0;
    y._v = y._v + line.o5u();
    var _iterator__ex2g4s_0 = line.n5t_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var node = _iterator__ex2g4s_0.c1();
      if (node instanceof TextNode) {
        if (node.y5t_1.g5u_1) {
          place$render(out, node, x, y, fill, stroke, 1.0, 0.0);
        }
        place$render(out, node, x, y, fill, stroke, 0.0, 0.0);
        x._v = x._v + node.z2i();
        x._v = x._v + wordSpacing;
      }
    }
    y._v = y._v + (line.n5u() - line.o5u());
  }
  return out;
}
function place$render($out, node, x, y, $fill, $stroke, dx, dy) {
  var tmp = Vector2D.w27(x._v + dx, y._v + dy);
  var tmp0_elvis_lhs = node.y5t_1.i5u_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
    tmp_0 = $fill;
  } else {
    var tmp_2 = tmp0_elvis_lhs;
    tmp_0 = tmp_2 == null ? null : new RGBA(tmp_2);
  }
  $out.s5v_1.h(new Placement(node.x5t_1, tmp, node.y5t_1.e5u_1, node.y5t_1.d5u_1, tmp_0, $stroke));
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_50().m5w_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function _VerticalAlign___get_ratioFake0__impl__5adpb3($this) {
  return equals($this, Companion_getInstance_50().m5w_1) ? 0.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_40;
function Companion_getInstance_50() {
  if (Companion_instance_40 === VOID)
    new Companion_34();
  return Companion_instance_40;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_50().m5w_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_50().m5w_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.y4s_1, font.y4s_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_50().j5w_1) ? 'TOP' : equals($this, Companion_getInstance_50().k5w_1) ? 'MIDDLE' : equals($this, Companion_getInstance_50().l5w_1) ? 'BOTTOM' : equals($this, Companion_getInstance_50().m5w_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.p5w_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_51().d5w_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_41;
function Companion_getInstance_51() {
  if (Companion_instance_41 === VOID)
    new Companion_35();
  return Companion_instance_41;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_51().d5w_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_51().e5w_1) ? 'LEFT' : equals($this, Companion_getInstance_51().f5w_1) ? 'CENTER' : equals($this, Companion_getInstance_51().g5w_1) ? 'RIGHT' : equals($this, Companion_getInstance_51().d5w_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.q5w_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_42;
function Companion_getInstance_52() {
  if (Companion_instance_42 === VOID)
    new Companion_36();
  return Companion_instance_42;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.xw().m25_1 + $this.w53().y29(x, y);
  var ry = $this.xw().n25_1 + $this.w53().b2a(x, y);
  $this.d51_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.d51_1, Vector2D.w27(rx, ry));
  if ($this.e51_1 === 0) {
    $this.c51_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.c51_1, Vector2D.w27(rx, ry));
  }
  var _receiver__tnumb7 = $this.g51_1;
  _receiver__tnumb7.o51_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.o51_1, Vector2D.w27(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.d26();
  var fy = rect.f26();
  var w = rect.y25_1;
  var h = rect.z25_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.t5w(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.i53(text, c);
  $this$CreateWStringTextRenderer.e54(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.i53(text, c);
  $this$CreateStringTextRenderer.e54(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.c5z_1.q5z_1.x27()) {
    this$0.c5z_1.o5z_1 = this$0.a5z_1 ? 4 : 1;
    this$0.g5z_1.m5y_1 = filler;
    this$0.g5z_1.v5y_1 = $state.l4u_1;
    this$0.g5z_1.t2q();
    var tmp = $winding == null ? fillPath.v3d_1 : $winding;
    this$0.c5z_1.w5z(this$0.b5z_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.g5z_1.qc();
    this$0.c5z_1.q5z_1.t2q();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.g5z_1.k5z(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.x4r_1, dstN, src.x4r_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_43;
function Companion_getInstance_53() {
  if (Companion_instance_43 === VOID)
    new Companion_37();
  return Companion_instance_43;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_44;
function Companion_getInstance_54() {
  return Companion_instance_44;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.x4r_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.x4r_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.x4r_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.x4r_1, dstN, dst.x4r_1, dstN, src.x4r_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.x4r_1, dstN, src.x4r_1, srcN, dst.x4r_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_53();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.j60(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_53().i60_1);
  var tmp_0 = Companion_getInstance_53();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.j60(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_53();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.j60(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_53().i60_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_53().i60_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_53().i60_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_53().i60_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_53().i60_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_53().i60_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_53().i60_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_53().i60_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_44.h3p();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.v4t_1.u2a();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.y47_1.v4t_1;
    if (this_0.b26()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.w27(this_0.y29(p.m25_1, p.n25_1), this_0.b2a(p.m25_1, p.n25_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.t3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.ux(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.u3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.w27(tmp, path.u3d_1.d1(_unary__edvuaz_1));
        _this__u8e3s4.q3d(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.u3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.w27(tmp_0, path.u3d_1.d1(_unary__edvuaz_3));
        _this__u8e3s4.d3e(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.u3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.w27(tmp_1, path.u3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.u3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.w27(tmp_2, path.u3d_1.d1(_unary__edvuaz_7));
        _this__u8e3s4.e3e(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.u3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.w27(tmp_3, path.u3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.u3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.w27(tmp_4, path.u3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.u3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.w27(tmp_5, path.u3d_1.d1(_unary__edvuaz_13));
        _this__u8e3s4.r3d(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.f6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_4().m26();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.x4t_1.h3a());
  var tmp = bb;
  var tmp333_safe_receiver = state.w4t_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.h3a());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).k2f(state.v4t_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.q3z(toIntCeil_0(bounds.y25_1), toIntCeil_0(bounds.z25_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.z5r(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_3().j29().m2a(-bounds.d26(), -bounds.f26()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.n60();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_45;
function Companion_getInstance_55() {
  CycleMethod_initEntries();
  if (Companion_instance_45 === VOID)
    new Companion_39();
  return Companion_instance_45;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_55();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.r3_1, 0), y.r3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_55().p61_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_55().p61_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.w27(_CycleMethodPair___get_x__impl__dgz5uj($this).q61(ratio.m25_1), _CycleMethodPair___get_y__impl__fcnb7o($this).q61(ratio.n25_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.q5k(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.q5k(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.x3z_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.y3z_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.s40(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.t4c(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.u4c(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.v4c(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.w4c(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.x4c(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.e4d(-1.0);
  msdf_0.g4d(-1.0, +1.0);
  msdf_0.d4d();
  var msdfBitmap = msdf_0.j40();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.w4f(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).j40(), VOID, 0);
  return newImage.p4f_1.u47();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.r4c(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.h28();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.k39_1, item.l39_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.h1();
  var tmp0_iterator_0 = colorizedCurves.a1();
  while (tmp0_iterator_0.b1()) {
    var element = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.r61_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.y3z_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.x3z_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.w27(x + 0.5, y + 0.5);
          var inside = path.t3p(p);
          var allDist = allColorizedCurves.z61().d62(p);
          var redDist = allColorizedCurves.e62().d62(p);
          var greenDist = allColorizedCurves.f62().d62(p);
          var blueDist = allColorizedCurves.g62().d62(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.x4c(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.r61_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.i62_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.r61_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.i62_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.r61_1;
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.i62_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.r61_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.h62_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.j62();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.h62_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.k62();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.h62_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.l62();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.h62_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.e1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().e41_1;
  if (index === 0)
    return Colors_getInstance().g43_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().u46_1 : Colors_getInstance().e42_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().e41_1);
    if (true) {
      $this$NativeImageContext2d.k50();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.l61(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.j62();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.k62();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.l62();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.z61();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.e62();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.f62();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.g62();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.h1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.t3d_1;
  var n_0 = 0;
  while (n_0 < this_1.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.ux(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.w27(tmp, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_1));
        var x = destruct.jl();
        var y = destruct.kl();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.w27(tmp_0, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_3));
        var x_0 = destruct_0.jl();
        var y_0 = destruct_0.kl();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.w27(tmp_1, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.w27(tmp_2, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_7));
        var cx = destruct_1.jl();
        var cy = destruct_1.kl();
        var ax = destruct_2.jl();
        var ay = destruct_2.kl();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.w27(tmp_3, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.w27(tmp_4, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.u3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.w27(tmp_5, _this__u8e3s4.u3d_1.d1(_unary__edvuaz_13));
        var cx1 = destruct_3.jl();
        var cy1 = destruct_3.kl();
        var cx2 = destruct_4.jl();
        var cy2 = destruct_4.kl();
        var ax_0 = destruct_5.jl();
        var ay_0 = destruct_5.kl();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.y7();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.o62_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.p62_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.b63(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.c63_1, this$0.g63_1), this$0.d63_1, this$0.e63_1, this$0.f63_1, this$0.h63_1);
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.w62();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.x62();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.z37_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.b38_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.c38_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.d38_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.e38_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.f38_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.g38_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.h38_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.t63();
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.n5z_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.z3o($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_46;
function Companion_getInstance_56() {
  if (Companion_instance_46 === VOID)
    new Companion_40();
  return Companion_instance_46;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.x64(HtmlImage_instance.d64(_this__u8e3s4.j40()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.b65(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.x64(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.c65(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.d65(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.m24(path);
      var tmp_1 = BrowserImage_instance.c65(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.d65(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.bi(path).z23($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.b65(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.x64(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.t64_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.t64_1;
      tmp = tmp_0.e65(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.t64_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.t64_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.f65().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_11().mu()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.z4(toString(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.p3v(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.k65(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.l65(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.tc(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.oa('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.tc(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.s3()) == $this.r65_1) {
    tmp = fontSize === $this.q65_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.r65_1 = font == null ? null : font.s3();
  $this.q65_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.s3();
  $this.p65_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.p65_1.globalAlpha = state.l4u_1;
  $this.p65_1.globalCompositeOperation = $this.s65(state.m4u_1);
  if (doSetFont) {
    setFont($this, state.h4u_1, state.i4u_1);
  }
  if (fill) {
    $this.p65_1.fillStyle = $this.t65(state.f4u_1);
  } else {
    $this.p65_1.lineWidth = state.z4t_1;
    var tmp;
    switch (state.c4u_1.r3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.p65_1.lineJoin = tmp;
    var tmp_0;
    switch (state.y51().r3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.p65_1.lineCap = tmp_0;
    $this.p65_1.strokeStyle = $this.t65(state.e4u_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.u65($this.p65_1, paint.w53());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.f65();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.h65();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_11().nu() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_11().mu() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(Entry, 'Entry');
initMetadataForInterface(AtlasLookup, 'AtlasLookup');
protoOf(Atlas).f3x = tryGet;
protoOf(Atlas).bi = get_0;
initMetadataForClass(Atlas, 'Atlas', VOID, VOID, [AtlasLookup]);
initMetadataForCompanion(Companion);
initMetadataForClass(Meta, 'Meta', Meta);
initMetadataForClass(FrameTag, 'FrameTag', FrameTag);
initMetadataForClass(Layer, 'Layer', Layer);
initMetadataForClass(Slice, 'Slice');
initMetadataForClass(Key, 'Key');
initMetadataForClass(Page, 'Page');
initMetadataForClass(Region, 'Region');
initMetadataForCompanion(Companion_0);
initMetadataForClass(AtlasInfo, 'AtlasInfo', AtlasInfo.d3x);
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry_0, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.t3z);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_3);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_4);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_5);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForCompanion(Companion_6);
initMetadataForClass(ColorTransform, 'ColorTransform');
initMetadataForCompanion(Companion_7);
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForObject(MaterialColors, 'MaterialColors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_11);
initMetadataForCompanion(Companion_12);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_13);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).s4s = get_baseBmp;
protoOf(BitmapFontImpl).w4s = getFontMetrics;
protoOf(BitmapFontImpl).h4t = getFontMetrics$default;
protoOf(BitmapFontImpl).i4t = getGlyphMetrics;
protoOf(BitmapFontImpl).p4t = getGlyphMetrics$default;
protoOf(BitmapFontImpl).w4u = getKerning;
protoOf(BitmapFontImpl).r4t = getTextScale;
protoOf(BitmapFontImpl).d1 = get_1;
protoOf(BitmapFontImpl).s4t = get_2;
protoOf(BitmapFontImpl).t4t = getGlyph;
protoOf(BitmapFontImpl).u4t = renderGlyph;
protoOf(BitmapFontImpl).v4u = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).t2q = reset;
protoOf(TextRendererActions).e54 = advance;
protoOf(TextRendererActions).f54 = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_15);
protoOf(LazyBitmapFont).s4s = get_baseBmp;
protoOf(LazyBitmapFont).w4s = getFontMetrics;
protoOf(LazyBitmapFont).h4t = getFontMetrics$default;
protoOf(LazyBitmapFont).i4t = getGlyphMetrics;
protoOf(LazyBitmapFont).p4t = getGlyphMetrics$default;
protoOf(LazyBitmapFont).w4u = getKerning;
protoOf(LazyBitmapFont).r4t = getTextScale;
protoOf(LazyBitmapFont).dz = getOrNull_2;
protoOf(LazyBitmapFont).d1 = get_1;
protoOf(LazyBitmapFont).s4t = get_2;
protoOf(LazyBitmapFont).t4t = getGlyph;
protoOf(LazyBitmapFont).u4t = renderGlyph;
protoOf(LazyBitmapFont).v4u = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.x56, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_17);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_18, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).h4t = getFontMetrics$default;
protoOf(BaseTtfFont).p4t = getGlyphMetrics$default;
protoOf(BaseTtfFont).t5a = getGlyphPath$default;
protoOf(BaseTtfFont).u4t = renderGlyph_0;
protoOf(BaseTtfFont).v4u = renderGlyph$default;
protoOf(BaseTtfFont).dz = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_19);
initMetadataForCompanion(Companion_20);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_21);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).z5h = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).z5h = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).c3p = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_22);
initMetadataForCompanion(Companion_23);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_24);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_25);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_26);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.r5o, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_27);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_28);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_29);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_30);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_31);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_32);
initMetadataForClass(Line, 'Line');
initMetadataForInterface(Node, 'Node');
initMetadataForClass(Style, 'Style');
initMetadataForClass(TextNode, 'TextNode', VOID, VOID, [Node]);
initMetadataForCompanion(Companion_33);
initMetadataForClass(RichTextData, 'RichTextData', VOID, VOID, [KtList]);
initMetadataForClass(Placement, 'Placement');
initMetadataForClass(RichTextDataPlacements, 'RichTextDataPlacements', RichTextDataPlacements, VOID, [KtList]);
initMetadataForCompanion(Companion_34);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_35);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_36);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_1, 'Entry', Entry_1);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_37);
initMetadataForCompanion(Companion_38);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).x3o = line;
protoOf(Context2d).g1 = isEmpty;
protoOf(Context2d).y3o = rect;
protoOf(Context2d).z3o = rect_0;
protoOf(Context2d).a3p = rect_1;
protoOf(Context2d).b3p = arc;
protoOf(Context2d).c3p = arc$default;
protoOf(Context2d).d3p = circle;
protoOf(Context2d).e3p = rMoveTo;
protoOf(Context2d).f3p = rLineTo;
protoOf(Context2d).k2f = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_39);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).n62 = getBounds;
protoOf(FillShape).m62 = getPath_0;
protoOf(FillShape).h55 = getPath$default;
protoOf(FillShape).o54 = draw;
protoOf(FillShape).i5i = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).h55 = getPath$default;
protoOf(CompoundShape).i5i = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).m62 = getPath_0;
protoOf(PolylineShape).h55 = getPath$default;
protoOf(PolylineShape).o54 = draw;
protoOf(PolylineShape).i5i = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).m62 = getPath;
protoOf(EmptyShape).h55 = getPath$default;
protoOf(EmptyShape).i5i = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_40);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_5 = new Companion();
Companion_instance_6 = new Companion_0();
Companion_instance_8 = new Companion_2();
Bitmaps_instance = new Bitmaps();
Companion_instance_10 = new Companion_4();
NewSDF_instance = new NewSDF();
Companion_instance_12 = new Companion_6();
Companion_instance_13 = new Companion_7();
Companion_instance_15 = new Companion_9();
Companion_instance_17 = new Companion_11();
Companion_instance_18 = new Companion_12();
Companion_instance_19 = new Companion_13();
Companion_instance_20 = new Companion_14();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_25 = new Companion_19();
Companion_instance_27 = new Companion_21();
Companion_instance_28 = new Companion_22();
Companion_instance_30 = new Companion_24();
Companion_instance_31 = new Companion_25();
Companion_instance_33 = new Companion_27();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_36 = new Companion_30();
Companion_instance_37 = new Companion_31();
NonePaint_instance = new NonePaint();
Companion_instance_44 = new Companion_38();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  readAtlas as readAtlas3i3fpdxd2wy0v,
  readFont as readFont34z4s2654u5hd,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  _ColorAdd___init__impl__q78um5 as _ColorAdd___init__impl__q78um52f1128lcwf1fa,
  _ColorAdd___get_a__impl__c1r8ux as _ColorAdd___get_a__impl__c1r8ux255rv89tur9tr,
  _ColorAdd___get_af__impl__60q32p as _ColorAdd___get_af__impl__60q32p2fncy9agnk301,
  _ColorAdd___get_b__impl__grv87a as _ColorAdd___get_b__impl__grv87a2vw0avtnx85s8,
  _ColorAdd___get_bf__impl__nvdxpq as _ColorAdd___get_bf__impl__nvdxpq26lfvmiy6mias,
  _ColorAdd___get_g__impl__itrhk1 as _ColorAdd___get_g__impl__itrhk12096raxfex02b,
  _ColorAdd___get_gf__impl__v9pxpl as _ColorAdd___get_gf__impl__v9pxpl3b35saap1pnga,
  _ColorAdd___get_r__impl__j9xkne as _ColorAdd___get_r__impl__j9xkne1kbrts3qrn6g1,
  _ColorAdd___get_rf__impl__4xdwim as _ColorAdd___get_rf__impl__4xdwim38adda9jzln7f,
  _RGBA___get_ad__impl__pt5rdj as _RGBA___get_ad__impl__pt5rdj2rhup0gteq97n,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  RGBA__interpolateWith_impl_mw7p5y as RGBA__interpolateWith_impl_mw7p5y1g8prnof19q7i,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5,
  _RGBA___get_premultipliedFast__impl__qiau4g as _RGBA___get_premultipliedFast__impl__qiau4g35hwdu9bo5950,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__times_impl_wehs9n as RGBA__times_impl_wehs9n2bi9iz06j1oam,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  RGBA__withAf_impl_dpdu32 as RGBA__withAf_impl_dpdu32g4ua5xko755s,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Companion_instance_13 as Companion_instancepqnabj9nutrw,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  MaterialColors_getInstance as MaterialColors_getInstance39ky4hjexuaug,
  Companion_getInstance_26 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_20 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_19 as Companion_instance1sgltfeqg9bxt,
  PNG_getInstance as PNG_getInstance30449hvvlhbbs,
  Companion_getInstance_52 as Companion_getInstancezw1wxvwtmh0g,
  Companion_getInstance_50 as Companion_getInstance2w9pdpq8h2ue0,
  EmptyShape_instance as EmptyShape_instance1905h5dvjxi3r,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage_0 as NativeImage33w1i7ec8zfym,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorAdd_pack as ColorAdd_pack3r2zgiosu4kvu,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  ColorTransform as ColorTransform3dmo0aeuiflxt,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBoundsWithGlyphs as getTextBoundsWithGlyphsa2ggkffutq4d,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  get_lazyBitmap_0 as get_lazyBitmap3pyj425xl7cp4,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  RichTextData as RichTextData1m4oei1jdcuz5,
  Entry_1 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  drawRichText as drawRichTextyqpa5ren8u0j,
  invoke as invoke2ot88cm6qcfmr,
  place as placem8wpiy4fm4tw,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
